var annotations =
webpackJsonp_name_([3],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(71);


/***/ }),

/***/ 11:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rfDraw = rfDraw;
exports.rfRotate = rfRotate;

var _uScope = __webpack_require__(78);

var _uScope2 = _interopRequireDefault(_uScope);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _helpers = __webpack_require__(4);

var _objects = __webpack_require__(16);

var _region = __webpack_require__(295);

var _region2 = _interopRequireDefault(_region);

var _toolbar = __webpack_require__(27);

var _annotationsService = __webpack_require__(293);

var _annotationsService2 = _interopRequireDefault(_annotationsService);

var _arrow = __webpack_require__(368);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//________________________________________________________________________________________________
// annotdraw.js
//    This file contains functions performing annotations drawing and rapahel SVG graphics calls.
//        All are prototypes of AnnotationsService.
//
//    references:
//        raphael.js is used to draw the vector graphics: http://raphaeljs.com
//        Scalable Vector Graphics: http://www.w3.org/TR/SVG/    http://www.w3.org/TR/SVG/Overview.html
//        SVG attribute index: http://www.w3.org/TR/SVG/attindex.html
//        Future options: http://www.graphdracula.net/
//
//    history
//    1109    cperz        created
//    _______________________________________end_AIHv1 __________________________________________
//    141118    cperz        add support for polygon
//    141120    cperz        add support for negative pen; simplified rfDraw attr; improved arrow head;
//    141222    cperz        support changes made for analysis; fix on image text font to be more readable;
//                        startNew: remove adding click handler to caliper - performed elsewhere now
//    150318    cperz        add support for analysis; add initializeRegion();
//                        refactor to utilize region's new fns; refactor use of var 'openShape';
//                        be like ImageScope and don't close the pen annot;
//________________________________________________________________________________________________

var CANNOT_DRAW = _annotationsService2.default.prototype;
var CANNOT_REGION = _annotationsService2.default.prototype;

//............................................ startNew
//    AnnotationsService.startNew - This function begins the drawing of a new annotation object.
//
//    parameters:
//        anType - us.eAnTypes type, annotation type to be created
//        crsrPos    - Point type, cursor position in base image coords
//        viewZoom - numeric type, zoom of current view
//        optText - optional, content for text annotation
//
CANNOT_DRAW.startNew = function (anType, crsrPos, viewZoom, viewAngleDeg, optText) {
    var self = this;

    var myLayerId = self.chooseLayer(anType); // get the annotation layer this region will belong to
    if (myLayerId < 0 || myLayerId == undefined) {
        // we cannot send an addRegion request to dataserver without an assigned layer id
        // ('annotdraw::startNew() - Layer not yet created or drawing is on an output layer w/o an input layer - Prohibiting region creation'); // eslint-disable-line no-undef
        return;
    }

    var isReportRegion = anType === _defines2.default.eAnTypes.report;
    this.newRegion = initializeRegion.call(this); // create a new region object
    var newRegion = this.newRegion; // and a handy ref

    var MINANNOTDIM = _defines2.default.annotSpecs.minAnnotDim;
    switch (newRegion.shape) {
        case 'pen':
        case 'negpen':
            newRegion.addPt(crsrPos);
            rfDraw(this.paper, newRegion);
            break;
        case 'caliper':
        case 'polygon':
            newRegion.addPt(crsrPos);
            newRegion.data.lengthPixels = 0;
            newRegion.data.lengthMicrons = 0;
            rfDraw(this.paper, newRegion);
            newRegion.addPt(crsrPos); // add the same pt again so update has one to remove
            break;
        case 'report':
            // only fixed resolution report regions filter through here
            newRegion.addPt(crsrPos);
            rfDraw(this.paper, newRegion);

            if (isReportFixedDim(newRegion.reportType)) // fixed dimension report regions require only a single point
                this.finishNew();
            break;
        case 'rect':
            newRegion.addPt(crsrPos); // top left
            var x1 = crsrPos.x + MINANNOTDIM;
            var y1 = crsrPos.y + MINANNOTDIM;

            var pt = new _objects.Point(x1, crsrPos.y);
            newRegion.addPt(pt); // top right
            pt = new _objects.Point(x1, y1);
            newRegion.addPt(pt); // bottom right
            pt = new _objects.Point(crsrPos.x, y1);
            newRegion.addPt(pt); // bottom left

            if (isReportRegion == false && newRegion.angleDeg != 0) {
                // rect is squared with the view frame so unrotate it
                var ptList = newRegion.getPts();
                var cpOrigin = new _objects.Point(ptList[0].x, ptList[0].y);
                newRegion.rotatePtsAbout(-newRegion.angleDeg, cpOrigin, 0);
            }
            rfDraw(this.paper, newRegion, viewZoom, newRegion.angleDeg);
            break;
        case 'arrow':
        case 'ellipse':
            newRegion.addPt(crsrPos); // top right
            var pt = new _objects.Point(crsrPos.x + MINANNOTDIM, crsrPos.y + MINANNOTDIM);
            newRegion.addPt(pt); // bottom left
            rfDraw(this.paper, newRegion);
            break;
        case 'ruler':
            // the ruler is never created by uScope; only by ImageScope or WebScope - nothing to do
            return;
            break;
        case 'pin':
            newRegion.addPt(crsrPos);
            rfDraw(this.paper, newRegion, viewZoom, viewAngleDeg);
            this.finishNew();
            break;
        case 'text':
            if ((0, _helpers.isUnDefined)(optText)) {
                // sanity check that there is text to write
                this.drawingCompleted(); // if not, Signal The End of Drawing
                return; // and return
            }
            newRegion.note = optText; // add the text to the region's data
            newRegion.addPt(crsrPos);
            rfDraw(this.paper, newRegion);
            this.finishNew();
            break;
        default:
            break;
    }

    return;

    //..................................................
    // closure functions
    //............................................ initializeRegion
    function initializeRegion() {
        var regionId = self.regions.getNextRegionId(); // will return a negative value that is a signal to dataserver of a new region
        var layer = self.layers.getLayerById(myLayerId);

        var newRegion = new _region2.default({
            layerId: myLayerId,
            regionId: regionId,
            displayId: -regionId, // display id is positive value of new region id
            decBGR: layer.get('LineColor'), // region color is the layer color
            type: anType,
            angleDeg: viewAngleDeg,
            zoom: viewZoom,
            isReportRegion: isReportRegion
        }, 'json', self.getMyImage(), undefined, // not "layer"?
        self);

        // openShape is a flag for rfDraw, when true shape is not closed; override default setting at draw start - don't close these shapes during draw
        newRegion.set('openShape', anType === _defines2.default.eAnTypes.pen || anType === _defines2.default.eAnTypes.negpen || anType === _defines2.default.eAnTypes.caliper || anType === _defines2.default.eAnTypes.polygon);

        // Note: There are 4 report region styles. The fixed size report regions are handled as report regions
        //            and the user drawn report regions are switched to rects for drawing.
        if (isReportRegion) {
            newRegion.reportType = _uScope2.default.instance.prefGet('reportRegionType'); // save report region type here for convenience
            newRegion.note = 'Report Image'; // report region on-image text

            if (!isReportFixedDim(newRegion.reportType)) {
                newRegion.setType(_defines2.default.eAnTypes.rect); // if user drawn report then switch to a rect draw
            }
            if (isReportFullRes(newRegion.reportType)) {
                newRegion.viewZoom = viewZoom; // save special data to draw at this zoom
                newRegion.zoom = this.getMyImage().getNormalizationFactor(); // report region overrides viewZoom  when full resolution preference is set
            }
        }
        return newRegion;
    }

    //..................................................
};

//............................................ updateNew
//    AnnotationsService.updateNew - This function updates with a new cursor position the drawing of a new annotation process.
//        The caliper needs the mouse event.
//
CANNOT_DRAW.updateNew = function (crsrPos, mouseAction) {
    if (this.drawingIsStarted() == false) return; // if called before startNew, return
    var self = this;

    var newRegion = this.newRegion;
    switch (newRegion.shape) {
        case 'pen':
        case 'negpen':
            if (newRegion.getPtsLen() < 1) return; // sanity
            var lastPt = newRegion.getPt(newRegion.getPtsLen() - 1);
            var dist = lastPt.cityBlockDistance(crsrPos);
            if (dist > _defines2.default.annotSpecs.minPenPointDist) {
                // don't add points that are too close together
                newRegion.addPt(crsrPos);
                rfDraw(this.paper, newRegion);
            }
            break;
        case 'caliper':
        case 'polygon':
            if (newRegion.getPtsLen() < 1) return; // sanity
            if (mouseAction === 'mousemove') {
                // mouse move updates only if move is sufficiently different
                var lastPt = newRegion.getPt(newRegion.getPtsLen() - 1); // otherwise the control is sticky, unresponsive
                var dist = lastPt.cityBlockDistance(crsrPos);
                if (dist <= _defines2.default.annotSpecs.minPenPointDist) return;
            }
            newRegion.setPt(crsrPos, newRegion.getPtsLen() - 1); // overwrite prevous point
            newRegion.computeLength();
            rfDraw(this.paper, newRegion); // draw the region

            if (mouseAction === 'mousedown') // mousedown duplicates the end point in anticipation of the next call's overwrite
                newRegion.addPt(crsrPos);
            break;
        case 'rect':
            if (newRegion.getPtsLen() < 4) return; // sanity
            var ptList = newRegion.getPts();

            if (newRegion.angleDeg != 0) {
                // if the view is rotated, rotate the cursor (indicating rect RB coord) about the LT of the rect
                var cpOrigin = new _objects.Point(ptList[0].x, ptList[0].y);
                crsrPos.rotateAbout(newRegion.angleDeg, cpOrigin);
                crsrPos.toInt();
            }

            ptList[2] = crsrPos; // define the 4 corners of the rect
            ptList[1].x = ptList[2].x;
            ptList[1].y = ptList[0].y;
            ptList[3].x = ptList[0].x;
            ptList[3].y = ptList[2].y;
            enforceDims_(); // force a minimim dimension

            if (newRegion.isReportRegion == false && newRegion.angleDeg != 0) {
                // rect is squared with the view frame so unrotate it
                var cpOrigin = new _objects.Point(ptList[0].x, ptList[0].y);
                newRegion.rotatePtsAbout(-newRegion.angleDeg, cpOrigin, 0);
            }
            rfDraw(this.paper, newRegion);
            break;
        case 'arrow':
        case 'ellipse':
            if (newRegion.getPtsLen() < 2) return; // sanity
            var ptList = newRegion.getPts();
            ptList[1] = crsrPos;
            enforceDims_(); // force a minimim dimension
            rfDraw(this.paper, newRegion);
            break;
        case 'report':
            if (isReportFixedDim()) {
                newRegion.setPt(crsrPos, 0); // overwrite prevous left-top point
            } else {
                    // act like a rectangle at this
                }
            rfDraw(this.paper, newRegion);
            break;
        case 'ruler': // note: rulers are not created in this viewer - the caliper replaces it.
        case 'pin':
            // no updates are necessary for these annotation types
            return;
            break;
        default:
            break;
    }

    //..................................................
    // closure functions
    //............................................ enforceDims_
    //    This function insures that the user did not shrink the new region shape beyond the minimum dimensions
    function enforceDims_() {
        var ptList = newRegion.getPts();
        var MINANNOTDIM = _defines2.default.annotSpecs.minAnnotDim;
        switch (newRegion.shape) {
            case 'rect':
                if (ptList[2].x < ptList[0].x + MINANNOTDIM) ptList[2].x = ptList[0].x + MINANNOTDIM; // bottom right
                if (ptList[2].y < ptList[0].y + MINANNOTDIM) ptList[2].y = ptList[0].y + MINANNOTDIM;
                ptList[1].x = ptList[2].x;
                ptList[1].y = ptList[0].y; // top right
                ptList[3].x = ptList[0].x;
                ptList[3].y = ptList[2].y; // bottom left
                break;
            case 'ellipse':
                // if somehow the dimension is < minimum allowed, fix it
                if (ptList[1].x < ptList[0].x + MINANNOTDIM) ptList[1].x = ptList[0].x + MINANNOTDIM; // bottom right
                if (ptList[1].y < ptList[0].y + MINANNOTDIM) ptList[1].y = ptList[0].y + MINANNOTDIM;
                break;
            default:
                break;
        }
    }

    //..................................................
};

//............................................ finishNew
//    AnnotationsService.finishNew - This function completes the drawing of a new annotation object.
//                Some annotations are checked if they are of reasonable size and removed rather
//                than keep a silly user mistake.
//    returns: true if annotation was saved; false otherwise
CANNOT_DRAW.finishNew = function () {
    if (this.drawingIsStarted() == false) {
        // if called before startNew, return
        // ('AnnotationsService.finishNew: called but drawing is not started!'); // eslint-disable-line no-undef
        return false;
    }
    var newRegion = this.newRegion;
    var bDisqualified = false;
    switch (newRegion.shape) {
        case 'pen':
        case 'negpen':
            if (newRegion.getPtsLen() < 3) {
                // don't save freeforms with less than 3 points
                bDisqualified = true;
                // ('Not saving freeform annotation: too few points'); // eslint-disable-line no-undef
            } else {
                rfDraw(this.paper, newRegion); // so perform the draw to complete the outline
            }
            break;
        case 'caliper':
        case 'polygon':
            newRegion.removeDuplicatePtsAtEnd();

            if (newRegion.getPtsLen() < 2) {
                // don't save caliper with less than 2 points
                // ('Not saving caliper/polygon annotation: only 1 point'); // eslint-disable-line no-undef
                bDisqualified = true;
            } else if (newRegion.getPtsLen() < 3 && newRegion.shape == 'polygon') {
                // ('Not saving polygon annotation: only 2 points'); // eslint-disable-line no-undef
                bDisqualified = true;
            } else {
                newRegion.computeLength();
                if (newRegion.data.lengthMicrons < 3) {
                    // don't save caliper with very small measurement
                    // ('Not saving caliper/polygon annotation: too small'); // eslint-disable-line no-undef
                    bDisqualified = true;
                }
                if (bDisqualified == false && newRegion.shape == 'polygon') {
                    newRegion.setLastPtToFirstPt(); // since when I read a polygon back it is a pen shape, close the shape by setting the last point to the first
                    rfDraw(this.paper, newRegion); // perform the draw to display the closed polygon shape
                }
            }
            break;
        case 'report':
        case 'rect':
            if (newRegion.isReportRegion) {
                newRegion.setType(_defines2.default.eAnTypes.rect); // report region is always a rectangle, switch types now
                rfDraw(this.paper, newRegion, newRegion.viewZoom); // redraw to show the report's associated text
                newRegion.viewZoom = undefined; // remove special data
            }
            break;
    }

    if (bDisqualified == false) {
        // if a region is qualified
        this.regAdd(newRegion, true, true); // add the new region to the collection and save back to the db
    } else {
        // otherwise ...
        newRegion.removeGraphics();
    }

    this.drawingCompleted(); // finishNew: return to not-drawing state
    return bDisqualified;
};

CANNOT_DRAW.createTextAt = function (annotationsService, location) {
    (0, _toolbar.openTextEditPanel)('Add on image text', '', annotationsService.onAddImageText, location);
};

//............................................ regReDraw
// regReDraw - This function modifies the outline of a freeform annotation.
//                It returns false if drawing is complete or cannot start.
CANNOT_REGION.regReDraw = function (phase, crsrPos, opt_viewZoom) {
    var closestIdx;
    var thinTolerance_ = _defines2.default.reDrawSpecs.thinTolerance; // initialize tolerances
    var startTolerance_ = _defines2.default.reDrawSpecs.startTolerance * (opt_viewZoom != undefined ? opt_viewZoom : 1);
    var skipTolerance_ = _defines2.default.reDrawSpecs.skipTolerance * (opt_viewZoom != undefined ? opt_viewZoom : 1);
    var removeTolerance_ = _defines2.default.reDrawSpecs.removeTolerance * (opt_viewZoom != undefined ? opt_viewZoom : 1);

    var region = this.getSelRegion(); // reference the redraw region

    if (phase == 'start') {
        //........ start region redraw mode: mouse down in redraw mode
        if (region.shape != 'pen') {
            // redraw is only valid for pen regions
            this.drawingCompleted(); // redraw: false start
            return false;
        }

        this.reDrawIdx = 0; // the current position in the points array
        this.reDrawCnt = 0;
        this.reDrawPrevPt = undefined; // signal no points changed yet
        region.priorPts = region.copyPts(); // save original point list so it can be restored

        region.thinOutPts(thinTolerance_); // thin point list of this region in preparation for redraw
        var _ptList = region.getPts(); // update reference to region points

        var closest = findClosestPt(crsrPos, _ptList, startTolerance_);
        closestIdx = closest.idx;
        if (closestIdx != -1) {
            var newPtList = createNewList(_ptList, crsrPos, closestIdx);
            region.replacePts(newPtList);

            this.paintSelRegion(_defines2.default.DONT_HIGHLIGHT); // force a repaint of this region but do not paint the highlight
            this.reDrawCnt++; // increment redraw iteration count
            this.reDrawPrevPt = new _objects.Point(crsrPos.x, crsrPos.y); // save the previous point
            return true; // return true indicates a position close enough to the region was clicked
        } else {
            // (this.reDrawIdx + ' regReDraw: start : not close enough!  dist: ' + closest.dist); // eslint-disable-line no-undef
            return false; // return false not starting redraw
        }
    } else if (phase == 'update') {
        //........ update region redraw mode: mouse down in redraw mode

        // don't react to new cursor positions that aren't far from the previously inserted point
        if (this.reDrawPrevPt.cityBlockDistance(crsrPos) < skipTolerance_) return true;

        var _ptList2 = region.getPts(); // reference to region points

        // find the closest point in list starting at the next index from last insert
        var closest = findClosestPtFrom(this.reDrawIdx + 1, _ptList2, crsrPos); //{ idx: idx, dist: closestDist };
        closestIdx = closest.idx;
        if (closestIdx != -1) {

            if (++this.reDrawIdx >= _ptList2.length - 1) {
                // if the cursor has lapped back to first point, end drawing
                return false;
            }

            var midpoint = parseInt(_ptList2.length / 2);
            if (closestIdx - this.reDrawIdx > midpoint) {
                // if the direction of motion is CCW (probably only happens early in the drawing)
                changeListDirection(_ptList2); // reverse the order of the points in the list

                var _ptList2 = region.getPts(); // update reference to region points and the closest point
                closest = findClosestPtFrom(this.reDrawIdx, _ptList2, crsrPos);
                ///???? closest = findClosestPtFrom(this.reDrawIdx + 1, ptList, crsrPos);
                closestIdx = closest.idx;
            }

            if (closest.dist < removeTolerance_) {
                // if it is reasonable to remove array points, do so
                (0, _helpers.removeChunk)(_ptList2, this.reDrawIdx, closestIdx);
            }

            (0, _helpers.insertAt)(_ptList2, this.reDrawIdx, crsrPos); // insert this new point right after this.reDrawIdx

            this.paintSelRegion(_defines2.default.DONT_HIGHLIGHT); // force a repaint of this region but do not paint the highlight
            this.reDrawCnt++; // increment redraw iteration count
            this.reDrawPrevPt = new _objects.Point(crsrPos.x, crsrPos.y); // replace the previous point

            return this.reDrawIdx != _ptList2.length - 1; // signal drawing finished or can continue
        } else {
            // (this.reDrawIdx + ' regReDraw: update : not close enough!   dist: ' + closest.dist); // eslint-disable-line no-undef
            return false; // return false finishes drawing
        }
    } else if (phase == 'finish') {
        //........ finish region redraw mode
        this.drawingCompleted(); // redraw: finshed
        var callbackJson = { anObj: this, region: region };
        if (this.reDrawCnt > 3) // if the drawing changed enough points in the region
            genericConfirm('Do you want to save this change?', // then ask user if he wants to save these changes
            'Save Changes', this.regReDrawFinish_cb, callbackJson);else this.regReDrawFinish_cb(callbackJson, false); // otherwise draw original region
        return false;
    } else {
        // unknown phase passed in, should never get here
        this.drawingCompleted(); // redraw: unknown phase
        return false;
    }

    //..................................................
    // closure functions
    //............................................ findClosestPt()
    // findClosestPt - finds the point in the passed list that is closest to the passed point
    //                    and optionally within an  maximum distance
    //                    and optionally can ignore a point at a specific list index
    function findClosestPt(pt, list, opt_tolerance, opt_skipIdx) {
        var idx = -1;
        var closestDist = Number.MAX_VALUE;
        var tolerance = opt_tolerance ? opt_tolerance : Number.MAX_VALUE;
        for (var p = 0, len = list.length; p < len; p++) {
            if (p == opt_skipIdx) // ignore the skip index if it is defined
                continue;
            var adist = list[p].cityBlockDistance(pt); // compute distance to the pt
            if (adist < closestDist) {
                idx = p; // save the list point closest to the passed point
                closestDist = adist;
            }
        }

        if (closestDist < tolerance) return { idx: idx, dist: closestDist };else {
            return { idx: -1, dist: Number.MAX_VALUE };
        }
    }

    //............................................ findClosestPtFrom()
    //    findClosestPtFrom - finds the point the the passed list starting at the passed start index
    //                        that is closest to the passed point
    function findClosestPtFrom(start, list, pt) {
        var idx = -1;
        var closestDist = Number.MAX_VALUE;
        for (var p = start, len = list.length; p < len; p++) {
            var dist = list[p].cityBlockDistance(pt);
            if (dist < closestDist) {
                idx = p;
                closestDist = dist;
            }
        }
        return { idx: idx, dist: closestDist };
    }

    //............................................ createNewList()
    //    createNewList - replace or insert into the passed list a new point
    //                    and reorder the list starting at the new point
    function createNewList(ptList, crsrPos, closestIdx) {
        var insertIdx = closestIdx + 1;
        (0, _helpers.insertAt)(ptList, insertIdx, crsrPos);

        var len = ptList.length; // update the new list length
        var newPtList = []; // new, temporary array

        for (var p = 0, o = insertIdx; p < len; p++) {
            // now put this point at index 0 of list
            newPtList[p] = ptList[o];
            if (++o >= ptList.length) // wrap index around original list
                o = 0;
        }
        return newPtList;
    }

    //............................................ changeListDirection()
    function changeListDirection(ptList) {
        // index 0,1,2,3,4....99 ---> 0,99,98,97...
        var item0 = ptList.shift(); // remove 1st list item
        ptList.reverse(); // reverse the list
        ptList.unshift(item0); // insert the saved 1st item
    }

    //..................................................
};

//............................................ regReDrawFinish_cb
CANNOT_REGION.regReDrawFinish_cb = function (json, save) {
    //note: although this is a prototype when called it does not know itself (this is window)
    var anObj = json.anObj;
    var region = json.region;
    if (save == false) {
        region.replacePts(region.priorPts); // restore the original region points
    } else {
        // save this region's points
        if (_uScope2.default.instance.canSaveAnnotations()) {
            // if incremental save is enabled, automatically update the database
            var regionXML = '<Region Id="' + region.regionId + '">';
            var vertexXML = region.buildVertexXML();
            regionXML += '<Vertices>' + vertexXML + '</Vertices>' + '</Region>';
            anObj.save({ action: 'updateRegion', layerId: region.layerId, regionXML: regionXML });
        }
    }
    anObj.paintSelRegion(); // force a repaint of this region
};

//-------------------------------------------------------------------------------------------------
//    raphael interface functions
//-------------------------------------------------------------------------------------------------

//............................................ rfSelect
//    rfSelect - This function sets the outline width of the region.
function rfSelect(aRegion, select) {
    var strokeWidth = select ? _defines2.default.annotSpecs.strokeWidthSel : aRegion.getStrokeWidth();
    if (aRegion.type != +_defines2.default.eAnTypes.text) aRegion.rfHandle.attr({ 'stroke-width': strokeWidth });else aRegion.data.textBBoxHandle.attr({ 'stroke-width': strokeWidth });
}

//-------------------------------------------------------------------------------------------------
//    deSaturate -
//cp-this isn't really desaturating the color ... rename me?
function deSaturate(decRGB) {
    var blue = decRGB & 0xFF;
    blue = Math.round(blue / 2);
    blue = blue.toString(16);
    if (blue.length < 2) blue = '0' + blue;

    var green = decRGB >> 8 & 0xFF;
    green = Math.round(green / 2);
    green = green.toString(16);
    if (green.length < 2) green = '0' + green;

    var red = decRGB >> 16 & 0xFF;
    red = Math.round(red / 2);
    red = red.toString(16);
    if (red.length < 2) red = '0' + red;

    return red + green + blue;
}

//............................................ rfDraw
//    rfDraw - raphael graphics draw - This function draws the specfied shape in its defined position
//            at scale.  When called with a defined rf handle the graphic's shape is updated,
//            otherwise a new one is created and the newRegion's rfHandle and rfId are asigned.
//            It always returns the rf handle to the annotation object.
//    Notes:
//        - Vertices of regions are always in base coordinate system and scaled for the current zoom.
//        - IE8 would fill all regions and outlines with white at opacity 1.0.  To resolve this the
//            attributes could not assume defaults and had to repeat all settings when updating the graphic.
//
function rfDraw(paper, newRegion, opt_viewZoom, opt_viewAngleDeg) {
    if (newRegion === undefined) return; // sanity check
    if (opt_viewAngleDeg == undefined) opt_viewAngleDeg = 0;

    // closure vars
    var pad = _defines2.default.annotSpecs.textBBoxPad;
    var padX2 = pad * 2;
    var decColor = newRegion.decRGB;
    var hexColor = '#' + (0, _helpers.toHexColor)(decColor);
    var hexBackColor = (0, _helpers.isLightColor)(decColor) ? '#000' : '#FFF'; // if forecolor is light, backcolor is dark and visa versa
    var fillColor = '#' + deSaturate(decColor);
    var ptList = newRegion.getPts(); // point list is in base (zoom = 1.0) coords
    var vtxCnt = ptList.length;
    if (vtxCnt < 1) return; // odd things happen when ending a caliper behind the magnifier, for example

    // if a opt_viewZoom value is not passed in, draw at the region's zoom value
    var scale = (0, _helpers.isDefined)(opt_viewZoom) ? 1. / opt_viewZoom : 1. / newRegion.zoom;

    var strokeWidth = newRegion.getStrokeWidth(); // select the proper stroke width for this region
    var attrs; // rf draw attributes array

    var rfCurHandle = newRegion.rfHandle;
    switch (newRegion.shape) {
        // path format: "M 100 100 L 300 100 L 200 300" (open path) - we are using this form during draw
        // path format: "M 100 100 L 300 100 L 200 300 Z" (closed path) - we are using this once drawn item is completed
        case 'pen':
        case 'negpen':
            if (newRegion.shape === 'pen' && vtxCnt < 3) return rfCurHandle;
            var spath = 'M ' + ptList[0].x * scale + ' ' + ptList[0].y * scale;
            if (vtxCnt > 1) spath += ' L ' + ptList[1].x * scale + ' ' + ptList[1].y * scale;

            for (var v = 2, vlen = vtxCnt; v < vlen; v++) {
                spath += ' ' + ptList[v].x * scale + ' ' + ptList[v].y * scale;
            }spath += newRegion.openShape == false ? ' Z' : ''; // closepath ?

            var strokeDash = newRegion.shape == 'negpen' ? '- ' : '';
            var fillOpacity = newRegion.shape == 'negpen' ? _defines2.default.annotSpecs.fillOpacity : 0.0;
            attrs = {
                'stroke': hexColor,
                'stroke-width': strokeWidth,
                'fill': fillColor,
                'stroke-dasharray': strokeDash,
                'fill-opacity': fillOpacity
            };
            rfCurHandle = rfDrawPath_();
            break;
        case 'ruler':
        case 'caliper':
        case 'polygon':
            var spath = 'M ' + ptList[0].x * scale + ' ' + ptList[0].y * scale;
            if (vtxCnt > 1) spath += ' L ' + ptList[1].x * scale + ' ' + ptList[1].y * scale;

            for (var v = 2; v < vtxCnt; v++) {
                spath += ' ' + ptList[v].x * scale + ' ' + ptList[v].y * scale;
            }spath += newRegion.openShape == false ? ' Z' : ''; // closepath ?

            attrs = { 'stroke': hexColor, 'stroke-width': strokeWidth, 'fill': fillColor, 'fill-opacity': 0.0 };
            rfCurHandle = rfDrawPath_();

            if (newRegion.shape == 'ruler' || newRegion.shape == 'caliper') {
                if (newRegion.isHighLight == false) {
                    // if not drawing the outline of the highlight, draw the caliper distance metric
                    var xloc = newRegion.getPt(vtxCnt - 1).x * scale - 20;
                    var yloc = newRegion.getPt(vtxCnt - 1).y * scale - 25;
                    var str = newRegion.data.lengthMicrons + ' um';
                    rfDrawRegionText(paper, newRegion, str, xloc, yloc);
                }
            }
            break;
        case 'rect':
            // note iscope always draws a rect (regardless of the vertex's stored) but, since this is defined with 4 vertices, use path here
            if (vtxCnt < 4) {
                // TODO: maybe warn instead?
                // ('Shape is rectangle but only ' + vtxCnt + ' points are defined'); // eslint-disable-line no-undef
                return rfCurHandle;
            }
            // report region scale is passed in
            if (newRegion.isReportRegion && newRegion.viewZoom) scale = 1. / newRegion.viewZoom;

            var spath = 'M ' + ptList[0].x * scale + ' ' + ptList[0].y * scale + ' L ' + ptList[1].x * scale + ' ' + ptList[1].y * scale + ' ' + ptList[2].x * scale + ' ' + ptList[2].y * scale + ' ' + ptList[3].x * scale + ' ' + ptList[3].y * scale + ' Z';
            attrs = { 'stroke': hexColor, 'stroke-width': strokeWidth, 'fill': fillColor, 'fill-opacity': 0.0 };
            rfCurHandle = rfDrawPath_();

            // for report region (not for other rects with text), draw the on-image text
            if (newRegion.isHighLight == false && newRegion.isReportRegion) {
                if (newRegion.note.length) {
                    // if the note has content, draw it
                    var bbox = newRegion.rfHandle.getBBox();
                    var xloc = newRegion.getPt(2).x * scale;
                    var yloc = newRegion.getPt(2).y * scale + 15;
                    rfDrawRegionText(paper, newRegion, newRegion.note, xloc, yloc);
                } else {
                    if (newRegion.data.rfTextHandle) {
                        newRegion.data.rfTextHandle.hide(); // if the note does not have content
                        newRegion.data.textBBoxHandle.hide(); // hide the text box and text
                        newRegion.data = {}; // and clear the associative array
                    }
                }
            }
            break;
        case 'report':
            // This handler fires for fixed resolution regions only. In other cases, the report is converted to a rect,
            // and once drawing is finished its textbox is added.
            if (vtxCnt < 1) return rfCurHandle;
            // the following is only good for report types of fixed size, user drawn are drawn as type rect from the start
            if (newRegion.viewZoom) scale = 1 / newRegion.viewZoom;

            // fixed report size but drawn at any resolution requires scaling the fixed report region coords
            var expandToBase;
            if (newRegion.reportType == _defines2.default.eReportTypes.CurRes_FixedDim) {
                expandToBase = newRegion.zoom;
            } else if (newRegion.reportType == _defines2.default.eReportTypes.FullRes_FixedDim) {
                expandToBase = _uScope2.default.instance.getThisImage().getNormalizationFactor();
            } else {
                expandToBase = 1;
            }

            var width = _uScope2.default.instance.prefGet('reportRegionWidth') * expandToBase;
            var height = _uScope2.default.instance.prefGet('reportRegionHeight') * expandToBase;

            // the first point is to be the center of the image so form the fixed size report rect around it
            ptList[0].x = ptList[0].x - parseInt(width / 2);
            ptList[0].y = ptList[0].y - parseInt(height / 2);
            ptList.length = 1; // insure only top left point in array
            var pt = new _objects.Point(ptList[0].x + width, ptList[0].y);
            newRegion.addPt(pt); // top right = ptList[1]
            pt = new _objects.Point(ptList[1].x, ptList[0].y + height);
            newRegion.addPt(pt); // bottom right ptList[2]
            pt = new _objects.Point(ptList[0].x, ptList[2].y);
            newRegion.addPt(pt); // bottom left = ptList[3]

            ptList = newRegion.getPts(); // now draw the report region at the current zoom
            var spath = 'M ' + ptList[0].x * scale + ' ' + ptList[0].y * scale + ' L ' + ptList[1].x * scale + ' ' + ptList[1].y * scale + ' ' + ptList[2].x * scale + ' ' + ptList[2].y * scale + ' ' + ptList[3].x * scale + ' ' + ptList[3].y * scale + ' Z';
            attrs = { 'fill': fillColor, 'fill-opacity': 0.0 };
            rfCurHandle = rfDrawPath_();
            break;
        case 'ellipse':
            var left = ptList[0].x * scale; // ptList[0] is top left corner and ptList[1] is bottom right corner
            var top = ptList[0].y * scale;
            var rx = Math.round((ptList[1].x * scale - left + 1) / 2);
            var ry = Math.round((ptList[1].y * scale - top + 1) / 2);
            var cx = Math.round(+left + +rx);
            var cy = Math.round(+top + +ry);

            attrs = { 'stroke': hexColor, 'stroke-width': strokeWidth, 'fill': fillColor, 'fill-opacity': 0.0 };

            if ((0, _helpers.isDefined)(rfCurHandle)) {
                attrs.cx = cx;
                attrs.cy = cy;
                attrs.rx = rx;
                attrs.ry = ry;
                rfCurHandle.attr(attrs);
            } else {
                newRegion.rfHandle = paper.ellipse(cx, cy, rx, ry).attr(attrs);
                newRegion.rfId = newRegion.rfHandle.id;
            }
            break;

        case 'arrow':
            var _renderArrow = (0, _arrow.renderArrow)(newRegion, ptList, scale, opt_viewZoom),
                svgPath = _renderArrow.svgPath,
                svgTransformation = _renderArrow.svgTransformation;

            attrs = {
                'stroke': hexColor,
                'stroke-width': strokeWidth,
                'fill': hexColor
            };

            if (!newRegion.isHighLight) {
                attrs['fill-opacity'] = 1.0;
            }

            if (rfCurHandle) {
                attrs.path = svgPath;
                rfCurHandle.attr(attrs);
                rfCurHandle.transform(svgTransformation);
            } else {
                newRegion.rfHandle = paper.path(svgPath).attr(attrs);
                newRegion.rfHandle.transform(svgTransformation);
                newRegion.rfId = newRegion.rfHandle.id;
            }

            break;
        case 'pin':
            var coords = _defines2.default.pinSpecs.coords; // the normalized coord path of the pin drop
            var x = Math.floor(ptList[0].x * scale);
            var y = Math.floor(ptList[0].y * scale);

            var spath = 'M ' + (+coords[0] + x) + ' ' + (+coords[1] + y) + ' L'; // build the pin drop path
            for (var p = 2, len = coords.length; p < len; p += 2) {
                spath = spath + ' ' + (+coords[p] + x) + ' ' + (+coords[p + 1] + y);
            }
            spath = spath + ' Z';

            attrs = {
                'stroke': hexColor,
                'stroke-width': strokeWidth,
                'fill': fillColor,
                'fill-opacity': _defines2.default.annotSpecs.fillOpacity
            };
            rfCurHandle = rfDrawPath_();

            if (opt_viewAngleDeg != undefined) {
                rfRotate(newRegion, opt_viewAngleDeg);
            }
            break;
        case 'text':
            if (newRegion.isHighLight == false) {
                if ((0, _helpers.isDefined)(rfCurHandle)) // draw the text
                    rfCurHandle.attr({
                        fill: hexColor, 'font-size': _defines2.default.annotSpecs.fontSize, 'font-weight': 'bold',
                        text: newRegion.note, x: ptList[0].x * scale, y: ptList[0].y * scale
                    });else {
                    newRegion.rfHandle = paper.text(ptList[0].x * scale, ptList[0].y * scale, newRegion.note).attr({ fill: hexColor, 'font-size': _defines2.default.annotSpecs.fontSize, 'font-weight': 'bold' });
                    newRegion.rfId = newRegion.rfHandle.id;
                }

                var bbox = newRegion.rfHandle.getBBox(); // draw the bounding box around the text
                newRegion.data.bbox = bbox; // save for highlight

                if ((0, _helpers.isDefined)(newRegion.data.textBBoxHandle)) newRegion.data.textBBoxHandle.attr({
                    'stroke': hexColor, 'fill': hexBackColor,
                    x: bbox.x - pad, y: bbox.y - pad, width: bbox.width + padX2, height: bbox.height + padX2
                });
                ///            , "font-family": "Arial, Helvetica, sans-serif" });
                else newRegion.data.textBBoxHandle = paper.rect(bbox.x - pad, bbox.y - pad, bbox.width + padX2, bbox.height + padX2, _defines2.default.annotSpecs.textBBoxRadius).attr({ 'stroke': hexColor, 'stroke-width': strokeWidth, fill: hexBackColor });

                newRegion.rfHandle.toFront(); // move the text in front of the bbox
            } else {
                var bbox = newRegion.data.bbox;
                if ((0, _helpers.isDefined)(newRegion.rfHandle)) rfCurHandle.attr({
                    'stroke': hexColor, 'stroke-width': strokeWidth, 'fill-opacity': 0.0,
                    x: bbox.x - pad, y: bbox.y - pad, width: bbox.width + padX2, height: bbox.height + padX2
                });else newRegion.rfHandle = paper.rect(bbox.x - pad, bbox.y - pad, bbox.width + padX2, bbox.height + padX2, _defines2.default.annotSpecs.textBBoxRadius).attr({ 'stroke': hexColor, 'stroke-width': strokeWidth, 'fill-opacity': 0.0 });
            }
            break;
    }

    if (newRegion.isHighLight && newRegion.rfHandle) // if this region is the high light region
        newRegion.rfHandle.toFront(); // move the highlight in front of the outline

    return newRegion.rfHandle; // return the raphael reference to the graphics object


    //..................................................
    // closure functions
    //............................................ rfDrawPath_()
    function rfDrawPath_() {
        if ((0, _helpers.isDefined)(rfCurHandle)) {
            attrs.path = spath;
            rfCurHandle.attr(attrs);
            return rfCurHandle;
        } else {
            newRegion.rfHandle = paper.path(spath).attr(attrs);
            newRegion.rfId = newRegion.rfHandle.id;
            return newRegion.rfHandle;
        }
    }

    //............................................ rfDrawRegionText()
    // This function draws text assoicated with a region at the specified location with a white,
    //  round cornered bounding box behind it.  If the raphael objects for the text and its box
    //  do not exist, they are created and the region object data is updated to retain them.
    //    This is used for ruler and caliper annotation.
    function rfDrawRegionText(paper, newRegion, str, xloc, yloc) {
        ////    var rfDrawRegionText = function (paper, newRegion, str, xloc, yloc) {
        var fontSize = _defines2.default.annotSpecs.fontSize;
        // draw the text
        if ((0, _helpers.isDefined)(newRegion.data.rfTextHandle)) newRegion.data.rfTextHandle.attr({
            text: str,
            x: xloc,
            y: yloc,
            fill: hexColor,
            'stroke': hexColor,
            'font-size': fontSize
        });else newRegion.data.rfTextHandle = paper.text(xloc, yloc, str).attr({ fill: hexColor, 'stroke': hexColor, 'font-size': fontSize });

        var bbox = newRegion.data.rfTextHandle.getBBox(); // draw the bounding box around the text
        //currently not used newRegion.data.bbox = bbox;                         // save for highlight
        if ((0, _helpers.isDefined)(newRegion.data.textBBoxHandle)) newRegion.data.textBBoxHandle.attr({
            'stroke': hexColor,
            fill: hexBackColor,
            x: bbox.x - pad,
            y: bbox.y - pad,
            width: bbox.width + padX2,
            height: bbox.height + padX2
        });else newRegion.data.textBBoxHandle = paper.rect(bbox.x - pad, bbox.y - pad, bbox.width + padX2, bbox.height + padX2, _defines2.default.annotSpecs.textBBoxRadius).attr({ 'stroke': hexColor, fill: hexBackColor });
        newRegion.data.rfTextHandle.toFront(); // move the text in front of the bbox
    }

    //..................................................
}

//............................................ rfRotate
//    This function rotates the passed region.
//    Note that the input angle is negated as uScope's positive direction is the reverse of Raphael's
function rfRotate(region, angleDeg) {
    var rfCurHandle = region.rfHandle;
    switch (region.shape) {
        case 'pin':
            rfCurHandle.transform(''); // must clear the transform or the rotation center wanders away!
            var bbox = rfCurHandle.getBBox();
            var xformStr = ' R' + -angleDeg; // absolute rotation angle
            xformStr += ',' + Math.round(bbox.x + bbox.width / 2) // center of rotation
            + ',' + Math.round(bbox.y + bbox.height);
            rfCurHandle.transform(xformStr); // perform the transform
            break;
        default:
            break;
    }
}

//............................................ regHighLight
// AnnotationsService.regHighLight - This function [de]highlights a region.
//
//    aRegion - region to highlight, or not
//    select - required, {true, false} to highlight or not
//    viewZoom = optional, view zoom of region to pass to rfDraw
CANNOT_REGION.regHighLight = function (aRegion, select, opt_viewZoom, opt_viewAngleDeg) {
    var type = +aRegion.type;
    rfSelect(aRegion, select); // increase/decrease the width of the region outline
    if (select) {
        var hiRegion = this.rfRegionHiLite[type]; // get the region that highlights this type

        hiRegion.decRGB = (0, _helpers.isLightColor)(aRegion.decRGB) ? 0 : 16777215; // if forecolor is light, backcolor is dark and visa versa
        hiRegion.zoom = aRegion.zoom;
        hiRegion.pts = aRegion.pts;
        hiRegion.centerPt = aRegion.centerPt;

        if (type == +_defines2.default.eAnTypes.text) // for on image text, highlight the bounding box
            hiRegion.data.bbox = aRegion.data.bbox;

        rfDraw(this.paper, hiRegion, opt_viewZoom, opt_viewAngleDeg); // draw the highlight
        hiRegion.rfHandle.show();

        if ((0, _helpers.isDefined)(aRegion.data.rfTextHandle)) // if this region has buddy text, like a caliper measurement
            aRegion.data.rfTextHandle.toFront(); // move the text in front of the region outline so the highlight doesn't cover it
    } else {
        this.rfRegionHiLite[type].rfHandle.hide(); // hide this outline
    }
};

//............................................ rfDrawHover
//    rfDrawHover - This function draws the hover note for the passed rfId.
//                    Note that a note length equal to 0 is valid - erasing the prior note.
//    Improvements:
//        -would like to pass region of note and region for hover graphic
CANNOT_DRAW.rfDrawHover = function (rfId) {
    var rfRegions = this.getRegionsArray();
    var region = rfRegions[rfId];

    if (region.shape === 'text' || region.isReportRegion) // if the region is on-image-text or is report region, nothing to do
        return;

    if ((0, _helpers.isUnDefined)(region.note) || region.note.length == 0) {
        // if the note for this region is not defined or its length is 0
        if ((0, _helpers.isDefined)(this.hoverMemoHandle)) this.hoverMemoHandle.hide();
        if ((0, _helpers.isDefined)(this.hoverMemoBBoxHandle)) this.hoverMemoBBoxHandle.hide();
        return;
    }
    if ((0, _helpers.isDefined)(this.hoverMemoHandle)) this.hoverMemoHandle.show();
    if ((0, _helpers.isDefined)(this.hoverMemoBBoxHandle)) this.hoverMemoBBoxHandle.show();

    var viewZoom = this.getMyImage().getViewZoom();

    var ptList = region.getPts(); // point list is in base (zoom = 1.0) coords
    var xloc = +ptList[0].x / viewZoom;
    var yloc = +ptList[0].y / viewZoom;
    if (region.shape === 'pin') yloc = Math.round(ptList[0].y / viewZoom - _defines2.default.pinSpecs.height);

    var pad = _defines2.default.annotSpecs.textBBoxPad;
    var padX2 = pad * 2;
    var decColor = 0; // black text
    var hexColor = '#' + (0, _helpers.toHexColor)(decColor);
    var hexBackColor = '#F6EFBA'; // sticky note yellow
    if ((0, _helpers.isDefined)(this.hoverMemoHandle)) // draw the text
        this.hoverMemoHandle.attr({ text: region.note, x: xloc, y: yloc, fill: hexColor });else this.hoverMemoHandle = this.paper.text(xloc, yloc, region.note).attr({ 'text-anchor': 'start', fill: hexColor, 'font-size': _defines2.default.annotSpecs.fontSize });

    var bbox = this.hoverMemoHandle.getBBox();
    if ((0, _helpers.isDefined)(this.hoverMemoBBoxHandle)) // draw the bounding box around the text
        this.hoverMemoBBoxHandle.attr({
            'stroke': hexColor,
            fill: hexBackColor,
            x: bbox.x - pad,
            y: bbox.y - pad,
            width: bbox.width + padX2,
            height: bbox.height + padX2
        });else this.hoverMemoBBoxHandle = this.paper.rect(bbox.x - pad, bbox.y - pad, bbox.width + padX2, bbox.height + padX2, _defines2.default.annotSpecs.textBBoxRadius).attr({ 'stroke': hexColor, fill: hexBackColor, opacity: 1.0 });

    yloc = yloc - bbox.height / 2; // adjust the note position for the height of the bounding box
    this.hoverMemoHandle.attr({ y: yloc }).toFront(); // and set the text in front of the bbox

    bbox = this.hoverMemoHandle.getBBox(); // move the bounding box to where the note text moved
    this.hoverMemoBBoxHandle.attr({ y: bbox.y - pad });
};

// NOTE: Using loose equality here since the user pref's service doesn't enforce typing yet. TODO: FIX
var isReportFullRes = function isReportFullRes(reportType) {
    return reportType == _defines2.default.eReportTypes.FullRes_FixedDim || reportType == _defines2.default.eReportTypes.FullRes_UserDrawn;
};

var isReportFixedDim = function isReportFixedDim(reportType) {
    return reportType == _defines2.default.eReportTypes.FullRes_FixedDim || reportType == _defines2.default.eReportTypes.CurRes_FixedDim;
};

//............................................ genericConfirm
//    genericConfirm -
//
//    parameters:
//        message:        required, string, your message to the user
//        title:            required, string
//        callback:        required

/**
 * A general purpose confirm panel that removes itself from the DOM when closed.
 * @param message (string) - your message to the user
 * @param title (string) - title
 * @param callback (function)
 * @param callbackJson
 */
function genericConfirm(message, title, callback, callbackJson) {
    if (message == undefined) message = '';
    if (title == undefined) title = '';
    if (message.length == 0 && message.length == 0) return;

    var jPanel = $('<div class=' + _defines2.default.clsPANEL + ' title="' + title + '">' + message + '</div>');

    // append this modal dialog to body to work around a jquery issue that modal dialogs cannot be dismissed in popup mode
    //    (would normally want it appended to the uscope div)
    // note that the dialog is the parent to the panel created
    $('body').append(jPanel);

    jPanel.dialog({
        autoOpen: true,
        modal: true,
        closeOnEscape: false,
        resizable: false,
        dialogClass: 'uscope-dialog dialogMover',
        close: function close(event, ui) {
            $(this).remove();
        },
        buttons: [{
            text: 'No', click: function click() {
                $(this).remove();
                if (callback) {
                    callback(callbackJson, false);
                }
                return false;
            }
        }, {
            text: 'Yes', click: function click() {
                $(this).remove();
                if (callback) {
                    callback(callbackJson, true);
                }
                return true;
            }
        }]
    });
}

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createLayer = createLayer;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _modelFactory = __webpack_require__(149);

var _modelFactory2 = _interopRequireDefault(_modelFactory);

var _reportLayer = __webpack_require__(153);

var _reportLayer2 = _interopRequireDefault(_reportLayer);

var _annotationLayer = __webpack_require__(152);

var _annotationLayer2 = _interopRequireDefault(_annotationLayer);

var _analysisLayer = __webpack_require__(151);

var _analysisLayer2 = _interopRequireDefault(_analysisLayer);

var _tuningLayer = __webpack_require__(154);

var _tuningLayer2 = _interopRequireDefault(_tuningLayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createLayer(props, type) {
    var createLayer = void 0;

    var model = _modelFactory2.default.call(null, props, type);

    // This isn't the most elegant factory ever, but I suppose it works with the constraints of the rules we're apparently using.
    if (model.Type == _defines2.default.anLayerTypes.report) {
        // or data.Name === us.ReportLayerName?
        createLayer = _reportLayer2.default;
    } else if (model.Name === _defines2.default.AnnotLayerName) {
        createLayer = _annotationLayer2.default;
    } else if (model.InputAnnotationId === 0) {
        createLayer = _tuningLayer2.default;
    } else {
        createLayer = _analysisLayer2.default;
    }

    return createLayer(props, model);
}

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _helpers = __webpack_require__(4);

var _model = __webpack_require__(150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lookupTable = {
    json: function json(props, model) {
        Object.assign(model, props);
    },
    x2js: function x2js(props, model) {
        model.Id = props._Id;
        model.Name = props._Name || model.Id;

        model.ReadOnly = props._ReadOnly !== '0';
        model.NameReadOnly = props._NameReadOnly === '0';
        model.LineColorReadOnly = props._LineColorReadOnly === '0';
        model.Incremental = props._Incremental === '0';

        model.LineColor = props._LineColor;
        model.Visible = props._Visible;
        model.Selected = props._Selected === '1';

        // InputAnnotationId is
        //  * defined for analysis output layers (except whole slide)
        //	* undefined for Annotation, Report, Input and whole slide output layer
        //  * 0 for a tuning layer
        model.InputAnnotationId = props.InputAnnotationId ? Number(props.InputAnnotationId) : undefined;

        // NOTE: Type is a layer attribute for tuning layers otherwise as a node (geez...)
        model.Type = props._Type;

        //toconsider: when the type is aafresult, THEN a lot of these macro and input annot ids matter, so maybe if (aafresult type ) then { }

        model.MacroName = props._MacroName;
        model.MacroId = model.MacroName || props.MacroId;

        if (props.Attributes_asArray.length) {
            var attrs = props.Attributes;
            for (var a = 0, alen = attrs.__cnt; a < alen; a++) {
                // e.g. <Attribute Name="Date" Id="728" Value="2014/06/03"/>  note that Id of attribute isn't useful
                //////////////////////ok on getannotations2 (dodbcall) for an aafresult layer
                //
                // Attribute: Array[62] and Attribute_asArray: Array[62] but ___cnt = 125
                // and then there is ___text: Array[63] is full of wierd character and space "↵                    "
                //
                // When I get the same layer with getannotations (imgserver call)
                // Attribute: Array[62] and Attribute_asArray: Array[62] and ___cnt = 62
                // and there is no ___text array
                //
                if (!attrs.Attribute[a]) {
                    break; // TODO: is "break" appropriate here? Why not "continue"?
                }

                //todo: some attributes contain _DisplayColor as well..... (_Id too but who needs it?)
                var displayColor = attrs.Attribute[a]._DisplayColor | '';

                var colorRGB = '#' + (0, _helpers.toHexColor)((0, _helpers.reverseCLR)(displayColor));
                if (colorRGB === '#000000') {
                    colorRGB = '#FFFFFF';
                }
                model.attributes[attrs.Attribute[a]._Name] = {
                    'value': attrs.Attribute[a]._Value,
                    colorRGB: colorRGB
                };
            }
        }

        // Added for Analysis
        // build a region attribute Id to Name lookup table
        //        - inObj.Regions holds <RegionAttributeHeaders> with Id, Name;  The Id here is the Name in the Region.Attributes.Attribute items
        if (props.Regions && props.Regions.RegionAttributeHeaders) {
            var regAttrIdName = {};
            props.Regions.RegionAttributeHeaders.AttributeHeader.forEach(function (header) {
                if (!header) {
                    return false;
                }
                regAttrIdName[header._Id] = header._Name;
            });
        }

        model.nRegions = props.Regions.Region_asArray ? props.Regions.Region_asArray.length : 0;
        //... more to do  RegionAttributeHeaders, and each Region???
    }
};

var updateCommonProps = function updateCommonProps(props, model) {
    // if layer color was not defined, randomly select a color
    if (!model.LineColor) {
        var color = _defines2.default.getRandomColor();
        model.LineColor = (0, _helpers.reverseCLR)((0, _helpers.hexColortoRGB)(color));
    }
    model.typeName = getKeyFromValue(_defines2.default.anLayerTypes, model.Type);
    model.isSupported = !!_defines2.default.anLayerTypesSupported[model.Type];
};

var getKeyFromValue = function getKeyFromValue(assocArray, value) {
    for (var key in assocArray) {
        if (assocArray.hasOwnProperty(key)) {
            if (assocArray[key] == value) return key;
        }
    }
    return '';
};

exports.default = function (props, type) {
    var model = (0, _model.createModel)();

    var parser = lookupTable[type];
    if (parser) {
        parser.call(null, props, model);
    } else {
        throw new Error('layer-factory::create() Cannot create layer from "' + type + '" base model');
    }

    updateCommonProps(props, model);

    return model;
};

module.exports = exports['default'];

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var createModel = exports.createModel = function createModel() {
    var id = 0;

    return {
        // nodes defined in annotation (layer) XML from DataServer - note that I am retaining the exact XML node names as my var names
        Name: undefined,
        get Id() {
            return id;
        },
        set Id(value) {
            var tmp = Number(value);
            if (isNaN(tmp)) {
                throw new Error("LayerModel:setId -> " + value + " is not a number.");
            }
            id = tmp;
        },

        ReadOnly: false, // not implemented!
        NameReadOnly: false, // not implemented!
        LineColorReadOnly: false, // not implemented!
        Incremental: true, // note: it is unclear why the layer is carrying the macro's incremental status.  Presumably imagescope needs it
        Selected: false,
        Visible: true,

        Type: undefined,
        InputAnnotationId: undefined,
        MacroName: undefined,
        MacroId: undefined,

        LineColor: undefined, // color in BGR

        // derived information
        isSupported: true, // see us.anLayerTypesSupported
        typeName: undefined, // string of layer type
        isReportLayer: false, // TODO: Since this is subclassed now, remove
        isAnnotLayer: false, // TODO: Since this is subclassed now, remove
        nRegions: 0, // not implemented!  nothing is keeping this up to date...

        // TODO: What are these? The original code says they're for analysis, but also seem to reference them for reports?
        attributes: []
    };
};

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lbsPiDash = __webpack_require__(5);

var _helpers = __webpack_require__(4);

var _baseLayer = __webpack_require__(48);

var _baseLayer2 = _interopRequireDefault(_baseLayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildResultLookupTable = function buildResultLookupTable(props) {
    // props.Regions holds <RegionAttributeHeaders> with Id, Name;
    // The Id here is the Name in the Region.Attributes.Attribute items
    var attributeHeaders = (0, _lbsPiDash.get)(props, 'Attributes.Attribute_asArray', []);
    var regionHeaders = (0, _lbsPiDash.get)(props, 'Regions.RegionAttributeHeaders.AttributeHeader', []);

    attributeHeaders.forEach(function (header) {
        header.regionHeader = regionHeaders.find(function (rh) {
            return rh._Name === header._Name;
        });
    });

    var regionsRaw = (0, _lbsPiDash.get)(props, 'Regions.Region_asArray');
    var regions = !regionsRaw ? [] : regionsRaw.map(function (region) {
        var _Id = region._Id,
            _InputRegionId = region._InputRegionId,
            Attributes = region.Attributes;

        var props = !Attributes ? {} : Attributes.Attribute_asArray.map(function (a) {
            var GlobalId = a.GlobalId,
                HeaderGlobalId = a.HeaderGlobalId,
                _Id = a._Id,
                _Name = a._Name,
                _Value = a._Value;

            return {
                GlobalId: GlobalId,
                HeaderGlobalId: HeaderGlobalId,
                _Id: _Id,
                _Name: _Name,
                _Value: _Value
            };
        });
        return {
            _Id: _Id,
            _InputRegionId: _InputRegionId,
            props: props
        };
    });
    var table = { regions: regions, regionHeaders: regionHeaders, attributeHeaders: attributeHeaders };

    regionHeaders.forEach(function (header) {
        if (header) {
            table[header._Id] = header._Name;
        }
    });

    return table;
};

exports.default = function (props, model) {
    var attributes = {}; // analysis results for the layer { name, value }
    var regionResultsLookup = buildResultLookupTable(props); // lookup of region's analysis results (attribute) Id to the actual attribute Name

    var self = (0, _baseLayer2.default)(model);

    self.getLayerResults = function () {
        return attributes;
    };
    self.getLayerResultsLength = function () {
        return (0, _helpers.assocArrayLength)(attributes);
    };
    self.getRegionResultsLUT = function () {
        return regionResultsLookup;
    };

    model.layerType = 'analysis';

    return self;
};

module.exports = exports['default'];

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _baseLayer = __webpack_require__(48);

var _baseLayer2 = _interopRequireDefault(_baseLayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props, model) {
    var self = (0, _baseLayer2.default)(model);

    model.layerType = 'annotation';

    // hack alert. Todo: standardize approach of identifying layer type
    model.isAnnotLayer = true;

    return self;
};

module.exports = exports['default'];

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _baseLayer = __webpack_require__(48);

var _baseLayer2 = _interopRequireDefault(_baseLayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props, model) {
    var self = (0, _baseLayer2.default)(model);

    model.layerType = 'report';

    // hack alert. Todo: standardize approach of identifying layer type
    model.isReportLayer = true;

    return self;
};

module.exports = exports['default'];

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _baseLayer = __webpack_require__(48);

var _baseLayer2 = _interopRequireDefault(_baseLayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props, model) {
    var self = (0, _baseLayer2.default)(model);

    // Type is a layer attribute for tuning layers otherwise as a node (geez...)
    model.Type = props.Type;

    model.layerType = 'tuning';

    // hack alert. Todo: standardize approach of identifying layer type
    model.isTuningLayer = true;

    return self;
};

module.exports = exports['default'];

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(19)
  , invoke             = __webpack_require__(54)
  , html               = __webpack_require__(103)
  , cel                = __webpack_require__(83)
  , global             = __webpack_require__(7)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(28)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AnnotationsService;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _toolbar = __webpack_require__(27);

var _objects = __webpack_require__(16);

var _region = __webpack_require__(295);

var _region2 = _interopRequireDefault(_region);

var _regions = __webpack_require__(374);

var _regions2 = _interopRequireDefault(_regions);

var _layer = __webpack_require__(294);

var _layerManager = __webpack_require__(370);

var _layerManager2 = _interopRequireDefault(_layerManager);

var _annotdraw = __webpack_require__(147);

var _events = __webpack_require__(31);

var _helpers = __webpack_require__(4);

var _publicApi = __webpack_require__(6);

var _publicApi2 = _interopRequireDefault(_publicApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//________________________________________________________________________________________________
// annotations.js
//    This file contains the AnnotationsService object that manages annotation graphics.
//
//    history
//    1108    cperz        created
//    _______________________________________end_AIHv1/PR __________________________________________
//    141118    cperz    add support for region copy and move;
//    141222    cperz    extended to support image analysis
//                    change call from ajaxXXXCall to doDATASVRREQ and doIMGSRVREQ with callbacks;
//    150318    cperz    add support for analysis; add getAnTypeButtonClass();
//                    update for doIMGSRVREQ signature change; add local logging;
//                    regDelete - signature change;
//    _______________________________________12.3 __________________________________________________
//    150615    cperz    setSelColor: remove closing tag for updateRegionAndLayer;
//                    getSpouseLayer_: correct get for layer id
//    150730    cboar    fixed incorrect jQuery selector for us.APNOTE
//________________________________________________________________________________________________
//    Object Name: AnnotationsService
//    Overview: The AnnotationsService obect performs all annotation related functionality for a given viewport (image).
//
//    Associated Panel:
//        o cAnnotPanel
//
//    Dependencies and Supporting objects:
//        o Annotations are drawn by the raphael javascript library which operates on
//            HTML5 and non-HTML5 browser versions that we support.
//        o Region
//
//    Assumptions:
//        o todo
//
//    Limitations:
//        o Early development of annotations did not employ layers so all annotations were just a region list.  The annotation panel
//            navigation just walked through that list of regions.  Regions belonging to layers were implemented with IA however as
//            it stands now there is a list of layers and a list of regions.  Regions know their layer but a layer doesn't know its regions.
//            A lot of accessor code is wrapped around working between these two arrays.  Ideally the layer would create its regions.
//            This might not be a good idea though, it should be thoughtfully considered.
//
//    Terms Used:
//        o Abbreviations:
//            A-Layer - annotation layer containing regions that can be a color that is not the layer color
//            R-Layer - annotation layer containing the report region
//            IA - Image Analysis
//
//    Functionality:
//        Input/Output
//            o Read all annotation layers and regions for a given image from the server
//            o Write incremental annotation updates to the server as they occur
//                or write all annotation updates to the server on image close
//        Actions that are Annotation Specific
//            For the 'Annotation' layer
//                o Add, Delete, Select annotions
//                o Change an annotation's color, note
//                o Move, Redraw an annotation (in work, may not be exposed yet)
//            For 'Analysis' layers
//                o Display all input layers, regardless of where they were created
//                o Hide all output layers (because they serve no purpose without markup images and analysis results)
//                o Allow user to add regions to 'Annotation' layer only, in which they can change the color
//                o Disable the color picker on layers other than A-Layer or R-Layer
//        Interaction with Image Navigation
//            o Translation of annotations is performed by translate()
//            o Scaling of annotations is performed by scale()
//            o Rotation of annotations is performed by rotate()
//            o Next/Previous annotation navigation is performed by regSelectNextPrev
//
//    Data Structures:
//        There are 3 data structures of import here:
//        1) the annotation xml, fetched from the server, parsed and maintained in a jquery object
//            - colors maintained in BGR order here because that is the annotation format standard
//        2) the raphael 'paper', a canvas that is contained in a div covering the viewport,
//            that presents the annotation graphics
//        3) the array 'rfRegions' (in cRegions) that is used to relate between the annotation xml and the graphics paper
//            - colors maintained in RGB order here because that is natural to SVG graphics
//
//    HTML:
//        The annotations    div is created in anDivBuild() and is appended to its viewport div.
//
// Inter-Op Annotations: between uScope and ImageScope | WebScope
//        o Display all input layers, regardless of where they were created
//        o Hide all output layers (because they serve no purpose without markup images and analysis results)
//        o Allow user to add regions to 'Annotation' layer only, in which they can change the color
//        o Disable the color picker on layers other than A-Layer or R-Layer
//
//    References:
//        raphael.js is used to draw the vector graphics: http://raphaeljs.com
//        Scalable Vector Graphics: http://www.w3.org/TR/SVG/
//        SVG attribute index: http://www.w3.org/TR/SVG/attindex.html
//________________________________________________________________________________________________
function AnnotationsService(uScope, viewport, annotationsPanel) {
    var self = this;
    var status = false;

    // ..... to group fns in js parser, for ease of search (e.g. search for all 'CANNOT_XFORM')
    var CANNOT = this;
    var CANNOT_INIT = this;
    var CANNOT_GET = this;
    var CANNOT_SET = this;
    var CANNOT_PAINT = this;
    var CANNOT_DRAW = this;
    var CANNOT_XFORM = this;
    var CANNOT_MARKUP = this;
    var CANNOT_DEBUG = this;
    var CANNOT_SAVE = this;
    var CANNOT_LAYER = this;
    var CANNOT_REGION = this;

    var isInitialized = false; // true when first annotation drawing is completed

    var jAnnotDiv;
    self.anDivRect = new _objects.Rectangle(0, 0, 0, 0); // anDiv's current geometry

    //............................................ get/set status
    CANNOT_GET.getStatus = function () {
        return status;
    };
    CANNOT_SET.setStatus = function (bstate) {
        status = !!bstate;
        if (!status) {
            _defines2.default.ENABLEANNOTCREATE = false;
        }
    };
    //............................................ info
    CANNOT_GET.getMyImage = function () {
        return viewport;
    }; // get the viewport instance associated with these annotations
    CANNOT_GET.getImageId = function () {
        return viewport.getImageId();
    };

    //............................................ toString
    CANNOT_DEBUG.toString = function (bDoShort, bReportResults) {
        var rtnStr = '';
        var theLayers = self.layers.getLayersArray();
        for (var lay = 0, len = theLayers.length; lay < len; lay++) {
            // directly access layer array for efficiency, could use getFirst(), getNext()
            if (theLayers[lay]) {
                rtnStr += '\n' + lay + ' Layer: ' + (bDoShort ? theLayers[lay].toStringShort() : theLayers[lay].toString(bReportResults));

                var layerId = theLayers[lay].get('Id');
                var regionArray = self.regions.findByProperty('layerId', layerId);
                for (var r = 0, rlen = regionArray.length; r < rlen; r++) {
                    if (regionArray[r]) rtnStr += '\n             ' + r + ' Region: ' + (bDoShort ? regionArray[r].toStringShort() : regionArray[r].toString(bReportResults));
                }
            }
        }
        return rtnStr;
    };
    //............................................
    _defines2.default.anLayerTypesSupported[_defines2.default.anLayerTypes.manual] = true; // initialize array of supported types
    _defines2.default.anLayerTypesSupported[_defines2.default.anLayerTypes.report] = true;
    if (_defines2.default.ENABLERUNANALYSIS) {
        _defines2.default.anLayerTypesSupported[_defines2.default.anLayerTypes.aafresult] = true;
    }

    CANNOT_GET.getRegionsObj = function () {
        return self.regions;
    };

    CANNOT_GET.getLayersObj = function () {
        return self.layers;
    };

    // AnnotationsService tracks which layer is selected
    self.selLayerIdx = -1; // currently selected layer index in layers layerArray
    // AnnotationsService tracks which region is selected
    self.rfSelected = -1; // currently selected region index in rfRegions
    self.initialRfSelected = -1; // initial selected region in rfRegions - at time of read in

    CANNOT_GET.getRegionsArray = function () {
        return self.regions.getRegionsArray();
    };
    CANNOT_GET.getSelRegion = function () {
        return self.regions.getByRfId(self.rfSelected);
    }; // returns undefined if none selected
    CANNOT_GET.getSelRegionRfId = function () {
        return self.rfSelected;
    };
    CANNOT_GET.getSelType = function () {
        return self.regions.getType(self.rfSelected);
    };
    CANNOT_GET.getSelShape = function () {
        return self.regions.getShape(self.rfSelected);
    };
    CANNOT_GET.getSelRegionId = function () {
        return self.regions.getRegionId(self.rfSelected);
    };

    CANNOT_GET.getSelLayer = function () {
        return self.layers.getSelected();
    };
    CANNOT_GET.getSelLayerId = function () {
        return self.layers.getSelectedId();
    };
    CANNOT_GET.getSelLayerIdx = function () {
        return self.layers.getSelectedIdx();
    };

    CANNOT_GET.getSelColor = function () {
        return self.regions.getRGB(self.rfSelected);
    };
    CANNOT_GET.getReportRegionId = function () {
        return self.regions.getReportRegionId();
    };

    // all on rfSelected
    CANNOT_GET.isWholeSlide = function () {
        return self.regions.isWholeSlide(self.rfSelected);
    };
    CANNOT_GET.isWholeSlideMarkup = function () {
        return self.regions.isWholeSlideMarkup(self.rfSelected);
    };

    // all on rfSelected
    CANNOT_MARKUP.markupIsInView = function (cr2View) {
        return self.regions.markupIsInView(self.rfSelected, cr2View);
    }; // returns true/false
    CANNOT_MARKUP.getSelMarkupImageId = function () {
        return self.regions.getMarkupImageId(self.rfSelected);
    }; // returns undefined if no markup
    CANNOT_MARKUP.getMarkupInfo = function () {
        return self.regions.getMarkupInfo(self.rfSelected);
    }; // returns undefined if no markup
    CANNOT_MARKUP.hasMarkup = function () {
        return self.regions.hasMarkup(self.rfSelected);
    };

    //............................................ region highlight
    // Define a highlight region for each region type.  This is better than creating and destroying
    // raphael objects for each selection as raphael does not reuse the removed ids.
    self.rfRegionHiLite = [];

    //............................................ drawing
    self.reDrawIdx = 0; // redraw vars
    self.reDrawCnt = 0;
    self.reDrawPrevPt = undefined;

    CANNOT_DRAW.drawingIsStarted = function () {
        // when newRegion is defined, drawing is going on
        return self.newRegion != undefined;
    };
    CANNOT_DRAW.drawingCompleted = function () {
        annotationsPanel.enableDrawingIcons(uScope.canAnnotate()); // change drawing icon state to enabled
        self.newRegion = undefined;
        viewport.navModeHalt();
    };

    //............................................ init() - call back from ajaxGetAnnotations
    var paintInitTries = 0;
    CANNOT_INIT.init = function (xml) {
        if ((0, _helpers.isUnDefined)(self.paper)) {
            // ('AnnotationsService: Could not create graphics object; Disabling annotation drawing.'); // eslint-disable-line no-undef
            _defines2.default.ENABLEANNOTCREATE = false;
            return;
        }

        paintInitTimer_(xml);

        //............................................ paintInitTimer_
        function paintInitTimer_(xml) {
            if (viewport.isInitialized()) {
                // if the first image refresh has completed
                paintInit_(xml); //   then paint the annotations (at zoom = 1.0)

                self.events.trigger('us:annotations:paint-complete');
            } else {
                // otherwise come back a little later and check the image paint status again
                if (++paintInitTries < 4) {
                    //    but don't try forever
                    setTimeout(paintInitTimer_, 1000);
                } else {
                    // ('paintInitTimer: annotation first draw: nTries: ' + paintInitTries); // eslint-disable-line no-undef
                }
            }
        }

        //............................................  paintInit_()
        //    This function parses the initial annotations stored in jsonObj_ into layer and region objects
        //    and performs the initial rendering of the annotations.
        function paintInit_(xml) {
            self.paper.clear(); // remove all of the raphael graphics objects
            self.regions.clear(); // remove all regions
            var lastRfHandle = -1; // last region added
            var selRfHandle = -1; // selected region
            createHighlightRegions_(); // create a highlight region for each region type

            var x2js = new X2JS();
            var jsonObj_ = x2js.xml_str2json(xml); // convert input xml to json object

            // note... really cLayers could take all of this in.....
            var jsAnnots = jsonObj_.Annotations.Annotation_asArray ? jsonObj_.Annotations.Annotation_asArray : [];

            for (var l = 0, jlen = jsAnnots.length; l < jlen; l++) {
                var jsLayer = jsAnnots[l]; // a layer :== [Annotation]
                var aLayer = (0, _layer.createLayer)(jsLayer, 'x2js'); // create this layer object from json
                //toconsider: verify construction is ok?
                var strLayerDbg = '\n.....layer: #' + l + ' ' + aLayer.toString(false);
                if (aLayer.get('isSupported') == false) {
                    // ignore un-supported layers and their regions
                    continue;
                }
                self.layers.add(aLayer); // add aLayer to cLayers collection

                var jsRegions = jsLayer.Regions; // has RegionAttributeHeaders, Region[]
                var nRegions = jsRegions.Region_asArray ? jsRegions.Region_asArray.length : 0;

                for (var r = 0, rlen = nRegions; r < rlen; r++) {
                    var jsRegion = jsRegions.Region_asArray[r];

                    var aRegion = new _region2.default(jsRegion, 'x2js', viewport, aLayer, self); // create this region
                    strLayerDbg += '\n             ...region #' + r + ' ' + aRegion.toString(true, false);

                    if (aRegion.rfHandle) {
                        // if successfully drawn
                        self.regAdd(aRegion, false, false); // add the new region to the collection, don't save back to the db

                        lastRfHandle = aRegion.rfHandle; // update last rfHandle
                        var Selected = jsRegion._Selected === '1' ? true : false;
                        if (aLayer.isSelected() && Selected) // if layer and region is selected,
                            selRfHandle = aRegion.rfHandle; // then this is the selected rfHandle
                    }
                }
            }
            isInitialized = true; // annotations initialized now; allows markupRefresh to execute
            initialView_(selRfHandle, lastRfHandle); // set the initial view according to the initial state parameters

            // TODO ? self.render();
            return true;

            //..................................................
            // closure functions
            //............................................ createHighlightRegions_
            function createHighlightRegions_() {
                for (var type = 0; type < _defines2.default.kREGIONTYPES; type++) {
                    // create a new region object of each region type
                    self.rfRegionHiLite[type] = new _region2.default({ 'type': type, isHighLight: true }, 'json', viewport, undefined, self);
                }
            }
            //............................................ initialView
            // This function sets the initial view according to the initial state parameters.
            //        Priority order of first view is derived from initial state parameters:
            //        1) initial region - if present, the code below responds
            //        then 2) initial x,y {optional z & mag} - if present, viewport already responded - just mag present works too
            //        then 3) last selected region - if a region exists, the code below responds
            //        then 4) center of image  - viewport's default and already performed
            function initialView_(selRfHandle, lastRfHandle) {
                // save selected region rfId that came from the db
                if (selRfHandle !== -1) self.initialRfSelected = selRfHandle.id;else if (lastRfHandle != -1) self.initialRfSelected = lastRfHandle.id;

                var initState = viewport.initState;
                if ((0, _helpers.isDefined)(initState.regionId)) // if the initial state specified a region, go to it
                    _publicApi2.default.goToRegion(initState.imageId, initState.regionId); // returns false if the specified region is not found
                else {
                        // otherwise,  select either the region last selected or the last region if it existed
                        if (selRfHandle != -1) self.regSelect({
                            rfId: selRfHandle.id,
                            bSaveSel: false,
                            bReposition: false
                        });else if (lastRfHandle != -1) self.regSelect({
                            rfId: lastRfHandle.id,
                            bSaveSel: false,
                            bReposition: false
                        });
                    }
                if (self.rfSelected == -1) // select the annotation layer if no regions are selected
                    self.layers.selectByProperty('Name', _defines2.default.AnnotLayerName);
                annotationsPanel.enableRegionIcons(self); // update the annotation navigation panel display
            }

            //..................................................
        }
    };
    //............................................ regHoverShow()
    //    This function shows/hides a hovering note associated with a region.
    CANNOT_PAINT.regHoverShow = function (show, rfId) {
        if (show) {
            if ((0, _helpers.isDefined)(self.hoverMemoHandle)) self.hoverMemoHandle.show();
            if ((0, _helpers.isDefined)(self.hoverMemoBBoxHandle)) self.hoverMemoBBoxHandle.show();
            if ((0, _helpers.isUnDefined)(rfId)) {
                var region = self.getSelRegion();
                rfId = region.rfId;
            }
            self.rfDrawHover(rfId); // draw the hover note
        } else {
            if ((0, _helpers.isDefined)(self.hoverMemoHandle)) self.hoverMemoHandle.hide();
            if ((0, _helpers.isDefined)(self.hoverMemoBBoxHandle)) self.hoverMemoBBoxHandle.hide();
        }
    };
    //............................................ show - This function shows/hides all annotation graphics
    CANNOT_PAINT.show = function (show) {
        if (jAnnotDiv) {
            if (show) jAnnotDiv.show();else jAnnotDiv.hide();
        }
    };
    //............................................ rotate - This function rotate all annotation graphics (that remain upright during rotation)
    //    Note that the annotation div naturally rotates with the view.
    //    This function addresses rotation of individual shapes to angles other than that of the view.
    var rotateChange = function rotateChange(angleDeg) {
        var rfRegions = self.getRegionsArray();

        for (var g = 0, glen = rfRegions.length; g < glen; g++) {
            // scale and position the graphics
            if ((0, _helpers.isDefined)(rfRegions[g])) {
                var region = rfRegions[g];
                (0, _annotdraw.rfRotate)(region, angleDeg);

                if (g == self.rfSelected) {
                    // update the highlight on the selected region
                    var type = +region.type;
                    var hiRegion = self.rfRegionHiLite[type]; // get the region that highlights this type
                    (0, _annotdraw.rfRotate)(hiRegion, angleDeg);
                }
            }
        }
    };
    //............................................ updatePosition
    //  This function sets the paper/canvas on-screen dimensions
    //    and position to that of the viewport. Call when the viewport size changes.
    function updatePosition(_ref) {
        var left = _ref.left,
            top = _ref.top,
            width = _ref.width,
            height = _ref.height;

        self.anDivRect.x = left;
        self.anDivRect.y = top;
        self.anDivRect.w = width;
        self.anDivRect.h = height;
    }

    //............................................ zoomChange - This function redraws all annotation graphics
    var zoomChange = function zoomChange() {
        var paper = self.paper; // access to raphael for this image
        var rfRegions = self.getRegionsArray();

        for (var g = 0, glen = rfRegions.length; g < glen; g++) {
            // scale and position the graphics
            if ((0, _helpers.isDefined)(rfRegions[g])) {
                (0, _annotdraw.rfDraw)(paper, rfRegions[g], viewport.getViewZoom(), viewport.getViewAngle(true));
                if (g == self.rfSelected) // update the highlight on the selected region
                    self.regHighLight(rfRegions[g], true, viewport.getViewZoom(), viewport.getViewAngle(true));
            }
        }
    };
    //............................................ paintSelRegion - This function redraws the selected annotation region
    CANNOT_PAINT.paintSelRegion = function (bDoHighlight) {
        var region = self.getSelRegion(); // ref to the selected region
        var viewZoom = viewport.getViewZoom();
        var viewAngleDeg = viewport.getViewAngle(true);
        (0, _annotdraw.rfDraw)(self.paper, region, viewZoom, viewAngleDeg);
        if (bDoHighlight != false) // if not prohibited, update the highlight color of the selected region
            self.regHighLight(region, true, viewZoom, viewAngleDeg);
    };

    //............................................ setSelColor
    //    AnnotationsService.setSelColor - This function sets the color of the selected layer and region.
    CANNOT_SET.setSelColor = function (decRGB) {
        var decBGR = (0, _helpers.reverseCLR)(decRGB);
        var thisImg = self.getMyImage();
        var viewZoom = thisImg.getViewZoom();
        var viewAngleDeg = thisImg.getViewAngle(true);

        //_____
        var aRegion = self.getSelRegion();
        var aLayer = self.getSelLayer();
        var alayerXML; // spouse layer is associated input or output layer
        var sLayer; // spouse layer is associated input or output layer
        var layerId;
        var regionXML;
        var slayerXML;

        if (aLayer && !aRegion) {
            layerId = aLayer.get('Id');
            sLayer = getSpouseLayer_(aLayer);
            alayerXML = '<Annotation Id="' + layerId + '"' + ' LineColor="' + decBGR + '"' + '></Annotation>';

            if (sLayer) {
                alayerXML += '<Annotation Id="' + sLayer.get('Id') + '"' + ' LineColor="' + decBGR + '"' + '></Annotation>';
            }

            self.save({ action: 'updateLayer', layerId: layerId, layerXML: alayerXML });
        } else if (aRegion) {
            layerId = aRegion.get('layerId');
            aLayer = self.layers.getLayerById(layerId);
            sLayer = getSpouseLayer_(aLayer);
            // save the region and layer color to the database
            regionXML = '<Region Id="' + aRegion.get('regionId') + '"' + ' LineColor="' + decBGR + '"' + '></Region>';
            alayerXML = '<Annotation Id="' + layerId + '"' + ' LineColor="' + decBGR + '"' + '>'; // do not include closing tag
            self.save({
                action: 'updateRegionAndLayer', layerId: layerId, layerXML: alayerXML,
                regionId: aRegion.get('regionId'), regionXML: regionXML
            });

            if (sLayer) {
                // save the spouse layer to the database
                slayerXML = '<Annotation Id="' + sLayer.get('Id') + '"' + ' LineColor="' + decBGR + '"' + '></Annotation>';
                self.save({ action: 'updateLayer', layerId: sLayer.get('Id'), layerXML: slayerXML });
            }
        } else {
            return // ('annot: setSelColor: no selected region, no selected layer, case not handled'); // eslint-disable-line no-undef
        }
        if (aLayer) aLayer.set('LineColor', decBGR); // set each layer's color
        if (sLayer) sLayer.set('LineColor', decBGR);

        //_____
        if (aLayer.get('isAnnotLayer') == false) {
            // if the layer is not the annotation layer,
            setRegionColor(layerId); // then color all the regions of this layer
            if (sLayer) setRegionColor(sLayer.get('Id')); // and if there exists a spouse layer, color its regions
        }

        if (aRegion) {
            // if there was a selected region,
            aRegion.setRGB(decRGB); // change the region color - necessary in case this is just a region on the annotation layer
            (0, _annotdraw.rfDraw)(self.paper, aRegion, viewZoom, viewAngleDeg); // then repaint the region with the new color
            self.regHighLight(aRegion, true, viewZoom, viewAngleDeg); // and update the highlight color of the selected region
        }
        return;

        //..................................................
        // closure functions
        //............................................ getSpouseLayer_
        function getSpouseLayer_(aLayer) {
            var spouseLayer;
            if (aLayer) {
                var layerSpouseId = aLayer.get('InputAnnotationId'); // is this an output layer?
                if (layerSpouseId) {
                    // then its color is the same as the input layer
                    spouseLayer = self.layers.getLayerById(layerSpouseId); // get the input layer and set its color
                } else {
                    // this is an input layer
                    var layerId = aLayer.get('Id');
                    var layerArray = self.layers.findByProperty('InputAnnotationId', layerId); // does it have an associated output layer?
                    if (layerArray.length) {
                        spouseLayer = layerArray[0]; //todo: note: not setting ALL output layers, assuming a single output layer here
                    }
                }
            }
            return spouseLayer;
        }

        //............................................ setRegionColor
        function setRegionColor(layerId) {
            if (layerId) {
                var regionArray = self.regions.findByProperty('layerId', layerId); // then set the region color for all regions in the layer (no need to save to the db)
                for (var r = 0, rlen = regionArray.length; r < rlen; r++) {
                    regionArray[r].setRGB(decRGB); // change the region color
                    (0, _annotdraw.rfDraw)(self.paper, regionArray[r], viewZoom, viewAngleDeg); // repaint the region with the new color
                }
            }
        }

        //..................................................
    };

    //............................................ saveAll
    // AnnotationsService.saveAll - This function saves all the annotations to the database.
    CANNOT_SAVE.saveAll = function () {
        // ('saveall:  not implemented'); // eslint-disable-line no-undef
    };
    //............................................ save
    // AnnotationsService.save - This function saves the annotations to the database.
    //        Although it can execute a complete save of all annotations its primary work is in saving
    //        incremental updates to annotations.
    //
    // input parameters:
    //        parms.action - required; operation to perform; choices are:
    //                            saveAll -
    //                            addRegion -
    //                            delRegion -
    //                            updateRegion -
    //                            addLayer -
    //                            delLayer -
    //                            updateLayer -
    //                            updateRegionAndLayer -
    //
    //      The presence of the following parameters depend upon the action specified:
    //        parms.layerId - the id of the layer
    //        parms.regionId - the id of the region
    //        parms.layerXML - the xml content to attach to the <Annotations> node
    //        parms.regionXML - the xml content to attach to the <Regions> node
    //        parms.tag - a string to enclose in <tag> </tag> that data server will echo back - used to associate reqeusts and responses
    //
    //
    CANNOT_SAVE.save = function (parms) {
        if (parms.action === 'saveAll') return self.saveAll();

        var preamble = 'save: ' + parms.action + ': ';
        var xml;
        var xmlns = 'http://www.aperio.com/webservices/';
        var imageId = (0, _helpers.stripLeadingAtSign)(self.getImageId()); // id sent as a number, no leading '@'

        if (parms.action === 'delRegion') {
            if ((0, _helpers.isUnDefined)(parms.layerId) || (0, _helpers.isUnDefined)(parms.regionId)) {
                // (preamble + ' layer or region id undefined'); // eslint-disable-line no-undef
                return;
            }

            //    <ImageId>10</ImageId>
            //    <AnnotationsNode><DeletedAnnotations><Annotation Id="19"><Regions><Region Id="390"/></Regions></Annotation></DeletedAnnotations></AnnotationsNode>
            var xml = '<ImageId>' + imageId + '</ImageId>' + '<AnnotationsNode>' + (parms.tag ? '<Tag>' + parms.tag + '</Tag>' : '') + '<DeletedAnnotations>' + '<Annotation Id="' + parms.layerId + '"' + '>' + '<Regions><Region Id="' + parms.regionId + '"' + '/></Regions>' + '</Annotation></DeletedAnnotations></AnnotationsNode>';
        } else if (parms.action === 'delLayer') {
            if ((0, _helpers.isUnDefined)(parms.layerId)) {
                // (preamble + ' layer id undefined'); // eslint-disable-line no-undef
                return;
            }

            //    <ImageId>10</ImageId>
            //    <AnnotationsNode><DeletedAnnotations><Annotation Id="19"></Annotation></DeletedAnnotations></AnnotationsNode>
            var xml = '<ImageId>' + imageId + '</ImageId>' + '<AnnotationsNode>' + (parms.tag ? '<Tag>' + parms.tag + '</Tag>' : '') + '<DeletedAnnotations>' + '<Annotation Id="' + parms.layerId + '"' + '>' + '</Annotation></DeletedAnnotations></AnnotationsNode>';
        } else if (parms.action === 'addRegion') {
            if ((0, _helpers.isUnDefined)(parms.layerId) || (0, _helpers.isUnDefined)(parms.regionXML)) {
                // (preamble + ' layer or region id or regionXML undefined'); // eslint-disable-line no-undef
                return;
            }

            //    <ImageId>10</ImageId>
            //    <AnnotationsNode>
            //        <Tag>echoed information here</Tag> // return original, negative regionId so assigned Id can be replaced
            //        <Annotations><Annotation Id="17">
            //            <Regions><Region Id="-474" ... DisplayId="-474"> ... <Region></Regions>
            //        </Annotation></Annotations>
            //    </AnnotationsNode>
            var xml = '<ImageId>' + imageId + '</ImageId>' + '<AnnotationsNode>' + (parms.tag ? '<Tag>' + parms.tag + '</Tag>' : '') + '<Annotations>' + '<Annotation Id="' + parms.layerId + '"' + '>' + '<Regions>' + parms.regionXML + '</Regions>' + '</Annotation></Annotations></AnnotationsNode>';
        } else if (parms.action === 'updateRegion') {
            if ((0, _helpers.isUnDefined)(parms.layerId) || (0, _helpers.isUnDefined)(parms.regionXML)) {
                // (preamble + ' layer or region id or regionXML undefined'); // eslint-disable-line no-undef
                return;
            }

            //    <ImageId>10</ImageId>
            //    <AnnotationsNode><Annotations><Annotation Id="17">
            //        <Regions><Region Id="12" ... > ... <Region></Regions>
            //    </Annotation></Annotations></AnnotationsNode>
            var xml = '<ImageId>' + imageId + '</ImageId>' + '<AnnotationsNode>' + (parms.tag ? '<Tag>' + parms.tag + '</Tag>' : '') + '<Annotations>' + '<Annotation Id="' + parms.layerId + '"' + '>' + '<Regions>' + parms.regionXML + '</Regions>' + '</Annotation></Annotations></AnnotationsNode>';
        } else if (parms.action === 'addLayer') {
            if ((0, _helpers.isUnDefined)(parms.layerXML)) {
                // (preamble + ' layer xml undefined'); // eslint-disable-line no-undef
                return;
            }

            //    <ImageId>10</ImageId>
            //    <AnnotationsNode>
            //        <Tag>echoed information here</Tag>
            //        <Annotations><Annotation Id="-17" ...></Annotation></Annotations>
            //    </AnnotationsNode>
            var xml = '<ImageId>' + imageId + '</ImageId>' + '<AnnotationsNode>' + '<Tag>' + parms.tag + '</Tag>' // return original, negative layerId so assigned Id can be replaced
            + '<Annotations>' + parms.layerXML + '</Annotations></AnnotationsNode>';
        } else if (parms.action === 'updateLayer') {
            if ((0, _helpers.isUnDefined)(parms.layerXML)) {
                // (preamble + ' layer xml undefined'); // eslint-disable-line no-undef
                return;
            }

            //    <ImageId>10</ImageId>
            //    <AnnotationsNode><Annotations><Annotation Id="-17" ...></Annotation></Annotations></AnnotationsNode>
            var xml = '<ImageId>' + imageId + '</ImageId>' + '<AnnotationsNode>' + (parms.tag ? '<Tag>' + parms.tag + '</Tag>' : '') + '<Annotations>' + parms.layerXML + '</Annotations></AnnotationsNode>';
        } else if (parms.action === 'updateRegionAndLayer') {
            if ((0, _helpers.isUnDefined)(parms.layerId) || (0, _helpers.isUnDefined)(parms.regionId) || (0, _helpers.isUnDefined)(parms.layerXML) || (0, _helpers.isUnDefined)(parms.regionXML)) {
                // (preamble + ' layer or region id or XML undefined'); // eslint-disable-line no-undef
                return;
            }

            //    <ImageId>10</ImageId>
            //    <AnnotationsNode><Annotations><Annotation Id="17" Selected="1">
            //        <Regions><Region Id="12" ... > ... <Region></Regions>
            //    </Annotation></Annotations></AnnotationsNode>
            var xml = '<ImageId>' + imageId + '</ImageId>' + '<AnnotationsNode>' + (parms.tag ? '<Tag>' + parms.tag + '</Tag>' : '') + '<Annotations>' + parms.layerXML // note that closing tag must not be present
            + '<Regions>' + parms.regionXML + '</Regions>' + '</Annotation></Annotations></AnnotationsNode>';
        } else {
            return;
        }

        if (xml) {
            // send the request
            self.getMyImage().ajax.doDATASVRREQ(cbSuccessFn, undefined, 'PutAnnotations3', xml, parms);
        }

        //..................................................
        // closure functions
        //............................................ cbSuccessFn()
        function cbSuccessFn(data, textStatus, jqXHR, cbParms) {
            var preamble = 'annot: cbSuccessFn: ' + cbParms.action + ': ';

            var idx = -1;
            var responseText = jqXHR.responseText;
            if ((idx = responseText.lastIndexOf('>')) !== -1) responseText = responseText.slice(0, idx + 1); // remove the null termination and the carriage return on the end of the response

            //    The minimum response is:
            //        <PutAnnotations3Response xmlns="http://www.aperio.com/webservices/">
            //            <PutAnnotations3Result>
            //                <ASResult>0</ASResult> <ASMessage/>
            //                </PutAnnotations3Result>
            //            <AnnotationsNode>
            //                <Annotations/>
            //            </AnnotationsNode>
            //        </PutAnnotations3Response>

            var xmlDoc = $.parseXML(responseText);
            var $xml = $(xmlDoc);
            var jResponse = $xml.find('PutAnnotations3Response');
            var jResult = jResponse.find('ASResult');

            if (jResult.text() != '0') {
                var jMessage = jResponse.find('ASMessage'); //s/b [ asmessage ]
                // (preamble + '  msg:' + jMessage.text() + '  code: ' + jResult.text()); // eslint-disable-line no-undef
                return;
            }

            if (cbParms.action === 'addRegion') {
                var imageId = '@' + jResponse.find('ImageId').text(); // i always precede imageId number with @

                var layerId = jResponse.find('Annotation').attr('Id');
                var jTag = jResponse.find('Tag'); // get the returned tag
                var oRegionId = parseInt(jTag.text()); // the original, negative region id
                var jRegion = jResponse.find('Region'); // s/b [  ]
                var regionId = jRegion.attr('Id'); // the assigned region id

                // replace the temporary negative regionId with the one assigned by dataserver
                self.regions.addRegionResponse({ imageId: imageId, negId: oRegionId, assignedId: regionId });
            } else if (cbParms.action === 'addLayer') {
                if (cbParms.cbSuccessFn) cbParms.cbSuccessFn(jResponse, cbParms);
            }
        }
    };

    //............................................ regSelect
    // AnnotationsService.regSelect - This function deselects the currently selected graphics object and
    //                selects the specified new one.
    //
    //    input parms:
    //        rfId:            required if regionId not provided, index into rfRegions to select
    //        regionId:        required if rfId not provided, id of region to select
    //                note: if both rfId and regionId are provided, rfId is used
    //
    //        bReposition:    optional, default true, reposition the view to center on the selection at the region zoom
    //        bDoZoom:        optional, default true, zoom to region's zoom
    //        bSaveSel:        optional, default true, update the database - this region/layer selected
    //                        - note that this may be overridden by us.ENABLEANNOTSELSAVE in which case it will not be saved
    CANNOT_REGION.regSelect = function (parms) {
        var thisImg = self.getMyImage();
        var rfRegions = self.getRegionsArray(); //

        var rfId = parms.rfId;
        if (rfId == undefined && parms.regionId) // if rfId not defined and regionId is, find rfId of that regionId in rfRegions
            rfId = (0, _helpers.getIndexWith)(rfRegions, 'regionId', parms.regionId); // returns -1 if regionId is not in rfRegions

        if (rfId == undefined || rfId < 0 || isValidArrayIndex(rfRegions, rfId) == false) {
            // insure a valid region
            // ('regSelect: missing both rfId and regionId'); // eslint-disable-line no-undef
            return false;
        }

        var region = rfRegions[rfId]; // newly selected region
        var bReposition = (0, _helpers.isUnDefined)(parms.bReposition) || parms.bReposition == true ? true : false;
        var bSaveSel = _defines2.default.ENABLEANNOTSELSAVE; // if saving the selection is disabled, disregard parms.bSaveSel
        if (bSaveSel) bSaveSel = (0, _helpers.isUnDefined)(parms.bSaveSel) || parms.bSaveSel == true ? true : false;

        var curZoom = thisImg.getViewZoom();
        if (self.rfSelected !== rfId) {
            // if the passed region is not already selected

            // deselection of the previous (current) graphic
            if (self.rfSelected >= 0 && rfRegions[self.rfSelected] != undefined) {
                // if the current select is valid
                var prevSel = self.rfSelected;
                var prevRegion = rfRegions[self.rfSelected];
                self.regHighLight(prevRegion, false, region.zoom, thisImg.getViewAngle(true));

                if (uScope.canSaveAnnotations() && bSaveSel) // send a layer and region update message
                    prevRegion.onSelectChange(false);
            }
            var prevRfSelected = self.rfSelected;
            self.rfSelected = rfId; // select the new region annotation xml

            var layerId = self.regions.getLayerId(self.rfSelected); // get layerId of this region
            self.layers.selectByProperty('Id', layerId); // and select the layer  ////////////??? maintaining this in layers and annotations??????

            // and highlight the region at the intended zoom
            self.regHighLight(region, true, bReposition ? region.zoom : curZoom, thisImg.getViewAngle(true));

            if (uScope.canSaveAnnotations() && bSaveSel) // send a layer and region update message
                region.onSelectChange(true);

            if (isInitialized && region.regionId >= 0) {
                self.events.trigger('us:annotations:region-change', { // NOTE: This replaces us.evANNOTCHANGE
                    imageId: region.imageId,
                    regionId: region.regionId,
                    layerId: region.layerId,
                    anShape: region.isReportRegion ? 'report' : region.shape,
                    action: 'sel'
                });
            }
        }

        if (bReposition) {
            // if specified to reposition the view (this is default behavior)
            var pt = region.getCenter();

            var bDoMove = false;
            // if region center is within the view, no need to reposition
            var cpViewCenter = thisImg.getViewCenter(); // in zoom image coords
            var ptViewCenter = new _objects.Point(cpViewCenter.x * curZoom, cpViewCenter.y * curZoom);
            var dx = Math.abs(pt.x - ptViewCenter.x),
                dy = Math.abs(pt.y - ptViewCenter.y);
            if (dx > thisImg.getViewWidth() / 2 || dy > thisImg.getViewHeight() / 2) bDoMove = true;

            var bDoZoom = parms.bDoZoom != undefined ? parms.bDoZoom : Math.abs(region.zoom - curZoom) > 0.1;

            if (bDoMove) // if the region isn't near the center of the view
                thisImg.moveAbsoluteCenter(pt.x, pt.y, { animate: true }); // then center it
            if (bDoZoom) // if the region's zoom isn't close to the current zoom
                thisImg.zoomAbsolute(region.zoom); // then change zooms
        }
        annotationsPanel.enableRegionIcons(this); // update the annotation navigation panel display

        ///////////////////////////////////////////////////////////////////
        ///todo: I don't think this is nec as trigger is listened for
        //thisImg.markupRefresh('regSelect');                         // if the newly selected region has a markup, refresh markup
        ///////////////////////////////////////////////////////////////////
        return true;
    };

    //............................................ regSelectToCenter
    // AnnotationsService.regSelectToCenter - This function zooms/centers the view at the currently selected region.
    //
    //    parameters:
    //        opt_bDoZoom:    optional, boolean, default true, if false the view zoom is not changed
    //
    CANNOT_REGION.regSelectToCenter = function (opt_bDoZoom) {
        var region = self.getSelRegion(); // ref to the selected region
        if (region) {
            var pt = region.getCenter(); // selected region's center pt
            var thisImg = self.getMyImage();
            if (opt_bDoZoom != false) thisImg.zoomAbsolute(region.zoom);
            thisImg.moveAbsoluteCenter(pt.x, pt.y, { animate: true });
        }
    };

    //............................................ regSelectSaveAtClose
    // AnnotationsService.regSelectSaveAtClose - This function is intended to be used when closing an image
    //        whose annotations were auto updated with the exception of the select/deselect state.
    //        The user rights permission is checked in this function.
    CANNOT_REGION.regSelectSaveAtClose = function () {

        // if the user has rights to save annotations and the initial selection isn't the current selection
        if (uScope.canSaveAnnotations() && self.initialRfSelected != self.rfSelected) {
            var rfRegions = self.getRegionsArray();

            if (isValidArrayIndex(rfRegions, self.initialRfSelected)) {
                var region = rfRegions[self.initialRfSelected];
                region.onSelectChange(false);
            }
            if (isValidArrayIndex(rfRegions, self.rfSelected)) {
                var region = rfRegions[self.rfSelected];
                region.onSelectChange(true);
            }
        }
    };

    //............................................ regSelectNextPrev
    // AnnotationsService.regSelectNextPrev - This function selects the first, next, previous or last annotation.
    //                    It returns true if it successfully selected an annotation, otherwise false.
    //    passed parameters:
    //        action:            required, string, "first", "next", "last", "previous", "current"
    //        bReposition:    optional, default true, reposition the view to center on the selection
    //
    CANNOT_REGION.regSelectNextPrev = function (action, bReposition) {
        if ((0, _helpers.isUnDefined)(bReposition)) bReposition = true;

        var rfRegions = self.getRegionsArray();
        if (rfRegions.length === 0 || self.rfSelected < 0) // if there are no regions, return
            return false;

        if (action == 'current') {
            self.regSelectToCenter(); // if the current region is selected, select it which puts it in view
            return true; // and return
        }

        var rfId = self.rfSelected; // start at currently selected region
        if (action === 'first') rfId = -1; // or start at first index (once nextId is called)
        else if (action === 'last') rfId = rfRegions.length; // or start at last index (once nextId is called)

        var incr = action === 'next' || action === 'first' ? 1 : -1; // step through rfRegions forward or backwards?

        rfId = nextId(rfId); // get starting next id
        var cnt = 0; // count to insure loop is not infinite
        do {
            // step forward/backward thru the regions array
            cnt++;
            if (rfRegions[rfId] !== undefined) {
                self.regSelect({ rfId: rfId, bReposition: bReposition }); // and select the next/previous region
                return true; // and return
            }
            rfId = nextId(rfId);
        } while (rfId !== self.rfSelected && cnt < rfRegions.length);
        // end up here after region deletions when there is only one region left

        self.regSelect({ rfId: self.rfSelected, bReposition: bReposition }); // select the lone region
        return false;

        //..................................................
        // closure functions
        function nextId(id) {
            // internal fn to increment/decrement id
            if (incr > 0) {
                if (++id >= rfRegions.length) id = 0;
            } else {
                if (--id < 0) id = rfRegions.length - 1;
            }
            return id;
        }

        //..................................................
    };

    //............................................ regSelectDelete
    //    AnnotationsService.regSelectDelete - This function deletes the selected annotation
    CANNOT_REGION.regSelectDelete = function () {
        var region = self.getSelRegion(); // ref to the selected region
        if (region) {
            if (self.regDelete(region.get('regionId'))) {
                self.regHighLight(region, false);
            }
        }
    };

    //............................................ layerReInit
    // This function is called after analysis is run to get the aafresult layer and its regions.
    // Optionally it will select the output region associated with the passed opt_inputRegionId
    // Optionally it will call the passed opt_cbLayerReInit with the layerId when the layer data has been loaded/parsed.
    CANNOT_LAYER.layerReInit = function (layerId, opt_inputRegionId, opt_cbLayerReInit) {
        /////////////////consider grouping with ther layer fns, consider just doing this inside cLayers?????????
        var anObj = this; // for closure
        var thisImg = self.getMyImage();

        if (self.layers.getLayerById(layerId) == undefined) {
            // ('layerReInit: layer does not exist! layerId: ' + layerId); // eslint-disable-line no-undef
            return;
        }

        var imageId = thisImg.getImageId();
        var xml = '<ImageId>' + imageId.substr(1) + '</ImageId>' + '<AnnotationId>' + layerId + '</AnnotationId>';
        thisImg.ajax.doDATASVRREQ(cbSuccessFn, cbFailureFn, 'GetAnnotations2', xml, {
            request: 'GetAnnotations2',
            imageId: imageId
        });
        return;

        //..................................................
        // closure functions
        //............................................ cbSuccessFn()
        // note the similarity here to paintInit
        function cbSuccessFn(data, textStatus, jqXHR) {
            var self = anObj;
            var x2js = new X2JS();
            var jsonObj_ = x2js.xml_str2json(data); // convert input xml to json object

            var jsLayer = jsonObj_.GetAnnotations2Response.AnnotationsNode.Annotations.Annotation;
            var aLayer = (0, _layer.createLayer)(jsLayer, 'x2js'); // create this layer object from json
            //todo: verify construction is ok?
            var strLayerDbg = '\n.....layer: ' + aLayer.toString(true);
            self.layers.replace(aLayer); // replace aLayer to cLayers collection

            var jsRegions = jsLayer.Regions; // has RegionAttributeHeaders, Region[]
            var nRegions = jsRegions.Region_asArray ? jsRegions.Region_asArray.length : 0;

            //todo: regions holds <RegionAttributeHeaders> where the ID here is that Attribute Name for a region...

            for (var r = 0, rlen = nRegions; r < rlen; r++) {
                var jsRegion = jsRegions.Region_asArray[r]; //

                var bRegion = self.regions.getByRegionId(jsRegion._Id);
                if (bRegion) // if the region already exists, remove it so it can be replaced
                    self.regions.remove(bRegion.get('rfId')); // remove() does NOT update DB nor signal ANNOTCHANGE

                var aRegion = new _region2.default(jsRegion, 'x2js', thisImg, aLayer, self); // create this region
                strLayerDbg += '\n             ...region #' + r + ' ' + aRegion.toString(true, false);

                if (aRegion.rfHandle) // if successfully drawn
                    self.regAdd(aRegion); // add the new region to the collection, don't save back to the db
            }

            if (opt_inputRegionId) // if the inputRegionId is defined
                aRegion = self.regions.getByProperty('InputRegionId', opt_inputRegionId); // then find the output region with this opt_inputRegionId
            if (aRegion) self.regSelect({ 'regionId': aRegion.get('regionId'), 'bReposition': true }); // and select the output region, show the markup
            if (opt_cbLayerReInit) // if a callback is defined
                opt_cbLayerReInit(aLayer.get('Id')); // then call it
        }

        //............................................ cbFailureFn()
        function cbFailureFn(jqXHR, textStatus, errorThrown) {
            var self = anObj;
            // ('GetAnnotations2: ' + thisImg.ajax.getErrorStr(jqXHR, self.getImageId())); // eslint-disable-line no-undef
            (0, _events.triggerUScopeEvent)(_defines2.default.evAJAXERROR, { imageId: self.getImageId(), request: 'GetAnnotations2', jqXHR: jqXHR });
        }

        //..................................................
    };

    //............................................ layerIsNamed
    // AnnotationsService.layerIsNamed - This function returns true if the passed layerId is that of the layer named 'LayerName'.
    //                This is useful to test if one is on the us.AnnotLayerName or us.ReportLayerName.
    CANNOT_LAYER.layerIsNamed = function (layerId, LayerName) {
        return self.layers.getLayerNameById(layerId) == LayerName ? true : false;
    };

    //............................................ regCopyTo
    //    AnnotationsService.regCopyTo
    //
    //        cpBaseCenter:    Point, base coord to center region at
    //        region:            Region,
    //
    //    potential issues:  adding to current layer, what if in a different image?  region needs to add to cRegions
    CANNOT_REGION.regCopyTo = function (cpBaseCenter, regionToCopy) {
        if (uScope.canAnnotate() == false) return;
        var thisImg = self.getMyImage();
        var paper = self.paper; // access to raphael for this image

        var layerId = self.chooseLayer(regionToCopy.get('type'));
        var regionId = self.regions.getNextRegionId(); // will return a negative value that is a signal to dataserver of a new region

        var aRegion = new _region2.default({
            layerId: layerId,
            regionId: regionId,
            displayId: -regionId,
            type: regionToCopy.type,
            angleDeg: regionToCopy.angleDeg,
            zoom: regionToCopy.zoom,
            decRGB: regionToCopy.decRGB,
            isReportRegion: regionToCopy.isReportRegion,
            pts: regionToCopy.copyPts()
        }, 'json', viewport, undefined, self);

        aRegion.centerAt(cpBaseCenter); // modify region points to center on input center pt

        (0, _annotdraw.rfDraw)(paper, aRegion, thisImg.getViewZoom(), thisImg.getViewAngle(true)); // draw this graphics object
        self.regAdd(aRegion, true, true); // add the new region to the collection and save back to the db
    };

    CANNOT_REGION.regCreate = function (_ref2) {
        var layerId = _ref2.layerId,
            type = _ref2.type,
            angleDeg = _ref2.angleDeg,
            zoom = _ref2.zoom,
            points = _ref2.points,
            _ref2$colorRgb = _ref2.colorRgb,
            colorRgb = _ref2$colorRgb === undefined ? _defines2.default.getRandomColor() : _ref2$colorRgb,
            _ref2$isReportRegion = _ref2.isReportRegion,
            isReportRegion = _ref2$isReportRegion === undefined ? false : _ref2$isReportRegion;
        var isExported = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var regionId = self.regions.getNextRegionId();
        var region = new _region2.default({
            layerId: layerId,
            regionId: regionId,
            displayId: -regionId,
            type: type,
            angleDeg: angleDeg,
            zoom: zoom,
            decRGB: colorRgb,
            isReportRegion: isReportRegion,
            pts: points
        }, 'json', viewport, undefined, self, isExported);

        (0, _annotdraw.rfDraw)(self.paper, region, zoom, angleDeg);

        self.regAdd(region, true, true);
    };

    //............................................ regAdd
    //    AnnotationsService.regAdd - This function ...
    CANNOT_REGION.regAdd = function (aRegion, bDoSave, bDoSelect) {
        self.regions.add(aRegion, bDoSave);

        //toconsider: this really doesn't belong here!!! I had to wait for the region to have a valid rfHandle but still... ol3 and all....perhaps the fn should move up to here
        aRegion.addEventHandlers({ click: true, hover: true, textclick: true }); // register the click and hover event handlers for this region

        // unselect the currently selected object and select this one (but don't reposition the view)
        if (bDoSelect) self.regSelect({ rfId: aRegion.rfId, bReposition: false, bSaveSel: false });
    };

    //............................................ regDelete
    //    AnnotationsService.regDelete - This function deletes the passed region object and updates, informs components and listeners.
    CANNOT_REGION.regDelete = function (regionId) {
        if (uScope.canAnnotate() == false) {
            return false;
        }

        var aRegion = self.regions.getByRegionId(regionId);
        if (aRegion) {
            if (aRegion.get('isTuningRegion') == true) {
                return false;
            }

            var rfId = aRegion.get('rfId');
            self.regions.del(rfId); // delete the region from the regions object and database

            // if the deleted region had be the selected region
            if (self.rfSelected == rfId && !self.regSelectNextPrev('next', false)) // select the next region but do not reposition the view
                self.rfSelected = -1; // insure that it is understood that nothing is selected

            annotationsPanel.enableDrawingIcons(uScope.canAnnotate()); // update the annotation drawing tools and navigation panel

            //todo: i wonder that the hover event handler s/b removed and if that would eliminate the need for this call and fn
            self.regHoverShow(false); // in case this region had hover note visible
            return true;
        }
    };

    //............................................ regMove
    CANNOT_REGION.regMove = function (cpBaseDist) {
        var region = self.getSelRegion(); // ref to the selected region
        var ptList = region.getPts();

        for (var i = 0, len = ptList.length; i < len; i++) {
            ptList[i].addPoint(cpBaseDist);
        }
        self.paintSelRegion(_defines2.default.DO_HIGHLIGHT); // force a repaint of this region and paint the highlight
    };

    //............................................ regMoveCenter
    CANNOT_REGION.regMoveCenter = function (cpBaseCenter) {
        var region = self.getSelRegion(); // ref to the selected region
        region.centerAt(cpBaseCenter); // modify region points to center on input cpCenter
        self.paintSelRegion(_defines2.default.DO_HIGHLIGHT); // force a repaint of this region but do not paint the highlight
    };

    //............................................ regAddNote
    //    regAddNote -
    CANNOT_REGION.regAddNote = function (note) {
        // add a note to the selected region
        (0, _toolbar.setIconState)($('.' + _defines2.default.APNOTE), _defines2.default.APNOTE, 'enabled');
        var region = self.getSelRegion();
        if (region) {
            region.addNote(note); // update note and save to database
            self.regHoverShow(true, region.rfId); // show the hover note on screen
        }
    };

    CANNOT_REGION.onAddImageText = function (crsrPos, onImageText) {
        (0, _toolbar.setIconState)($('#' + _defines2.default.APANNOTTEXT), _defines2.default.APANNOTTEXT, 'enabled');
        if (!onImageText || !uScope) return; // do nothing if the text is undefined

        if (onImageText[onImageText.length - 1] == '\n') {
            // strip off trailing carriage return
            onImageText = onImageText.substr(0, onImageText.length - 1);
        }

        onImageText = onImageText.substring(0, _defines2.default.textEditSpecs.maxChars); // limit number of characters

        if (crsrPos) {
            // if crsrPos is defined, add the region at crsrPos
            if (onImageText.length != 0) {
                // but don't add region if it has no content
                self.startNew(_defines2.default.eAnTypes.text, crsrPos, viewport.getViewZoom(), viewport.getViewAngle(true), onImageText);
            }
        } else {
            // else if no defined crsrPos the region text is being updated
            if (onImageText.length != 0) {
                // only change text if there is something to change (do not allow total clearing of on image text)
                self.regAddNote(onImageText); // update region and database
                (0, _annotdraw.rfDraw)(self.paper, self.getSelRegion()); // draw updated region
            }
        }
    };

    /**
     * This function selects or creates the appropriate layer for the passed annotation type and returns the layerId to
     * assign to the region. If a new region is being added to the report layer and there is already a report region,
     * that region is deleted.
     * @param anType
     * @returns {number} ID of the selected layer. A negative Id is returned if no layer can be selected.
     */
    self.chooseLayer = function (anType) {
        var layers = self.getLayersObj();
        var rtnSelLayerId = -1;

        if (anType == _defines2.default.eAnTypes.report) {
            // if anType is report, select/created report layer
            rtnSelLayerId = getSpecialLayerIdOrCreateIt(_defines2.default.ReportLayerName);
            if (rtnSelLayerId != -1) {
                layers.deleteRegions(rtnSelLayerId); // remove any existing regions from the report layer (since only one is allowed to exist)
            }
        } else {
            // otherwise we are creating an annotation that is not a report region
            var selLayer = layers.getSelected();
            if (selLayer) {
                // if selected layer is valid
                if (selLayer.get('isReportLayer') == false) {
                    // if selected layer is NOT a report layer
                    if (selLayer.get('Type') != _defines2.default.anLayerTypes.aafresult) rtnSelLayerId = selLayer.get('Id'); // as long as the currently selecte layer isn't a result layer, it will be used
                    else rtnSelLayerId = selLayer.get('InputAnnotationId'); // but if aafresult layer is currently selected, switch to its parent layer
                }
            }
        }

        if (rtnSelLayerId < 0) {
            // if the layerId is still not valid then just use/create annotation layer
            rtnSelLayerId = getSpecialLayerIdOrCreateIt(_defines2.default.AnnotLayerName);
        }

        layers.selectByProperty('Id', rtnSelLayerId); // now, finally, select that layer; note that passing in a -1 deselects all layers

        return rtnSelLayerId;

        /**
         * This function returns the selected layerId or -1 if not able to select it and requested it be created
         * @param layerName
         * @private
         */
        function getSpecialLayerIdOrCreateIt(layerName) {
            var layerId = layers.getLayerIdByName(layerName);
            if (layerId < 0) {
                // if the layer does not exist,
                layerId = layers.getProvisionalLayerId();
                layers.createAddSaveSpecial(layerName); // and create this special layer
            }
            return layerId;
        }

        //..................................................
    };

    (function construct() {
        self.events = viewport.events.$new(self, ['us:annotations:region-change']);
        // TODO: These should be exposed as a separate service
        self.regions = new _regions2.default(self, self.getImageId()); // create the one region collection; so much user interaction is on a region, direct ref to region is expedient
        self.layers = new _layerManager2.default(uScope, self, self.getImageId()); // create the one layer collection

        jAnnotDiv = $('<div/>', {
            'class': _defines2.default.clsANNOTDIV + ' ' + _defines2.default.clsGRAPHICS
        });

        // create the raphael paper tag inside the annot div
        self.paper = Raphael(jAnnotDiv[0], '100%', '100%');

        // NOTE: the following are raphael rendering bug fixes
        self.paper.renderfix(); // Fixes the issue of Firefox and IE9 regarding subpixel rendering.
        self.paper.safari(); // There is an inconvenient rendering bug in Safari (WebKit): sometimes the rendering should be forced.

        viewport.renderer.addLayer({
            container: jAnnotDiv[0],
            updatePosition: updatePosition,
            zoomChange: zoomChange,
            rotateChange: rotateChange
        });

        viewport.ajax.queryImageServer('GETANNOTATIONS').then(onSuccess).fail(onFailure);

        function onSuccess(data, textStatus, jqXHR) {
            self.init(jqXHR.responseText); // initialize the annotations class
        }

        function onFailure(jqXHR, textStatus, errorThrown) {
            self.setStatus(false); // indicate that GETANNOTATIONS failed
            // ('GETANNOTATIONS: ' + viewport.ajax.getErrorStr(jqXHR, self.getImageId())); // eslint-disable-line no-undef
            (0, _events.triggerUScopeEvent)(_defines2.default.evAJAXERROR, { imageId: self.getImageId(), request: 'GETANNOTATIONS', jqXHR: jqXHR });
        }
    })();
}

// getAnTypeButtonClass - This function returns the button element class of the annotation type for the passed region or undefined
_defines2.default.getAnTypeButtonClass = function (aRegion) {
    var className;
    var anType = (0, _helpers.isDefined)(aRegion) ? +aRegion.get('type') : -1;

    if (anType >= 0) {
        // get the element id of the selected annotation type
        if (anType === _defines2.default.eAnTypes.pen) className = _defines2.default.APANNOTPEN;else if (anType === _defines2.default.eAnTypes.negpen) className = _defines2.default.APANNOTNEGPEN;else if (anType === _defines2.default.eAnTypes.rect && aRegion.get('isReportRegion')) className = _defines2.default.APANNOTREPORT;else if (anType === _defines2.default.eAnTypes.rect) className = _defines2.default.APANNOTRECT;else if (anType === _defines2.default.eAnTypes.ellipse) className = _defines2.default.APANNOTELLIPSE;else if (anType === _defines2.default.eAnTypes.arrow) className = _defines2.default.APANNOTARROW;else if (anType === _defines2.default.eAnTypes.pin) className = _defines2.default.APANNOTPIN;else if (anType === _defines2.default.eAnTypes.ruler) className = _defines2.default.APANNOTCALIPER;else if (anType === _defines2.default.eAnTypes.caliper) className = _defines2.default.APANNOTCALIPER;else if (anType === _defines2.default.eAnTypes.text) className = _defines2.default.APANNOTTEXT;else if (anType === _defines2.default.eAnTypes.polygon) className = _defines2.default.APANNOTPOLY;
    }
    return className;
};

// getRandomColor - This function returns a random color selection from us.colorPalette (in hex RGB format)
_defines2.default.getRandomColor = function () {
    var r = parseInt(Math.random() * _defines2.default.colorPalette.length);
    return _defines2.default.colorPalette[r];
};

function isValidArrayIndex(array, idx) {
    return !(idx < 0 || (0, _helpers.isUnDefined)(array[idx]));
}
module.exports = exports['default'];

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _layerFactory = __webpack_require__(148);

Object.defineProperty(exports, 'createLayer', {
  enumerable: true,
  get: function get() {
    return _layerFactory.createLayer;
  }
});

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Region;

var _lbsPiDash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lbsPiDash);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _objects = __webpack_require__(16);

var _annotdraw = __webpack_require__(147);

var _helpers = __webpack_require__(4);

var _uScope = __webpack_require__(78);

var _uScope2 = _interopRequireDefault(_uScope);

var _xinfo = __webpack_require__(307);

var _xinfo2 = _interopRequireDefault(_xinfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//________________________________________________________________________________________________
// region.js
/**
 * @file   example_action.h
 * @Author Me (me@example.com)
 * @date   September, 2008
 * @brief  Brief description of file.
 *
 * Detailed description of file.
 */
//    This file contains the annotation region object 'Region' (single annotation region).
//
//    history
//
//    1302    cperz    created
//    _______________________________________end_AIHv1/PR __________________________________________
//    141118    cperz    ol3 integration
//    141222    cperz    created to support image analysis; change call from ajaxXXXCall to doDATASVRREQ and doIMGSRVREQ
//    150318    cperz    build out for analysis and markup;
//                    update for doIMGSRVREQ signature change; construct: remove jquery option;
//    _______________________________________12.3 __________________________________________________
//    150612    cperz    construct_: draw with intiial view angle
//    150615    cperz    onSelectChange: comment update
//________________________________________________________________________________________________
//    Object Name: Region
//    Overview:  The Region object is a container for region information and is used as a reference
//                between graphics in raphael paper and the annotation xml.
//
//    mu : MarkUp
//________________________________________________________________________________________________

//    Region
//    inObj:        req'd, object containing properties for to-be-created region object
//    inObjType:    req'd, type of inObj: {'json', 'x2js' or 'jquery'}
//    vpObj:        req'd, cViewport object
//    aLayer:        req'd only when inObjType == 'x2js'; a ref the cLayer this region belongs to

function Region(props, propSource, viewport, layer, annotationsService, isExported) {
    var self = this;
    var paper = annotationsService.paper;

    var CREGION = this;
    var CREGION_GET = this;
    var CREGION_SET = this;
    var CREGION_MARKUP = this;
    var CREGION_ANALYSIS = this;
    var CREGION_POINTS = this;
    var CREGION_DEBUG = this;

    // in/out from database ................................
    //toconsider: I'd like to use the XML node names exactly here instead
    self.regionId = 0; // current or new region id - never equal to 0
    self.displayId = 0; // display id
    // note that selected is not maintained in this object
    self.Analyze = false; // means 'can run analysis', s/b in agreement with us.eAnAnalysis[self.type]

    self.type = -1; // as given by us.eAnTypes[]
    self.shape = undefined; // as given by us.anShapes[]
    self.decRGB = undefined; // decimal value of color in RGB order
    self.decBGR = undefined; // and color in BGR order too

    self.zoom = 1.0; // zoom at time of orignal drawing
    self.pts = []; // array of Points at base zoom

    self.note = undefined; // text associated with this region
    self.data = {}; // associative array for related data such as caliper distance measures

    // analysis related
    self.InputRegionId = undefined; // parent region, 0 means no parent (not analysis),  -1 means whole image
    self.MarkupImageId = undefined; // either undefined or valid markup image id with the @ sign for internal use (saved without it)
    self.MacroId = undefined; // copied from layer
    self.MacroName = undefined; // copied from layer

    // derived .............................................
    self.isHighLight = false; // indicate region for hightlight outline
    self.isReportRegion = false; // indicate report region status

    self.openShape = false; // openShape is a flag for rfDraw, when true the form is not closed(while user is drawing); matters only to pen, polygon,

    self.imageId = viewport ? viewport.getImageId() : 0;
    self.layerId = 0; // associated layer id; never is a layer id 0

    self.rfHandle = undefined; // the raphael object associated with this region
    self.rfId = -1; // raphael id and used as index of region in rfRegions[]

    // geometry
    self.centerPt = new _objects.Point(-1, -1); // computed center of pts array, use getCenter() to compute & access
    self.boundingBox = new _objects.BoundingBox(0, 0, 0, 0); // region or markup bounding box in base coords (pixels) at zoom = 1
    self.angleDeg = 0.0; // view rotation angle at time of orignal drawing

    // analysis and markup image related
    self.isSmall = false; // relatively speaking, is this a small region at scan resolution? see notes on us.IMAGESERVER_MAXJDIM
    self.isAnalyzed = false;
    self.hasMarkup = false; // has an associated analysis markup image
    self.isWholeSlide = false; // whole image analysis region
    self.isWholeSlideMarkup = false; // whole image analysis region with markup

    // markup xinfo
    self.xinfo = undefined; // markup image xinfo
    self.muInitialized = false; // markup image xinfo initialized
    self.AlgorithmName = undefined; // markup algorithm name
    self.tileWidth = 512;
    self.tileHeight = 512; // markupmarkup tile dimensions; default to something so even if xinfo for markup isn't yet returned the render will work

    //////////////////////////////////////////////////////todo: ia related .... still in work
    var attributes = {};
    CREGION_ANALYSIS.getRegionResults = function () {
        return attributes;
    };
    CREGION_ANALYSIS.getRegionResultsLength = function () {
        return (0, _helpers.assocArrayLength)(attributes);
    };
    CREGION_ANALYSIS.clearRegionResults = function () {
        attributes = {};
    };
    //////////////////////////////////////////////////////

    CREGION_GET.get = function (str) {
        return this[str];
    };
    CREGION_SET.set = function (key, value) {
        this[key] = value;
    };

    //............................................ simple gets
    CREGION_GET.getType = function () {
        return self.type;
    };
    CREGION_GET.getShape = function () {
        return self.shape;
    }; //todo: better is use anShapes[] and don't keep this var
    CREGION_GET.getZoom = function () {
        return self.zoom;
    };
    CREGION_GET.getRegionId = function () {
        return self.regionId;
    };
    ///    region_get.getRfId = function () { return self.rfId; };
    CREGION_GET.getRGB = function () {
        return self.decRGB;
    };
    CREGION_GET.getBGR = function () {
        return self.decBGR;
    };

    CREGION_GET.getLayerId = function () {
        return +self.layerId;
    };

    CREGION_ANALYSIS.getInputRegionId = function () {
        return self.InputRegionId;
    }; //
    CREGION_ANALYSIS.getMacroId = function () {
        return self.MacroId;
    }; // from layer originally
    CREGION_ANALYSIS.getMacroName = function () {
        return self.MacroName;
    }; // from layer originally

    //............................................ markup getMarkupImageId
    CREGION_MARKUP.getMarkupImageId = function () {
        return self.MarkupImageId;
    };

    //............................................ Region markupIsInView
    //    markupIsInView: returns true if region has a markup and it is in the passed view rect; otherwise false;
    CREGION_MARKUP.markupIsInView = function (cr2View) {
        return self.hasMarkup ? self.isInView(cr2View) : false;
    };
    //............................................ Region getMarkupInfo
    var markupInfo = {}; // Region local var, cached markup info
    CREGION_MARKUP.getMarkupInfo = function () {
        if (markupInfo.AlgorithmName == undefined) {
            // if this xinfo var has not been set in the object then the object has not been populated yet
            computeGeometry_(); // insure geometry is up to date
            markupInfo = {
                hasMarkup: self.hasMarkup,
                muInitialized: self.muInitialized,
                AlgorithmName: self.AlgorithmName,
                // could get macro name and id from layer? getMacroName()
                regionId: self.regionId,
                MarkupImageId: self.MarkupImageId,
                boundingBox: self.boundingBox,
                zoom: self.zoom,
                isSmall: self.isSmall,
                tileWidth: self.tileWidth,
                tileHeight: self.tileHeight
            };
        }
        return markupInfo;
    };
    //............................................ Region constructor
    // This function construct the region given either a json or x2js input object.
    // notes:
    //        o event handlers not added because rfId is needed
    //        o analysis results including markup imagery are not fetched at this time

    var construct_ = function construct_() {
        if (propSource == 'json') {
            // is input is json?  json used to create from user input
            var json = props;
            _.assign(self, props);

            if (self.rfHandle) self.rfId = self.rfHandle.id;
            if ((0, _helpers.isDefined)(json.type)) self.setType(+json.type); // remember this sets things related to type as well
            if (json.decRGB) self.setRGB(json.decRGB);
            if (json.decBGR) self.setBGR(json.decBGR);
            if (json.MarkupImageId) self.MarkupImageId = '@' + json.MarkupImageId; // prepend @ sign - all image id's are in this format internally

            if (self.shape == 'caliper' || self.shape == 'polygon') // update length for shapes that require it
                self.computeLength();

            //ia-todo: do derived stuff like isWholeSlideMarkup, ...
        } else if (propSource == 'x2js') {
            // input is x2js object? x2js is used to create from xml input from dataserver
            if (layer == undefined) {
                // layer is required input
                // ('Layer ref is required for object type x2js'); // eslint-disable-line no-undef
                return;
            }
            if (!(props.Vertices && props.Vertices.Vertex_asArray)) {
                // sometimes regions without vertices are showing,  so just abort region creation
                // ('Object type x2js does not contain vertices'); // eslint-disable-line no-undef
            }

            self.layerId = layer.get('Id');
            //should I get the layer name, it can change right?
            self.MacroId = layer.get('MacroId'); // cache the layer info needed for analysis presentation
            self.MacroName = layer.get('MacroName');

            self.regionId = props._Id; // '_item' is access to attribute 'item' of Region node
            //todo: probably if a region is selected then its layer should be selected
            //?move back is currently in annot?            var Selected = props._Selected === "1" ? true : false;///if moved here, update onSelectChange()

            // Use InputRegionId to determine if this is an analysis region
            //	and use a combo of regionId and InputRegionId to determine if this is wholeslide or tuning region (geez)
            //						TuningRegion	WholeSlide		AnalysisInput	AnalysisOutput
            //						------------	----------		-------------	--------------
            //	InputRegionId		-1				-1				undefined		positive
            //	RegionId			negative		positive		positive		positive
            //	ImageLocation		defined			defined			undefined		defined

            self.InputRegionId = props._InputRegionId && props._InputRegionId != '0' ? +props._InputRegionId : undefined;

            if (self.InputRegionId) {
                // this an analysis output region if the InputRegionId is defined
                //  a value of -1 means whole image or tuning region
                self.isAnalyzed = true;
                ////////self.isWholeSlide = (self.InputRegionId < 0) ? true : false;
                if (self.InputRegionId < 0) {
                    // InputRegionId is negative for tuning region and for whole slide
                    if (self.regionId < 0) self.isTuningRegion = true; // regionId is negative for tuning region and positive for whole slide
                    ///todo: remove layer's knowledge?  self.isTuningRegion = layer.get('isTuningLayer');
                    self.isWholeSlide = !!self.isTuningRegion;
                }

                // note: that the markup image is dimensioned only as large as it needs to be;  it is tiled but these tiles are not registered with image tiles, they align with the ROI

                //	Use ImageLocation to get MarkupImageId because it is defined for tuning, wholeslide and analysis output regions
                //						TuningRegion	WholeSlide		AnalysisInput	AnalysisOutput
                //						------------	----------		-------------	--------------
                //	MarkupImageId		undefined		defined			undefined		defined
                //	ImageLocation		defined			defined			undefined		defined
                self.MarkupImageId = props._ImageLocation ? props._ImageLocation : undefined; // the imageId of a markup, can be undefined
                ////	self.MarkupImageId = props._MarkupImageId ? '@' + props._MarkupImageId : undefined; // the imageId of a markup, can be undefined
                self.TempImageLocation = props._TempImageLocation ? props._TempImageLocation : undefined; // tuning only: the server's path to the markup image

                self.hasMarkup = self.MarkupImageId ? true : false;
                self.isWholeSlideMarkup = self.isWholeSlide ? self.hasMarkup : false; //flag that this region is whole image analysis with a markup
                ///				self.isWholeSlideMarkup = (self.InputRegionId < 0) ? self.hasMarkup : false; //flag that this region is whole image analysis with a markup

                //todo: move this search to cRegions
                var regionParent = self.InputRegionId != -1 ? annotationsService.getRegionsObj().getByRegionId(self.InputRegionId) : undefined; // the parent region of this region
                if (regionParent) {
                    var anType = regionParent.get('type'); // if Type is from parent region b/c iscope keeps changing output region rects to pen
                    self.setType(anType);
                    self.zoom = regionParent.get('zoom');
                } else {
                    // valid InputRegionId but no regionParent
                    self.setType(_defines2.default.eAnTypes.rect); //  defaults to a rect region type and scan resolution
                    self.zoom = 1.0;
                }

                if (props.Attributes) {
                    var IdNameLUT = layer.getRegionResultsLUT();

                    var regAttrs = props.Attributes;
                    for (var a = 0, alen = regAttrs.__cnt; a < alen; a++) {
                        var attr = regAttrs.Attribute[a];
                        if (attr == undefined) // because of same problem mentioned for layer attributes
                            break;

                        var Name = IdNameLUT[attr._Name] ? IdNameLUT[attr._Name] : attr._Name;
                        attributes[Name] = attr._Value;
                        if (IdNameLUT[attr._Name] == undefined) {
                            // if the look up failed
                            // ('Region Attributes numeric name: ' + attr._Name + ' has no match in Regions.RegionAttributeHeaders'); // eslint-disable-line no-undef
                        }
                    }
                }
                //no DisplayId??? but defined on output regions
            } else {
                // this is a non-analysis region
                self.setType(props._Type);
                var NegativeROA = props._NegativeROA == '1';
                if (self.type == _defines2.default.eAnTypes.pen && NegativeROA) // if negativeROA indicated, switch to negative pen type
                    self.setType(_defines2.default.eAnTypes.negpen);

                var Zoom = 1. / props._Zoom; // the annotation zoom is the inverse of the image zoom
                self.zoom = (0, _helpers.roundToDecimals)(Zoom);

                // not impl var ImageFocus = props._ImageFocus;

                self.displayId = props._DisplayId;
                self.isReportRegion = layer.get('isReportLayer');
            }

            self.Analyze = _defines2.default.eAnAnalysis[self.type] ? true : false; // means can run analysis

            // LineColor for a region is only valid on the layer named 'Annotation'
            var RegionBGR = layer.get('isAnnotLayer') && props._LineColor ? props._LineColor : layer.get('LineColor');
            self.setBGR(RegionBGR);

            var jsVertex = props.Vertices.Vertex_asArray;
            self.pts = jsVertexToPtList(jsVertex);

            if (props._Length) {
                // ImageScope saves attribute "Length" (pixels)
                self.data.lengthPixels = props._Length; // add additional info to region.data
                self.data.lengthMicrons = distance_({ 'value': self.data.lengthPixels, 'toMicrons': true });
            } else if (props._LengthMicrons) {
                // WebScope saves attribute "LengthMicrons"
                self.data.lengthMicrons = props._LengthMicrons;
                self.data.lengthPixels = (self.data.lengthMicrons / viewport.getMPP()).toFixed(1);
            }
            //todo: what to do about area input?
            //if (jRegion.attr("Area")) {                                // ImageScope saves attribute "Area" (pixels)
            //else if (jRegion.attr("AreaMicrons")) {                    // WebScope saves attribute "AreaMicrons"

            self.note = props._Text ? _.unescape(props._Text) : '';

            // flag to enable drawing of this region; e.g. tuning window's temp region is not drawn
            var doDraw = props.doDraw != undefined ? props.doDraw : true;
            if (doDraw) {
                self.rfHandle = (0, _annotdraw.rfDraw)(paper, self, viewport.getViewZoom(), viewport.getViewAngle(true)); // draw this graphics object
                if (self.rfHandle) {
                    self.rfId = self.rfHandle.id;
                } else {
                    // ('construct_: rfId: ' + self.rfId + ' Drawing failed'); // eslint-disable-line no-undef
                    return;
                }
            }
        } else {
            // ('construct_: unrecognized propSource: ' + propSource); // eslint-disable-line no-undef
            return;
        }

        if (self.decRGB == undefined) // if region color was not defined, randomly select a color
            self.setRGB((0, _helpers.hexColortoRGB)(_defines2.default.getRandomColor()), false);
        computeGeometry_(); //

        //todo: I get the markup without needing its xinfo.  Waiting to see if I need its xinfo for anything
        //      It is best not to have to get it if I don't have to
        //if (us.ENABLEANALYSIS && self.hasMarkup) self.initMarkup();
        return true;

        //..................................................
        // closure functions
        //............................................ initMarkup
        function initMarkup() {
            if (self.hasMarkup) viewport.ajax.doIMGSRVREQ(cbSuccessFn, cbFailureFn, 'XINFO', {
                'request': 'XINFO',
                'imageId': self.imageId
            }, 'xml', self.MarkupImageId);
            return;
            //............................................ cbSuccessFn
            function cbSuccessFn(data, textStatus, jqXHR) {
                self.xinfo = new _xinfo2.default(self.MarkupImageId);
                self.xinfo.init(data, self.MarkupImageId); // decode the markup's xinfo

                self.AlgorithmName = self.xinfo.getAlgorithmName(); // save anything useful from markup's xinfo now
                self.tileWidth = self.xinfo.tileWidth * _defines2.default.kTILEMULTIPLIER; //note that a markup's tile dims is not nec. the same as its parent tile dims
                self.tileHeight = self.xinfo.tileHeight * _defines2.default.kTILEMULTIPLIER;

                self.xinfo = undefined; // to free up memory
                self.muInitialized = true; // indicate markup info is initialized
            }

            //............................................ cbFailureFn()
            function cbFailureFn(jqXHR, textStatus, errorThrown) {
                // ('doXINFO: (markup image): ' + viewport.ajax.getErrorStr(jqXHR, self.MarkupImageId)); // eslint-disable-line no-undef
            }

            //..................................................
        }

        //............................................ jVertexToPtList
        //    jVertexToPtList - This function converts a jq object of x,y vertices to an array of Points
        function jVertexToPtList(jVertex) {
            var ptList = [];
            for (var v = 0, vlen = jVertex.length; v < vlen; v++) {
                var x = jVertex.eq(v).attr('X');
                var y = jVertex.eq(v).attr('Y');
                var pt = new _objects.Point(x, y);
                ptList.push(pt);
            }
            return ptList;
        }

        //    jsVertexToPtList - This function converts a x2js object of x,y vertices to an array of Points
        function jsVertexToPtList(jsVertex) {
            var ptList = [];
            for (var v = 0, vlen = jsVertex.length; v < vlen; v++) {
                var x = jsVertex[v]._X;
                var y = jsVertex[v]._Y;
                var pt = new _objects.Point(x, y);
                ptList.push(pt);
            }
            return ptList;
        }
    };
    //............................................ removeGraphics()
    CREGION.removeGraphics = function () {
        if (self.rfHandle) // remove the region from the graphics paper
            self.rfHandle.remove();

        if (self.data.rfTextHandle) // remove any custom handles
            self.data.rfTextHandle.remove();
        if (self.data.textBBoxHandle) self.data.textBBoxHandle.remove();
    };

    //............................................ addEventHandlers()
    // note: event handlers for region can only be added after region is drawn and has a valid rfHandle
    CREGION.addEventHandlers = function (json) {

        if (self.isWholeSlide == false && self.rfHandle) {
            if (json.click && json.click == true) self.rfHandle.click(cb_regClick); // register the click handler
            if (json.hover && json.hover == true) self.rfHandle.hover(cb_regHover); // register the hover hanlder

            if (json.textclick && json.textclick == true) {
                var rfTextHandle = self.data.rfTextHandle;
                if (rfTextHandle) {
                    rfTextHandle.click(cb_regClick); // register the buddy text for on click events
                    rfTextHandle.data('parentRfId', self.rfId); // save parent id so it can be used as the highlighted graphic
                }
            }
        } else {
            // (' addEventHandlers: not added, rfHandle: ' + self.rfHandle); // eslint-disable-line no-undef
        }
        //..................................................
        // closure functions
        //............................................ cb_regClick()
        // This function sorts out the parent region for a click (associated text is a child region)
        function cb_regClick() {
            // note that self is Region, this is raphael object
            if ((0, _helpers.isDefined)(self.id)) {
                var parentId = self.data('parentRfId');
                if ((0, _helpers.isDefined)(parentId)) // if the annot has a parent, select the parent  (buddy text annots haveparentRfId)
                    annotationsService.regSelect({ rfId: parentId, bReposition: false }); // unselect the currently selected parent object and select this one
                else annotationsService.regSelect({ rfId: self.id, bReposition: false }); // unselect the currently selected object and select this one
            }
        }

        //............................................ cb_regHover()
        //    This function is the region hover callback. It displays a hovering note associated with the region, if it exists.
        function cb_regHover() {
            annotationsService.regHoverShow(true, self.id); // note that self is Region, this is raphael object
        }

        //..................................................
    };

    CREGION_GET.isSelected = function () {
        return annotationsService.rfSelected === self.rfId;
    };

    //............................................ simple computations
    CREGION.computeLength = function () {
        if (self.getPtsLen()) {
            self.data.lengthPixels = distance_({ 'pointList': self.getPts() });
            self.data.lengthMicrons = distance_({ 'value': self.data.lengthPixels, 'toMicrons': true });
        }
    };
    //............................................ setRegionId
    CREGION_SET.setRegionId = function (regionId) {
        self.regionId = regionId;
    };
    //............................................ setType
    CREGION_SET.setType = function (type) {
        self.type = +type;
        self.shape = _defines2.default.anShapes[self.type];
        self.openShape = self.type == _defines2.default.eAnTypes.pen || self.type == _defines2.default.eAnTypes.caliper ? true : false;
        self.Analyze = _defines2.default.eAnAnalysis[self.type] ? true : false; // means can run analysis
    };
    //............................................ setRGB
    CREGION_SET.setRGB = function (decRGB) {
        self.decRGB = decRGB;
        self.decBGR = (0, _helpers.reverseCLR)(decRGB);
    };
    //............................................ setBGR
    CREGION_SET.setBGR = function (decBGR) {
        self.decBGR = decBGR;
        self.decRGB = (0, _helpers.reverseCLR)(decBGR);
    };
    //............................................ region onSelectChange
    //        bSelect:        required, true/false, save state as selected/deselected
    //        cb_function:    optional, response callback function
    CREGION_SET.onSelectChange = function (bSelect) {
        // note that the region doesn't keep a var that it is selected

        var bSelect = (0, _helpers.isUnDefined)(bSelect) || bSelect == false ? 0 : 1; // convert bSelect to 0,1
        var layerXML = '<Annotation Id="' + self.layerId + '" Selected="' + bSelect + '">'; // do not include closing tag
        var regionXML = '<Region Id="' + self.regionId + '" Selected="' + bSelect + '"></Region>';

        annotationsService.save({
            action: 'updateRegionAndLayer', layerId: self.layerId, layerXML: layerXML,
            regionId: self.regionId, regionXML: regionXML
        });
    };
    //............................................ region addNote
    CREGION.addNote = function (note) {
        if (note == undefined) note = '';
        self.note = noteFormat_(note); // limit # chars and insert line feeds for display

        if (_uScope2.default.instance.canSaveAnnotations()) {
            // if incremental save is enabled, automatically update the database
            var regionXML = '<Region Id="' + self.regionId + '"' + ' Text="' + _.escape(self.note) + '"' + '></Region>';
            annotationsService.save({ action: 'updateRegion', layerId: self.layerId, regionXML: regionXML });
        }
        //..................................................
        // closure functions
        //............................................ noteFormat
        //    noteFormat - This function limits the number of characters and adds newlines for display.
        function noteFormat_(note) {
            if (note[note.length - 1] == '\n') // strip off trailing carriage return
                note = note.substr(0, note.length - 1);
            var oNote = note.substring(0, _defines2.default.textEditSpecs.maxChars); // limit number of characters
            var words = oNote.split(' '); // split into words
            var rtnNote = ''; // return string

            var line = words[0]; // line of text
            var curWidth = 0; // current line width
            var goalWidth = _defines2.default.textEditSpecs.noteWidth; // display note width
            for (var i = 1, len = words.length; i < len; i++) {
                var crIndex = words[i].indexOf('\n');

                if (crIndex != -1) {
                    var words2 = words[i].split('\n'); // check for, handle user-defined carriage returns
                    if (words2.length == 2) {
                        // two words with user-defined cr between them
                        rtnNote += line + ' ' + words2[0] + '\n';
                        line = words2[1];
                        continue;
                    } else if (crIndex == 0) {
                        // user-defined cr at start of word
                        line += '\n';
                        words[i] = words2[0];
                        line = words2[1];
                        continue;
                    } else {
                        // user-defined cr at end of word
                        rtnNote += line + ' ' + words2[0] + '\n';
                        line = '';
                        continue;
                    }
                }
                if (words[i].length + line.length < goalWidth) {
                    line += ' ' + words[i];
                } else {
                    rtnNote += line + '\n';
                    line = words[i];
                }
            }
            if (line.length) rtnNote += line;
            return rtnNote;
        }

        //..................................................
    };

    //............................................ related to points
    CREGION_POINTS.clrPts = function () {
        self.pts = [];
    };
    CREGION_POINTS.getPts = function () {
        return self.pts;
    };
    CREGION_POINTS.getPtsLen = function () {
        return self.pts ? self.pts.length : 0;
    };
    CREGION_POINTS.setPtsLen = function (len) {
        if (len > -1) self.pts.length = len;
    };
    CREGION_POINTS.getPt = function (index) {
        return index < self.pts.length ? self.pts[index] : undefined;
    };
    CREGION_POINTS.addPt = function (pt) {
        self.pts.push(pt);
    };
    CREGION_POINTS.insertPt = function (pt, at) {
        self.pts.splice(at, 0, pt);
    };
    CREGION_POINTS.setPt = function (pt, index) {
        self.pts[index] = pt;
    };

    //............................................ region rotatePtsAbout
    CREGION_POINTS.rotatePtsAbout = function (angleDeg, cpOrigin, opt_precision) {
        if (angleDeg == 0) return;

        for (var p = 0, len = self.pts.length; p < len; p++) {
            self.pts[p].rotateAbout(angleDeg, cpOrigin, opt_precision);
        }

        return self.pts.length;
    };
    //............................................ region copyPts
    CREGION_POINTS.copyPts = function () {
        var curPts = self.pts;
        var newPts = [];
        for (var p = 0, len = curPts.length; p < len; p++) {
            var pt = new _objects.Point(curPts[p].x, curPts[p].y);
            newPts.push(pt);
        }
        return newPts;
    };
    //............................................ replacePts
    CREGION_POINTS.replacePts = function (ptList) {
        self.clrPts();
        if (ptList && ptList.length) {
            for (var p = 0, len = ptList.length; p < len; p++) {
                self.pts.push(new _objects.Point(ptList[p].x, ptList[p].y));
            }
        }
        return self.pts;
    };
    //............................................ centerAt
    CREGION_POINTS.centerAt = function (cpCenterNew) {
        var cpCenterCur = self.getCenter();
        var dx = cpCenterNew.x - cpCenterCur.x;
        var dy = cpCenterNew.y - cpCenterCur.y;

        for (var p = 0, len = self.pts.length; p < len; p++) {
            self.pts[p].x += dx;
            self.pts[p].y += dy;
        }
        self.getCenter(_defines2.default.WITHFORCE); // force update of center point
    };
    //............................................ thinOutPts
    CREGION_POINTS.thinOutPts = function (minDist) {
        var nPtsRemoved = 0;
        if (self.type != _defines2.default.eAnTypes.pen) return nPtsRemoved; // only thin out pen drawings

        var newPts = self.copyPts();
        var len = newPts.length;
        if (len > 5) {
            var TOOCLOSE = minDist == undefined ? 5 : minDist; // define what too closely spaced means
            var pt0 = newPts[0]; // left-adjacent point
            for (var p = 1; p < len; p++) {
                // compare adjacent point city block distance
                var pt1 = newPts[p]; // right-adjacent point
                if (pt1.cityBlockDistance(pt0) < TOOCLOSE) {
                    // if left and right adjacent points are"too close"
                    newPts[p].set(-1, -1); // then flag that the right one to be removed
                    nPtsRemoved++;
                } else {
                    pt0 = pt1; // otherwise the left-adjacent becomes the right adjacent
                }
            }
            var lastPt = newPts[len - 1]; // test the last point against the first point
            if (lastPt.x != -1 && newPts[0].cityBlockDistance(lastPt) < TOOCLOSE) {
                newPts[len - 1].set(-1, -1); // and flag that the last point to be removed
            }

            self.clrPts(); // copy valid points from newPts to self.pts
            var curPts = self.pts;
            len = newPts.length;
            for (var p = 0; p < len; p++) {
                if (newPts[p].x != -1) {
                    curPts.push(newPts[p]);
                }
            }
            computeGeometry_(); // recompute center point, bounding box
        }
        return nPtsRemoved;
    };
    //............................................ countDuplicates
    CREGION_POINTS.countDuplicates = function () {
        var dupCount = 0;
        for (var p = 1, len = self.pts.length; p < len; p++) {
            if (self.pts[p].isEqual(self.pts[p - 1])) dupCount++;
        }
        return dupCount;
    };
    //............................................ removeDuplicatePtsAtEnd
    CREGION_POINTS.removeDuplicatePtsAtEnd = function () {
        var dupCount = 0;
        var ptList = self.pts;
        var lastIdx = ptList.length - 1;

        var pt1 = ptList[lastIdx];
        var pt0 = ptList[lastIdx - 1];
        while (lastIdx > 1 && pt0.x == pt1.x && pt0.y == pt1.y) {
            dupCount++;
            ptList.length = ptList.length - 1; // remove pt1
            pt1 = pt0;
            lastIdx--;
            pt0 = ptList[lastIdx - 1];
        }
        computeGeometry_(); // recompute center point, bounding box
        return dupCount;
    };
    //............................................ setLastPtToFirstPt
    CREGION_POINTS.setLastPtToFirstPt = function () {
        if (self.pts.length) {
            var pt0 = self.pts[0];
            var pt99 = self.pts[self.pts.length - 1];
            if (pt0.x != pt99.x && pt0.y != pt99.y) {
                var pt = new _objects.Point(pt0.x, pt0.y);
                self.addPt(pt);
            }
        }
    };
    //............................................ region computeGeometry_
    // This function computes the center point and the bounding box of the region.
    //    Note that the center point is biased for regions with few points and first==last
    //    and that the center of the bbox could be used.

    var computeGeometry_ = function computeGeometry_() {
        // really I know pins are one point, just use them
        if (self.type == _defines2.default.eAnTypes.pin) {
            // Note that in the original code the line above referred to `this` rather than `self`, and `this` sometimes
            // pointed at `window`, so this branch never actually executed, so I'm not sure what it was supposed to do.
            // After correcting the context .setPoint started failing because self.pts[0] was empty. TODO: Figure out what it's supposed to be doing!
            if (self.pts.length) {
                self.centerPt.setPoint(self.pts[0]);
                //todo: implement bbox for pin, arrow, self.boundingBox.setxywh();
            }
        } else {
            if (self.pts.length) {
                var xsum = 0,
                    ysum = 0; // compute the centerPt once
                var xleft = Number.MAX_VALUE,
                    ytop = Number.MAX_VALUE; //
                var xright = Number.MIN_VALUE,
                    ybottom = Number.MIN_VALUE; //
                for (var p = 0, len = self.pts.length; p < len; p++) {
                    var x = +self.pts[p].x;
                    var y = +self.pts[p].y;
                    xsum += x;
                    ysum += y;
                    if (x < xleft) xleft = x;
                    if (y < ytop) ytop = y;
                    if (x > xright) xright = x;
                    if (y > ybottom) ybottom = y;
                }
                self.centerPt.set(xsum / self.pts.length, ysum / self.pts.length);
                self.centerPt.toInt();
                self.boundingBox.set(xleft, ytop, xright, ybottom);
                // Note that ImageServer has a limitation on the dimensions of its returned JPEG compressed image
                // (currently clipping each dimension to 2000 pixels). So this limitiation is used to define smallness.
                self.isSmall = self.boundingBox.w < _defines2.default.IMAGESERVER_MAXJDIM && self.boundingBox.h < _defines2.default.IMAGESERVER_MAXJDIM;
            }
        }
    };

    //............................................ getCenter
    CREGION_GET.getCenter = function (opt_bForce) {
        if (opt_bForce == false) {
            // if not forcing a recomputation
            // if centerPt has been computed or if it cannot yet be computed, return it
            if (self.centerPt.x > 0 || (0, _helpers.isUnDefined)(self.pts) || self.pts.length === 0) return self.centerPt;
        }
        computeGeometry_();
        return self.centerPt;
    };
    //............................................ getBBox
    CREGION_GET.getBBox = function (opt_bForce) {
        if (opt_bForce == false) {
            // if not forcing a recomputation
            // if boundingBox has been computed or if it cannot yet be computed, return it
            if (self.boundingBox.isZero() == false || (0, _helpers.isUnDefined)(self.pts) || self.pts.length === 0) return self.boundingBbox;
        }
        computeGeometry_();
        return self.boundingBbox;
    };
    //............................................ Region isInView
    CREGION.isInView = function (cr2View) {
        return self.boundingBox.hasOverlap(cr2View);
    };
    CREGION_GET.getIntersectRect = function (cr2View) {
        return self.boundingBox.getIntersectRect(cr2View);
    };

    //............................................ getStrokeWidth
    //toconsider-could have var of strokeWidth in the region and only return differently if isHighLight - faster
    CREGION_GET.getStrokeWidth = function () {
        if (self.isHighLight && _uScope2.default.instance.isRegionCopyActive()) return _defines2.default.annotSpecs.strokeWidthCopyMove;else if (self.shape == 'pin') return _defines2.default.annotSpecs.strokeWidthPin;else if (self.shape == 'text') return _defines2.default.annotSpecs.strokeWidthTextBorder;else return _defines2.default.annotSpecs.strokeWidth;
    };
    //............................................ buildXML
    //    buildXML - This function converts a Region to XML
    //        input parameters:
    //            selected {true, false}
    // note:
    //        o region type of negative pen is translated to a pen with a NegativeROA for backward compatibility
    //        o region type of polygon is translated to a pen for backward compatibility
    //        o region LineColor is saved as BGR for backward compatibility
    //        o Analyze is saved but should not be known to any viewer, still probably need it for backward compatibility
    //        o InputRegionId is set and saved by AAF; ImageScope defaults a parent region's value to "0"

    CREGION.buildXML = function (selected) {

        // if my local type is negative pen, save it as a pen (with NegativeROA set)
        var saveType = self.type == _defines2.default.eAnTypes.negpen ? _defines2.default.eAnTypes.pen : self.type;
        // if my local type is polygon, save it as a pen
        saveType = self.type == _defines2.default.eAnTypes.polygon ? _defines2.default.eAnTypes.pen : self.type;

        var regionXML = '<Region Id="' + self.regionId + '"' + ' Type="' + saveType + '"' + ' Zoom="' + 1. / self.zoom + '"' // the annotation zoom is the inverse of the image zoom
        + ' Selected="' + ((0, _helpers.isUnDefined)(selected) || selected == false ? 0 : 1) + '"' + ' LineColor="' + self.decBGR + '"'
        //        + ' ImageLocation=""'
        //        + ' ImageFocus=""'
        + ' NegativeROA="' + (self.type == _defines2.default.eAnTypes.negpen ? 1 : 0) + '"' + ' InputRegionId="' + (self.InputRegionId ? self.InputRegionId : '0') + '"' + ' Analyze="' + _defines2.default.eAnAnalysis[self.type] + '"' + ' DisplayId="' + self.displayId + '"';
        if (self.data.lengthPixels) {
            regionXML += ' Length="' + self.data.lengthPixels + '"';
        }
        if (self.data.lengthMicrons) {
            regionXML += ' LengthMicrons="' + self.data.lengthMicrons + '"';
        }
        if (self.note) {
            regionXML += ' Text="' + _.escape(self.note) + '"';
        }
        regionXML += '>';

        if (isExported) {
            regionXML += '<Export>true</Export>';
        }

        var vertexXML = self.buildVertexXML();
        regionXML += '<Vertices>' + vertexXML + '</Vertices>' + '</Region>';
        return regionXML;
    };
    //............................................ buildVertexXML
    //    buildVertexXML - This function converts an array of Points to XML
    CREGION.buildVertexXML = function () {
        var ptList = self.getPts();
        var str = '';
        for (var v = 0, vlen = ptList.length; v < vlen; v++) {
            str += '<Vertex X="' + ptList[v].x + '" Y="' + ptList[v].y + '"></Vertex>';
        }return str;
    };
    //............................................ toStringShort
    CREGION_DEBUG.toStringShort = function () {
        var str = ' rfId:' + self.rfId + '  regionId:' + self.regionId + '  InputRegionId:' + self.InputRegionId + '  layerId:' + self.layerId + ' shape:' + self.shape;
        if (self.isAnalyzed) str += ' isAnalyzed:' + self.isAnalyzed;
        if (self.isTuningRegion) str += ' isTuningRegion: ' + self.isTuningRegion;
        if (self.MarkupImageId) {
            str += ' isSmall:' + self.isSmall + ' MarkupImageId:' + self.MarkupImageId;
            if (self.isWholeSlideMarkup) str += '  isWholeSlideMarkup: ' + self.isWholeSlideMarkup;
        }

        //debug-only str += "\n                           center:" + self.centerPt.toString() + "  bbox:" + self.boundingBox.toString(); ////////temp
        //debug-only str += self.toStringPts();
        return str;
    };
    CREGION_DEBUG.toString = function (bReportResults, bReportPts) {
        var str = ' rfId:' + self.rfId + '   regionId:' + self.regionId + '   InputRegionId:' + self.InputRegionId + '   layerId:' + self.layerId + '\n                           shape:' + self.shape + '   type:' + self.type + '   angleDeg:' + self.angleDeg + ' zoom:' + self.zoom + '\n                           reportReg:' + self.isReportRegion + ' decRGB: #' + (0, _helpers.toHexColor)(self.decRGB) + ' displayId:' + self.displayId + '\n                           center:' + self.centerPt.toString() + '  bbox:' + self.boundingBox.toString() + ' Note:' + self.note;

        if (self.isAnalyzed) str += '     isAnalyzed: ' + self.isAnalyzed;
        if (self.isWholeSlideMarkup) str += ' isWholeSlideMarkup: ' + self.isWholeSlideMarkup;
        if (self.isTuningRegion) str += ' isTuningRegion: ' + self.isTuningRegion;
        if (self.MarkupImageId) str += '  isSmall: ' + self.isSmall + ' MarkupImageId: ' + self.MarkupImageId;

        if ($.isEmptyObject(self.data) == false) {
            str += '\n                           Data: ';
            for (var key in self.data) {
                str += key + ':' + self.data[key] + ' ';
            }
        }
        if (bReportResults == true && (0, _helpers.assocArrayLength)(attributes)) str += '\n                           Region Results (' + (0, _helpers.assocArrayLength)(attributes) + '):  ' + (0, _helpers.toStringAssoc)(attributes);

        if (bReportPts == true) str += self.toStringPts();
        return str;
    };
    //............................................ toStringPts
    CREGION_DEBUG.toStringPts = function () {
        var str = '\n                           Points: len:' + self.pts.length + ' \n';
        for (var i = 0; i < self.pts.length; i++) {
            str += self.pts[i].toString() + ', ';
        }return str;
    };
    //............................................ toStringPtDeltas
    CREGION_DEBUG.toStringPtDeltas = function (bReportPts) {
        var str = self.toString(false);
        if (bReportPts) {
            str += '\n                Points: len:' + self.pts.length + ' \n';
            var ptDiff = new _objects.Point();
            ptDiff.setPoint(self.pts[self.pts.length - 1]);
            ptDiff.subractPoint(self.pts[0]);
            str += ptDiff.toString();
            for (var i = 1; i < self.pts.length; i++) {
                ptDiff.setPoint(self.pts[i - 1]);
                ptDiff.subractPoint(self.pts[i]);
                str += ptDiff.toString();
            }
        }
        return str;
    };

    //    //............................................ reset
    //    self.reset = function () {
    //        if (self.rfHandle) rfHandle.remove();
    //        self.rfHandle = undefined;
    //        self.rfId = -1; // note that 0 is a valid rfId

    //        self.imageId = 0; self.layerId = 0; self.regionId = 0; self.displayId = 0;
    //        self.isReportRegion = false; self.isHighLight = false;
    //        self.shape = ""; self.type = 0; self.decRGB = 0xFF; self.decBGR = 0xFF0000;
    //        self.angleDeg = 0; self.zoom = 1.0; self.pts = []; self.centerPt.set(-1, -1);

    //        self.data = {}; // clear the associative array
    //    };


    //............................................ distance_
    //    Region.distance - This function computes the distance in pixels or microns of an array
    //                            of Points or of a passed value.
    // input parms:
    //        "pointList" :     an array of Point pixel values
    //        "value" :        the pixel value to convert to microns
    //        "toMicrons":    boolean, convert to microns

    var distance_ = function distance_(parms) {
        var distInPix = 0;
        if (parms.pointList) {
            var ptList = parms.pointList;
            for (var i = 1, len = ptList.length; i < len; i++) {
                var apt = ptList[i - 1];
                var bpt = ptList[i];
                distInPix += apt.distance(bpt);
            }
        } else if (parms.value) {
            distInPix = parms.value;
        }
        if (distInPix) return parms.toMicrons ? (0, _helpers.roundToNearset)(distInPix * viewport.getBaseMPP(), 10) : Math.round(distInPix);else return distInPix;
    };
    //............................................ construction
    construct_(props, propSource, layer);
}
module.exports = exports['default'];

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(544);

__webpack_require__(545);

__webpack_require__(546);

__webpack_require__(364);

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(20);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _annotationsPanel = __webpack_require__(365);

var _annotationsPanel2 = _interopRequireDefault(_annotationsPanel);

var _annotationsService = __webpack_require__(293);

var _annotationsService2 = _interopRequireDefault(_annotationsService);

var _keyboardHandler = __webpack_require__(369);

var _regionToolbar = __webpack_require__(373);

var _regionToolbar2 = _interopRequireDefault(_regionToolbar);

var _regionInteraction = __webpack_require__(372);

var _navigationService = __webpack_require__(371);

var _colorPicker = __webpack_require__(367);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _publicApi = __webpack_require__(6);

var _publicApi2 = _interopRequireDefault(_publicApi);

var _browserCompatibility = __webpack_require__(26);

__webpack_require__(147);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_publicApi2.default.plugins.register({
    name: 'us:color-picker',

    extends: 'uScope',

    canStart: function canStart() {
        return !_browserCompatibility.env.isIOS;
    },


    constructor: _colorPicker2.default
});

// TODO: figure out a more elegant way to include this stuff


_publicApi2.default.plugins.register({
    name: 'us:annotations:ui',

    extends: 'uScope',

    dependencies: ['us:color-picker', 'us:annotations:service-locator'],

    canStart: function canStart() {
        return !_browserCompatibility.env.isIOS;
    },


    constructor: function (_AnnotationsPanel) {
        (0, _inherits3.default)(AnnotationsPanelHack, _AnnotationsPanel);

        function AnnotationsPanelHack(uScope, colorPicker, serviceLocator) {
            (0, _classCallCheck3.default)(this, AnnotationsPanelHack);

            var _this = (0, _possibleConstructorReturn3.default)(this, (AnnotationsPanelHack.__proto__ || Object.getPrototypeOf(AnnotationsPanelHack)).call(this, uScope, colorPicker, serviceLocator));
            // HACK ALERT. The annotations service and ui have a circular dependency. This is a workaround. TODO: Untangle.


            var annotationsButton = $('<a/>', {
                'id': _defines2.default.TBANNOTPANEL,
                'class': _defines2.default.clsTBBUTTON + ' ' + _defines2.default.TBANNOTPANEL + '-e',
                'title': 'Open the annotation toolbox'
            });

            uScope.topToolbar.addButton(annotationsButton);
            return _this;
        }

        return AnnotationsPanelHack;
    }(_annotationsPanel2.default)
});

_publicApi2.default.plugins.register({
    name: 'us:annotations:service',

    extends: 'viewport',

    dependencies: ['us:annotations:ui', 'us:annotations:service-locator'],

    canStart: function canStart() {
        return !_browserCompatibility.env.isIOS;
    },


    constructor: function (_AnnotationsService) {
        (0, _inherits3.default)(AnnotationsServiceHack, _AnnotationsService);

        function AnnotationsServiceHack(uScope, viewport, annotationsPanel, serviceLocator) {
            (0, _classCallCheck3.default)(this, AnnotationsServiceHack);

            var _this2 = (0, _possibleConstructorReturn3.default)(this, (AnnotationsServiceHack.__proto__ || Object.getPrototypeOf(AnnotationsServiceHack)).call(this, uScope, viewport, annotationsPanel));

            var self = _this2;

            (0, _keyboardHandler.createKeyboardHandler)(uScope, viewport, self);

            // TODO: This listener is for the UI, not the service. Not even sure why it occurs on image open!
            viewport.events.on('viewport:image-opened', function () {
                // TODO: refactor uScope to use a "read only" flag, instead of "can annotate"
                annotationsPanel.enableDrawingIcons(uScope.canAnnotate()); // if the annotations panel is already visible, set the drawing icon state
            });

            viewport.events.on('viewport:image-close', function () {
                if (!_defines2.default.ENABLEANNOTSELSAVE) {
                    // if not saving selected annot each time the user selects one,
                    self.regSelectSaveAtClose(); // then the last selected has yet to be saved, do so
                }
            });

            // HACK ALERT. The annotations service, ui and a few others have circular dependencies. This is a workaround. TODO: Untangle.
            viewport.events.on('viewport:selected', function () {
                serviceLocator.activeViewport = viewport;
                serviceLocator.annotationsService = self;
            });

            uScope.events.on(_defines2.default.evREGIONSELECT, function (parms) {
                if (!serviceLocator.annotationsService) {
                    return;
                }
                serviceLocator.annotationsService.regSelect(parms);
            });

            viewport.annots = _this2;
            return _this2;
        }

        return AnnotationsServiceHack;
    }(_annotationsService2.default)
});

_publicApi2.default.plugins.register({
    name: 'us:annotations:region-toolbar',

    dependencies: ['us:annotations:ui', 'us:annotations:service-locator'],

    extends: 'viewport',

    canStart: function canStart() {
        return _defines2.default.ENABLECONTEXTMENU;
    },


    constructor: _regionToolbar2.default
});

_publicApi2.default.plugins.register({
    name: 'us:annotations:navigation-service',

    dependencies: ['us:annotations:service'],

    extends: 'viewport',

    canStart: function canStart() {
        return _defines2.default.ENABLECONTEXTMENU;
    },


    constructor: _navigationService.NavigationService
});

// TODO: Integrate this directly into region class
_publicApi2.default.plugins.register({
    name: 'us:annotations:region-interaction-hack',

    dependency: 'us:annotations:service-locator',

    extends: 'uScope',

    constructor: _regionInteraction.RegionInteraction
});

// HACK ALERT. The annotations service and ui have a circular dependency. This is a workaround. TODO: Untangle.
_publicApi2.default.plugins.register({
    name: 'us:annotations:service-locator',

    extends: 'uScope',

    constructor: function ServiceLocator() {
        (0, _classCallCheck3.default)(this, ServiceLocator);
    }
});

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AnnotationsPanel;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _toolbar = __webpack_require__(27);

var _helpers = __webpack_require__(4);

var _browserCompatibility = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AnnotationsPanel(uScope, colorPicker, serviceLocator) {
    var self = this;
    var jPanel;
    var namespace = '.annotpanel'; // namespace for attached events (note that some events are attached to body element of page)

    //............................................ enableDrawingIcons() public
    //    enableDrawingIcons - This function [en|dis]ables all annotation drawing tools
    //        and region specific tools of the annotation panel.
    this.enableDrawingIcons = function (bEnable) {
        var state = bEnable ? 'enabled' : 'disabled';
        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTPOLY), _defines2.default.APANNOTPOLY, state);
        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTPIN), _defines2.default.APANNOTPIN, state);
        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTNEGPEN), _defines2.default.APANNOTNEGPEN, state);
        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTPEN), _defines2.default.APANNOTPEN, state);
        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTRECT), _defines2.default.APANNOTRECT, state);

        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTARROW), _defines2.default.APANNOTARROW, state);
        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTCALIPER), _defines2.default.APANNOTCALIPER, state);
        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTREPORT), _defines2.default.APANNOTREPORT, state);
        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTELLIPSE), _defines2.default.APANNOTELLIPSE, state);
        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTTEXT), _defines2.default.APANNOTTEXT, state);

        self.enableRegionIcons();
    };

    //............................................ setColorPickerState_() public
    var setColorPickerState_ = function setColorPickerState_(state) {
        var annotationsService = serviceLocator.annotationsService;
        if (annotationsService) {
            var layerId = annotationsService.getSelLayerId(); // double check for R12.0: allow color picking on A-layer and R-layer only
            var canBeEnabled = annotationsService.layerIsNamed(layerId, _defines2.default.AnnotLayerName) || annotationsService.layerIsNamed(layerId, _defines2.default.ReportLayerName);
            if (!canBeEnabled) state = 'disabled';
        }
        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTCOLOR), _defines2.default.APANNOTCOLOR, state);
    };
    //............................................ enableRegionIcons() public
    //    enableRegionIcons - This function [en|dis]ables all region specific icons of the annotation panel
    //                        including the annotation navigation panel.
    //                        Note that the passed annotation object may not be defined (no image open)
    //                        and that this function must still set the icon states properly.
    this.enableRegionIcons = function (annotationsService) {
        if (!annotationsService && uScope.isThisImageValid()) {
            annotationsService = serviceLocator.annotationsService;
        }
        var state = 'disabled'; //
        var jIconButton;
        var region;

        if (annotationsService) {
            // if there's an image with an annotation object
            region = annotationsService.getSelRegion();
            state = region ? 'enabled' : 'disabled'; // state is enabled if there is a region selected (vs no regions existing)
            var buttonClass = _defines2.default.getAnTypeButtonClass(region); // get the button class of the selected annotation type
            if (buttonClass) jIconButton = $('.' + buttonClass); // and then jq object of the icon button itself
        }
        //............................................  annotation navigation icons
        (0, _toolbar.setIconState)($('#' + _defines2.default.ANAVPREV), _defines2.default.ANAVPREV, state);
        (0, _toolbar.setIconState)($('#' + _defines2.default.ANAVNEXT), _defines2.default.ANAVNEXT, state);

        if (jIconButton) {
            // show the icon for this annotation type
            var url = jIconButton.css('background-image'); // e.g. =  url("http://localhost../images/PinDrop-24.png")
            var backColor = annotationsService ? '#' + (0, _helpers.toHexColor)(annotationsService.getSelColor()) : '#FFFFFF'; // set the current tool icon background color to that of the selected icon

            $('.' + _defines2.default.clsANAVCURRENT).css({
                'background-image': url,
                'width': jIconButton.width(),
                'height': jIconButton.height(),
                'visibility': 'visible'
            }).show();
            $('.' + _defines2.default.clsANAVCURRENT).css({ 'background-color': backColor });

            if (region) {
                var text = ''; // useful feedback to indicate region is an Analysis or Input region
                if (region.get('isAnalyzed') == true) text = 'A';
                //debug-only watch out may be out of date var rtnArray = annotationsService.layers.findByProperty('InputAnnotationId', region.get('layerId')); // is this an input/parent layer?
                //debug-only if (rtnArray.length) text = 'I';
                $('.' + _defines2.default.clsANAVCURRENT).text(text).css({ 'color': (0, _helpers.isLightColor)(backColor) ? 0 : 16777215 });
            }
        } else {
            $('#' + _defines2.default.idANAVCURRENT).css('visibility', 'hidden'); // or hide the icon
        }

        //............................................  region icons: trash, colorpicker, note
        state = uScope.canAnnotate() == false ? 'disabled' : state;
        (0, _toolbar.setIconState)($('.' + _defines2.default.APTRASH), _defines2.default.APTRASH, state);
        (0, _toolbar.setIconState)($('.' + _defines2.default.APNOTE), _defines2.default.APNOTE, state);
        setColorPickerState_(state);
    };

    //............................................ position() public
    //    position - This function positions the annotations panel below the label or, if there is
    //                        no label, in the position that the label would have been placed.
    //        Note that it assume the label has room below it... instead cOverLayout should be updated to handle this.
    this.position = function () {
        var activeViewport = uScope.getThisImage();
        // if (curiously) opened w/o an image or that image has no label
        if (uScope.isThisImageValid() == false || activeViewport.hasALabel() == false || _defines2.default.ENABLELABEL == false) {
            var rootPos = $(_defines2.default.idHashROOT).offset();
            var panelPos = [rootPos.left, Math.floor(rootPos.top + $(_defines2.default.idHashROOT).height() / 3)];
        } else {
            var jVpDiv = activeViewport.vpDivGet('outer'); // place it relative to the label
            var offsetPos = jVpDiv.find('.' + _defines2.default.clsDIVLABEL).offset();
            if (offsetPos == null || offsetPos == undefined) offsetPos = { 'left': 0, 'top': 0 };
            var panelPos = [offsetPos.left, Math.floor(offsetPos.top + _defines2.default.labelSpecs.width + 2 * _defines2.default.kOVERLAY_ELEMENT_SPACE)];
        }
        jPanel.dialog({ left: panelPos[0], top: panelPos[1] });
    };

    //............................................ activateDrawIcon_() local
    //    activateDrawIcon_ - This function sets the specified drawing icon to the active state
    //        and all all other drawing icons to the enabled state.
    var activateDrawIcon_ = function activateDrawIcon_(jContainer, classRoot) {
        self.enableDrawingIcons(true);
        (0, _toolbar.setIconState)(jContainer, classRoot, 'active');
    };
    //............................................ show() public
    this.show = function (show) {
        if (show == true) {
            jPanel.dialog('open');
            self.enableDrawingIcons(uScope.canAnnotate());
        } else {
            jPanel.dialog('close');
        }
    };
    //............................................ onColorSelect() local
    // onColorSelect - This function is called by the color picker when a color is selected.
    var onColorSelect = function onColorSelect(color) {
        // The color picker in toolbar.js triggers a setColor click event when it's created. This is bound to $.ready(),
        // and serviceLocator.annotationsService isn't defined until the imageOpen event is called in viewportAP, which
        // doesn't happen until after xInfo is received, so we have a little race condition going on.
        if (serviceLocator.annotationsService) {
            serviceLocator.annotationsService.setSelColor(color);
            self.enableRegionIcons(serviceLocator.annotationsService);
        }
    };
    //............................................ unBindEvents_() local
    // unBindEvents_ - This function releases the namespaced annotation panel event handlers
    var unBindEvents_ = function unBindEvents_() {
        $(_defines2.default.idHashROOT).off(namespace);
        $('body').off(namespace); // note - these events may linger even after uScope is removed
    };

    //............................................ bindEvents_() local
    // bindEvents_ - This function adds the annotation colorpicker panel event handlers.
    //
    //    Note that an exception is made here and the namespace is not an image's namespace.

    var bindEvents_ = function bindEvents_() {
        var jRoot = $(_defines2.default.idHashROOT); // cache jQuery element of uScope root div

        // these events are attached to the uScope root div
        jRoot.on('click' + namespace, '.' + _defines2.default.TBANNOTPANEL + '-e', function () {
            self.show(true);
            (0, _toolbar.setIconState)($('#' + _defines2.default.TBANNOTPANEL), _defines2.default.TBANNOTPANEL, 'active');
            return false;
        });
        jRoot.on('click' + namespace, '.' + _defines2.default.TBANNOTPANEL + '-a', function () {
            self.show(false);
            (0, _toolbar.setIconState)($('#' + _defines2.default.TBANNOTPANEL), _defines2.default.TBANNOTPANEL, 'enabled');
            return false;
        });
        jRoot.on(_defines2.default.evIMAGESELECTED + namespace, function (e, parms) {
            self.enableDrawingIcons(uScope.canAnnotate()); // change the drawing icon state as a function of the selected image
        });

        jRoot.on('click', '.' + _defines2.default.APANNOTPIN + '-a' + ',.' + _defines2.default.APANNOTPEN + '-a' + ',.' + _defines2.default.APANNOTNEGPEN + '-a' + ',.' + _defines2.default.APANNOTPOLY + '-a' + ',.' + _defines2.default.APANNOTRECT + '-a' + ',.' + _defines2.default.APANNOTARROW + '-a' + ',.' + _defines2.default.APANNOTCALIPER + '-a' + ',.' + _defines2.default.APANNOTREPORT + '-a' + ',.' + _defines2.default.APANNOTELLIPSE + '-a' + ',.' + _defines2.default.APANNOTTEXT + '-a', function (e) {
            if (uScope.isThisImageValid()) {
                var activeViewport = uScope.getThisImage();
                activeViewport.navModeSwitch(_defines2.default.eNavModes.nmNone);
                activeViewport.vpDivGet().css('cursor', 'auto');
                (0, _toolbar.setIconState)($(e.currentTarget), (0, _helpers.getClassList)(e.currentTarget)[0], 'enabled');
            }
        });

        // selecting enabled drawing tool
        jRoot.on('click' + namespace, '.' + _defines2.default.APANNOTPIN + '-e' + ',.' + _defines2.default.APANNOTPEN + '-e' + ',.' + _defines2.default.APANNOTNEGPEN + '-e' + ',.' + _defines2.default.APANNOTPOLY + '-e' + ',.' + _defines2.default.APANNOTRECT + '-e' + ',.' + _defines2.default.APANNOTARROW + '-e' + ',.' + _defines2.default.APANNOTCALIPER + '-e' + ',.' + _defines2.default.APANNOTREPORT + '-e' + ',.' + _defines2.default.APANNOTELLIPSE + '-e' + ',.' + _defines2.default.APANNOTTEXT + '-e', function (e) {
            if (uScope.isThisImageValid()) {
                var navModeIdx = e.currentTarget.getAttribute('navmode');
                if (navModeIdx) {
                    // Ensure there's a layer to write to before drawing!
                    var layerName = _defines2.default.eNavModes[navModeIdx] === _defines2.default.eNavModes.nmAnnotReport ? _defines2.default.ReportLayerName : _defines2.default.AnnotLayerName;
                    if (serviceLocator.annotationsService.layers.getLayerIdByName(layerName) < 0) {
                        serviceLocator.annotationsService.layers.createAddSaveSpecial(layerName);
                    }

                    var navMode = _defines2.default.eNavModes[navModeIdx];
                    var activeViewport = uScope.getThisImage();
                    activeViewport.navModeSwitch(navMode);
                    activateDrawIcon_($(e.currentTarget), (0, _helpers.getClassList)(e.currentTarget)[0]); // 1st class in list is base class name, change to draw icon image
                }
            }
            return false;
        });

        jRoot.on('click' + namespace, '.' + _defines2.default.APTRASH + '-e', function (e) {
            if (uScope.isThisImageValid() && serviceLocator.annotationsService) {
                serviceLocator.annotationsService.regSelectDelete();
            }
            return false;
        });

        jRoot.on('click' + namespace, '.' + _defines2.default.APANNOTCOLOR, function (e) {
            if (serviceLocator.annotationsService && uScope.isThisImageValid()) {
                var layerId = serviceLocator.annotationsService.getSelLayerId(); // allow color picking on Annotation-layer and Report -layer only
                var canBeEnabled = serviceLocator.annotationsService.layerIsNamed(layerId, _defines2.default.AnnotLayerName) || serviceLocator.annotationsService.layerIsNamed(layerId, _defines2.default.ReportLayerName);
                if (canBeEnabled) {
                    var color = serviceLocator.annotationsService.getSelColor();
                    var isVisible = colorPicker.toggle(color);
                    (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTCOLOR), _defines2.default.APANNOTCOLOR, isVisible ? 'active' : 'enabled');
                }
            }
            return false;
        });

        jRoot.on('click' + namespace, '.' + _defines2.default.APNOTE + '-e', function (e) {
            (0, _toolbar.setIconState)($('.' + _defines2.default.APNOTE), _defines2.default.APNOTE, 'active');
            if (uScope.isThisImageValid() && serviceLocator.annotationsService) {
                var region = serviceLocator.annotationsService.getSelRegion();
                if (!region) {
                    return;
                }

                if (region.shape === 'text') {
                    (0, _toolbar.openTextEditPanel)('Update on image text', region.note, serviceLocator.annotationsService.onAddImageText);
                } else if (region.isReportRegion) {
                    (0, _toolbar.openTextEditPanel)('Modify report region text', region.note, serviceLocator.annotationsService.onAddImageText);
                } else {
                    (0, _toolbar.openTextEditPanel)('Add note for this region', region.note, function (cursorPosition, note) {
                        if (serviceLocator.annotationsService) {
                            serviceLocator.annotationsService.regAddNote(note);
                        }
                    });
                }
            }
            return false;
        });

        jRoot.on('click' + namespace, '#' + _defines2.default.ANAVPREV + ',#' + _defines2.default.idANAVCURRENT + ',#' + _defines2.default.ANAVNEXT, function (e) {
            var nextPrev = 'previous';
            if (e.currentTarget.id == _defines2.default.idANAVCURRENT) nextPrev = 'current';else if (e.currentTarget.id == _defines2.default.ANAVNEXT) nextPrev = 'next';
            if (uScope.isThisImageValid() && serviceLocator.annotationsService) {
                serviceLocator.annotationsService.regSelectNextPrev(nextPrev);
            }
            return false;
        });
    };

    var construct_ = function construct_() {
        jPanel = $('<div id=' + _defines2.default.idANNOTPANEL + ' class=' + _defines2.default.clsPANEL + ' title="Annotations"></div>');
        // annotation region tools section
        // note that the click handler requires that the base class (w/o the "-e" or "-d" etc) is the first class listed
        jPanel.append($('<a/>', {
            'class': _defines2.default.APANNOTRECT + ' ' + _defines2.default.APANNOTRECT + '-e ' + _defines2.default.clsAPBUTTON,
            'navmode': 'nmAnnotRect',
            'title': 'Add a rectangular annotation'
        }));
        jPanel.append($('<a/>', {
            'class': _defines2.default.APANNOTPOLY + ' ' + _defines2.default.APANNOTPOLY + '-e ' + _defines2.default.clsAPBUTTON,
            'navmode': 'nmAnnotPolygon',
            'title': 'Add a polygon annotation:\r   click set points\r   double-click to finish'
        }));

        // 5/12/15 - negative freeform annotation removed for 12.3  FB 20591
        //jPanel.append($("<a/>", { "class": us.APANNOTNEGPEN + " " + us.APANNOTNEGPEN + "-e "+ us.clsAPBUTTON, "navmode":
        jPanel.append($('<a/>', {
            'class': _defines2.default.APANNOTPEN + ' ' + _defines2.default.APANNOTPEN + '-e ' + _defines2.default.clsAPBUTTON,
            'navmode': 'nmAnnotPen',
            'title': 'Add a freeform annotation'
        }));
        jPanel.append($('<a/>', {
            'class': _defines2.default.APANNOTPIN + ' ' + _defines2.default.APANNOTPIN + '-e ' + _defines2.default.clsAPBUTTON,
            'navmode': 'nmAnnotPin',
            'title': 'Add a pin annotation'
        }));
        jPanel.append('<div class=\'tooldivider tooldivider0\'></div>'); // invisible horizontal line - keeps row of icons from shifting

        jPanel.append($('<a/>', {
            'class': _defines2.default.APANNOTARROW + ' ' + _defines2.default.APANNOTARROW + '-e ' + _defines2.default.clsAPBUTTON,
            'navmode': 'nmAnnotArrow',
            'title': 'Add an arrow annotation'
        }));
        jPanel.append($('<a/>', {
            'class': _defines2.default.APANNOTCALIPER + ' ' + _defines2.default.APANNOTCALIPER + '-e ' + _defines2.default.clsAPBUTTON,
            'navmode': 'nmAnnotCaliper',
            'title': 'Add a measurement annotation:\r   click set points\r   double-click to finish'
        }));
        jPanel.append($('<a/>', {
            'class': _defines2.default.APANNOTREPORT + ' ' + _defines2.default.APANNOTREPORT + '-e ' + _defines2.default.clsAPBUTTON,
            'navmode': 'nmAnnotReport',
            'title': 'Add a report annotation'
        }));
        jPanel.append($('<a/>', {
            'class': _defines2.default.APANNOTELLIPSE + ' ' + _defines2.default.APANNOTELLIPSE + '-e ' + _defines2.default.clsAPBUTTON,
            'navmode': 'nmAnnotEllipse',
            'title': 'Add an elliptcal annotation'
        }));
        jPanel.append($('<a/>', {
            'class': _defines2.default.APANNOTTEXT + ' ' + _defines2.default.APANNOTTEXT + '-e ' + _defines2.default.clsAPBUTTON,
            'navmode': 'nmAnnotText',
            'title': 'Add on-image text'
        }));
        jPanel.append('<div class=\'tooldivider\'></div>'); // horizontal line

        //
        jPanel.append($('<a/>', {
            'class': _defines2.default.APTRASH + ' ' + _defines2.default.APTRASH + '-e ' + _defines2.default.clsAPBUTTON,
            'title': 'Delete the selected annotation'
        }));
        jPanel.append($('<a/>', {
            'class': _defines2.default.APANNOTCOLOR + ' ' + _defines2.default.APANNOTCOLOR + '-e ' + _defines2.default.clsAPBUTTON,
            'title': 'Select a color for this annotation'
        }));
        jPanel.append($('<a/>', {
            'class': _defines2.default.APNOTE + ' ' + _defines2.default.APNOTE + '-e ' + _defines2.default.clsAPBUTTON,
            'title': 'Add or update a note for this annotation'
        }));

        // annotation navigation section
        jPanel.append('<div class=\'tooldivider\'></div>'); // horizontal line
        var jAnNavDiv = jPanel.append($('<div>', { 'id': _defines2.default.idANNAVDIV }));
        jAnNavDiv = jPanel.find('#' + _defines2.default.idANNAVDIV);

        jAnNavDiv.append($('<a/>', {
            'id': _defines2.default.ANAVPREV,
            'class': _defines2.default.clsANAVBUTTON + ' ' + _defines2.default.ANAVPREV + '-e',
            'title': 'Select previous annotation'
        }));
        jAnNavDiv.append($('<a/>', {
            'id': _defines2.default.idANAVCURRENT,
            'class': _defines2.default.clsANAVCURRENT + ' ' + _defines2.default.clsBLANKBTN,
            'title': 'Center the view on the selected annotation'
        }));
        jAnNavDiv.append($('<a/>', {
            'id': _defines2.default.ANAVNEXT,
            'class': _defines2.default.clsANAVBUTTON + ' ' + _defines2.default.ANAVNEXT + '-e',
            'title': 'Select next annotation'
        }));

        // convert div into dialog and use defaults
        jPanel.dialog({
            appendTo: _defines2.default.idHashROOT,
            autoOpen: false,
            closeOnEscape: true,
            resizable: false,
            // hard-coding size since on move it can be shrunk, and I'm too lazy to figure out why
            width: '175px',
            height: '200px',
            dialogClass: 'uscope-dialog dialogMover',
            close: function close(event, ui) {
                (0, _toolbar.setIconState)($('#' + _defines2.default.TBANNOTPANEL), _defines2.default.TBANNOTPANEL, 'enabled');
            }
        });

        self.position(); // position the panel

        uScope.events.on('color-picker:select-color', onColorSelect); // and create the color picker
        self.publicColorPicker = colorPicker;
        unBindEvents_(); // removes namespaced event handlers
        bindEvents_(); // add event handlers
    };

    //............................................ construction
    construct_();
}
module.exports = exports['default'];

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ColorPickerControl;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ColorPickerControl(selector, options) {
    var $colorCells = void 0;
    var selectedIdx = void 0;
    var settings = void 0;

    var init = function init(selector, options) {
        var defaults = {
            defaultColorIdx: 0, // default color index
            columns: 13, // number of color cells per row (0 means 1 row)
            divClass: _defines2.default.clsCLRPICKGRID, // the div to place the color picker grid in
            colorPalette: _defines2.default.colorPalette, // color selections
            click: function click($colorCells) {}
        };
        settings = $.extend({}, defaults, options);

        // in the immediate scope of the plugin function, the this keyword refers to the jQuery object the plugin was invoked on.
        var $this = $(selector); // the associated parent html element
        selectedIdx = settings.defaultColorIdx;
        settings.columns = settings.columns > 0 ? settings.columns : settings.color.length;

        var sCells = ''; // create abd add the color grid to the parent with the specified class
        for (var i = 0; i < settings.colorPalette.length; i++) {
            sCells += '<div style="background-color:' + settings.colorPalette[i] + ';"></div>';
        }$this.html('<div class="' + settings.divClass + '">' + sCells + '</div>');

        $colorCells = $this.children('.' + settings.divClass).children('div'); // select the grid's color cells

        var w = ($colorCells.width() + 4) * settings.columns; // set width of cell grid =  space between cells x N cells/row
        $('.' + settings.divClass).css('width', w);

        $colorCells.each(function (i) {
            // add click event to each cell
            $(this).click(function () {
                setCheckState(i); // check the appropriate div
                settings.click(settings.colorPalette[i]); // issue user click
            });
        });
        setCheckState(settings.defaultColorIdx); // check the appropriate div
        selectedIdx = settings.defaultColorIdx; // save the selected color idx
    };

    var setCheckState = function setCheckState(i) {
        var $cell = void 0;
        if (selectedIdx == i) return; // nothing to do
        if (i == -1 || i > settings.colorPalette.length - 1) i = 0; // keep index in-bounds

        if (selectedIdx > -1) {
            // clean up check state in previous color cell
            $cell = $colorCells.eq(selectedIdx);
            if ($cell.hasClass('check')) $cell.removeClass('check').removeClass('checkwht').removeClass('checkblk');
        }

        selectedIdx = i; // save the selected color idx
        $cell = $colorCells.eq(selectedIdx); // set checkmark in selected color
        var whiteFont = setWhiteFont(settings.colorPalette[i]);
        $cell.addClass('check').addClass(whiteFont ? 'checkwht' : 'checkblk');
    };

    var setWhiteFont = function setWhiteFont(hexColor) {
        // compute brightness of color by converting to the Y component of YUV, which is brightness or luminance
        var decRGB = parseInt(hexColor.substr(1), 16); // integer RGB value
        var blue = decRGB & 0xFF;
        var green = decRGB >> 8 & 0xFF;
        var red = decRGB >> 16 & 0xFF;
        //    don't need U and V, but fyi, they are:      U = 0.436 * (blue - Y) / (1 / 0.114);  V = 0.615 * (red - Y) / (1 / 0.299);
        var Y = parseInt(red * 0.299 + green * 0.587 + blue * 0.114);
        return Y <= 139;
    };

    this.selectByColor = function (hexColor) {
        // set the color selection to the passed hex color, e.g. "#ffff56"
        for (var i = 0; i < settings.colorPalette.length; i++) {
            if (settings.colorPalette[i] == hexColor) {
                setCheckState(i);
                break;
            }
        }
    };

    init(selector, options);
}
module.exports = exports['default'];

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ColorPicker;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _toolbar = __webpack_require__(27);

var _helpers = __webpack_require__(4);

var _colorPickerControl = __webpack_require__(366);

var _colorPickerControl2 = _interopRequireDefault(_colorPickerControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ColorPicker(uScope) {
    var jPanel = void 0;
    var jColorPickerContainer = void 0;
    var jColorPickerBar = void 0;
    var control = void 0;
    var jColorPickerGrid = void 0;

    var isVisible = function isVisible() {
        return jPanel.is(':visible');
    };

    this.toggle = function (color) {
        var visible = isVisible();
        if (!visible) {
            jPanel.dialog('open');
            position();
            set(color);
        } else {
            jPanel.dialog('close');
        }
        return !visible; // invert since state is reversed now.
    };

    var position = function position() {
        jPanel.dialog({
            position: { my: 'top', at: 'bottom', of: '#' + _defines2.default.idANNOTPANEL },
            width: getGridWidth() + 40 // TODO: Fix magic number
        });
    };

    var set = function set(color) {
        if (isVisible()) {
            var curColorHex = '#' + (0, _helpers.toHexColor)(color);
            control.selectByColor(curColorHex);
            jColorPickerBar.css({ 'background-color': curColorHex });
        }
    };

    var getGridWidth = function getGridWidth() {
        return jColorPickerGrid.width();
    };

    var init = function init() {
        jColorPickerContainer = $('<div id=' + _defines2.default.idCLRPICKDIV + '></div>');
        jPanel = $('<div/>', {
            'id': _defines2.default.idCLRPICKPANEL,
            'class': _defines2.default.clsPANEL,
            'title': 'Select a Color'
        });

        // $('#' + us.idCLRPICKPANEL).remove();                // Remove any existing color pickers from the DOM (TODO - shouldn't there be a destructor?)
        $(_defines2.default.idHashROOT).append(jPanel); // Add the panel to the root to be able to move it

        jPanel.dialog({
            autoOpen: false,
            closeOnEscape: false,
            modal: true,
            draggable: true,
            resizable: false,
            stack: true,
            position: ['center', 'bottom'],
            dialogClass: 'uscope-dialog dialogMover',
            buttons: [{
                text: 'OK', click: function click() {
                    (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTCOLOR), _defines2.default.APANNOTCOLOR, 'enabled');
                    $(this).dialog('close');
                }
            }, {
                text: 'Cancel', click: function click() {
                    (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTCOLOR), _defines2.default.APANNOTCOLOR, 'enabled');
                    $(this).dialog('close');
                }
            }]
        });

        // append this modal dialog to body to work around a jquery issue that modal dialogs cannot be dismissed in popup mode
        //    (would normally want it appended to the uscope div)
        // note that the dialog is the parent to the panel created
        jPanel.parent().appendTo('body');

        // add the div of color squares to the panel
        jPanel.append(jColorPickerContainer);

        control = new _colorPickerControl2.default(jColorPickerContainer, {
            columns: 13,
            click: function click(clr) {
                uScope.events.trigger('color-picker:select-color', (0, _helpers.hexColortoRGB)(clr));
                jPanel.dialog('close');
                (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTCOLOR), _defines2.default.APANNOTCOLOR, 'enabled');
            }
        });

        jColorPickerGrid = $('.' + _defines2.default.clsCLRPICKGRID);
        jColorPickerBar = $('<div/>', { 'id': _defines2.default.idCLRPCKBAR, 'width': getGridWidth() - 5, 'height': 14 });

        // and add a color bar div to display the selected color
        jPanel.append(jColorPickerBar);
    };

    init();
}
module.exports = exports['default'];

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renderArrow = undefined;

var _Point = __webpack_require__(107);

var renderArrow = exports.renderArrow = function renderArrow(region, pointList) {
    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var viewZoom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

    // An arrow is just two points with a tip. The shape information for the arrow's tip is not saved to the database so
    // we have a little extra work to do. To simplify we draw a vertical arrow and then scale / rotate it to match the
    // length / angle of the line between the two points saved in the database.

    var origin = new _Point.Point().setPoint(pointList[0]);
    var endpoint = new _Point.Point().setPoint(pointList[1]);

    // 1. Draw the tip in its baseline position.
    //    Since the tip is manually generated we have to scale it manually too (IE tipZoom !== viewZoom).
    var tipScale = region.zoom && viewZoom ? region.zoom / viewZoom : 1;
    var tipWidth = 4 * tipScale;
    var tipLength = 12 * tipScale;
    var tipXY = tipWidth + ',' + tipLength;
    var tipPath = 'M 0,0 L ' + tipXY + ' L -' + tipXY;

    // 2. Draw the shaft in its baseline position.
    var arrowLength = region.data.lengthPixels || origin.distance(endpoint);

    // 3. Put the tip on the shaft.
    var svgPath = 'M 0,0 L 0,' + arrowLength * scale + ' ' + tipPath + ' Z';

    // 4. Calculate the angle of rotation
    var deltaX = origin.x - endpoint.x;
    var deltaY = origin.y - endpoint.y;
    var angle = Math.atan2(deltaY, deltaX) * 180 / Math.PI + 90; // +90 because the baseline position is vertical

    // 5. Calculate the offset.
    //    Our baseline Arrow's coordinates are 0,0, so we apply a transformation to move it to the position indicated by
    //    the origin.
    var offset = origin.x * scale + ',' + origin.y * scale;
    // By default, Raphael rotates around the center of the arrow's bounding box. We decorate angle with 0,0 to tell
    // Raphael to rotate at the tip instead.
    var svgTransformation = 't' + offset + ' r' + angle + ',0,0';

    return { svgPath: svgPath, svgTransformation: svgTransformation };
};

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createKeyboardHandler = undefined;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _keyCodes = __webpack_require__(139);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createKeyboardHandler = exports.createKeyboardHandler = function createKeyboardHandler(uScope, viewport, annotationsService) {

    viewport.events.on('viewport:keyup', function (keyCode, event) {
        if (!event.ctrlKey || !uScope.canAnnotate()) {
            return;
        }

        var region = annotationsService.getSelRegion();

        switch (keyCode) {
            case _keyCodes.keyCodes.deleteKey:
                // delete selected annotation
                annotationsService.regSelectDelete();
                break;

            case _keyCodes.keyCodes.c:
                // copy selected annotation
                uScope.startCopyMoveRegion(region, event, 'copy');
                break;

            case _keyCodes.keyCodes.v:
                // paste selected annotation
                if (!uScope.isRegionCopyActive()) {
                    //arg... really need cursor position for this to work.....
                    var e = jQuery.Event('', { pageX: _defines2.default.pageX, pageY: _defines2.default.pageY });
                    uScope.startCopyMoveRegion(region, e, 'copy');
                }
                uScope.stopCopyMoveRegion(); // and place the copied region here
                break;

            case _keyCodes.keyCodes.m:
                // copy selected annotation
                if (!uScope.isRegionCopyActive()) {
                    uScope.startCopyMoveRegion(region, event, 'move');
                } else {
                    uScope.stopCopyMoveRegion();
                }
                break;
        }
    });
};

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(10);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(9);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.default = LayerManager;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _helpers = __webpack_require__(4);

var _layer = __webpack_require__(294);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO / To Consider:
// - WHERE macros should reside (? uScope) and how to track image permissions
// - var isValidLayer_ = function (layerId) { return rfLayer[layerId] ? true : false; };
// - The layer manager should be the place where layers are created, saved, deleted, etc. However, not everything
//      uses the layer manager to create layers, which means it can get out of sync

function LayerManager(uScope, annotationsService, imageId) {
    var _this = this;

    var self = this;
    var thisRegions = annotationsService.getRegionsObj();

    // This array contains all layers, but layerId is not the index into this array. Note that the length of this array
    // is NOT the number of layers.  Deleted layers are undefined slots in the array.
    var allLayers = [];
    self.getLayersArray = function () {
        return allLayers;
    };
    // handy access into theLayers to the currently selected layer (or -1 if none selected)
    self.selectedIdx = -1;

    var findLayerByKeyAndValue = function findLayerByKeyAndValue(key, val) {
        return allLayers.find(function (layer) {
            return layer && layer.get(key) === val;
        });
    };

    self.getLayerById = function (layerId) {
        return findLayerByKeyAndValue('Id', layerId);
    };

    self.getLayerIdxById = function (layerId) {
        var layer = self.getLayerById(layerId);
        return layer ? allLayers.indexOf(layer) : -1;
    };

    self.getLayerByName = function (name) {
        return findLayerByKeyAndValue('Name', name);
    };

    self.getLayerIdByName = function (name) {
        var layer = self.getLayerByName(name);
        return layer ? layer.get('Id') : -1;
    };

    self.getLayerNameById = function (layerId) {
        var aLayer = self.getLayerById(layerId);
        return aLayer ? aLayer.get('Name') : undefined;
    };

    self.maybeCreateLayerAndGetId = function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(name) {
            var layerId, layer;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            layerId = self.getLayerIdByName(name);

                            if (!(layerId < 0)) {
                                _context.next = 6;
                                break;
                            }

                            _context.next = 4;
                            return self.createAddSave({
                                Name: name,
                                Type: _defines2.default.anLayerTypes.manual,
                                LineColor: (0, _helpers.reverseCLR)((0, _helpers.hexColortoRGB)(_defines2.default.getRandomColor())),
                                selected: true
                            });

                        case 4:
                            layer = _context.sent;

                            layerId = layer.get('Id');

                        case 6:
                            return _context.abrupt('return', layerId);

                        case 7:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();

    /**
     * This function creates a layer object from the jsonLayer input, adds it to theLayers array and saves it to the database
     * @param jsonLayer
     */
    self.createAddSave = function (jsonLayer) {
        jsonLayer.Id = self.getNextLayerId(); // assign a negative Id to the newly created layer (will be re-assigned by DataServer and resolved on callback)
        var aLayer = (0, _layer.createLayer)(jsonLayer, 'json'); // create the new layer
        return self.addAndSave(aLayer); // add add and save the layer
    };

    /**
     * This function adds the layer to the layers array and saves it to the database. Call it for layers newly created
     * layer objects.
     * @param layer (Object) - a layer object. Note that its Id should be assigned by layers.setNextLayerId_  and be negative.
     * Note also that the save callback will resolve the negative Id with that assigned by the database
     * @returns {Promise}
     */
    self.addAndSave = function (layer) {
        if (!layer) {
            // ('layer-manager::addAndSave() called without a layer object'); // eslint-disable-line no-undef
            return Promise.reject();
        }

        // Try to add the layer to the tracking array.
        if (!self.add(layer)) {
            // ('layer-manager::addAndSave() Failed to add the layer!'); // eslint-disable-line no-undef
            return Promise.reject();
        }

        var layerXML = layer.buildXML();

        if (!uScope.canSaveAnnotations()) {
            return Promise.resolve(layer);
        }

        return new Promise(function (resolve) {
            annotationsService.save({
                action: 'addLayer',
                layerXML: layerXML,
                tag: layer.get('Id'),
                cbSuccessFn: function cbSuccessFn(response) {
                    updateLayerFromServer(response, layer);
                    resolve(layer);
                }
                // What, no errors?

            });
        });
    };

    //............................................ cLayers updateLayerFromServer
    // updateLayerFromServer - This function is a callback when a layer is saved to the database.
    //
    var updateLayerFromServer = function updateLayerFromServer(serverResponse, layer) {
        var posId = serverResponse.find('Annotation').attr('Id');
        // track the highest value layer id
        setNextLayerId_(posId);
        layer.set('Id', posId);
    };
    //............................................ cLayers add
    // add - This function adds the passed layer to theLayers array.
    //
    self.add = function (aLayer) {
        if (aLayer.get('isSupported')) {
            if (aLayer.get('isReportLayer') && self.getLayerByName(_defines2.default.ReportLayerName)) // if adding a report layer,insure a report layer does not already exist
                return false;
            if (aLayer.get('isAnnotLayer') && self.getLayerByName(_defines2.default.AnnotLayerName)) // if adding an annotation layer, insure a annotation layer does not already exist
                return false;

            allLayers.push(aLayer); // add the layer to the container
            setNextLayerId_(aLayer.get('Id')); // update the next layer id
            return true;
        } else {
            // layer not supported
            // ('add: layer type is not yet supported'); // eslint-disable-line no-undef
            return;
        }
        return false;
    };

    //............................................ cLayers replace
    self.replace = function (aLayer) {
        var layerId = aLayer.get('Id');
        var idx = self.getLayerIdxById(layerId);
        if (idx != -1) {
            allLayers[idx] = aLayer;
            return true;
        }
        return false;
    };
    //............................................ cLayers createAddSaveSpecial
    //    createAddSaveSpecial - This function creates a new special layer and adds it to the container array.
    //            It returns true if it was sucessfully created and false if not.
    //    layerName:  us.ReportLayerName | us.AnnotLayerName

    self.createAddSaveSpecial = function (layerName) {
        if (uScope.canAnnotate() == false) {
            // ('layer-manager::createAddSaveSpecial() called when annotations are disabled.'); // eslint-disable-line no-undef
            Promise.reject();
        }

        if (layerName == _defines2.default.ReportLayerName) {
            if (self.getLayerByName(_defines2.default.ReportLayerName)) return false; // insure a report layer does not already exist
            return self.createAddSave({
                'Name': _defines2.default.ReportLayerName,
                'Type': _defines2.default.anLayerTypes.report,
                'LineColor': (0, _helpers.reverseCLR)((0, _helpers.hexColortoRGB)(_defines2.default.ReportLayerRGB)),
                'selected': true
            });
        } else if (layerName == _defines2.default.AnnotLayerName) {
            if (self.getLayerByName(_defines2.default.AnnotLayerName)) return false; // insure a annotation layer does not already exist
            return self.createAddSave({
                'Name': _defines2.default.AnnotLayerName,
                'Type': _defines2.default.anLayerTypes.manual,
                'LineColor': (0, _helpers.reverseCLR)((0, _helpers.hexColortoRGB)(_defines2.default.AnnotLayerRGB)),
                'selected': true
            });
        } else {
            // ('layer-manager::createAddSaveSpecial() called for non-special layer'); // eslint-disable-line no-undef
            Promise.reject();
        }
    };

    //............................................ cLayers del
    //    This function deletes the layer with the passed layerId and all its regions.
    //    It will update the database if opt_bDoSave isn't false and annotation changes are allowed.
    //    parameters:
    //        layerId:        required, valid id of layer to delete
    //        opt_bDoSave:    optional, true/false, default true, whether or not to save the change to the database
    self.deleteLayer = function (layerId, opt_bDoSave) {
        if (uScope.canAnnotate() == false) return;
        var idx = self.getLayerIdxById(layerId);
        if (idx < 0) return;

        // since layer does not contain its regions, it must ask cRegions for help
        thisRegions.delAllFromLayer(layerId); // remove all regions from this layer
        allLayers[idx] = undefined;

        if (opt_bDoSave != false && uScope.canSaveAnnotations()) {
            annotationsService.save({ action: 'delLayer', layerId: layerId });
        }
    };
    //............................................ cLayers deleteAllLayers
    //note: this is not efficient (saving each layer change) but is currently used only for development so who cares
    //    parameters:
    //        opt_bDoSave:    optional, true/false, default true, whether or not to save the change to the database
    self.deleteAllLayers = function (opt_bDoSave) {
        if (uScope.canAnnotate() == false) return;
        for (var l = 0, len = allLayers.length; l < len; l++) {
            if (allLayers[l]) self.deleteLayer(allLayers[l].get('Id'), opt_bDoSave);
        }
        allLayers.length = 0;
    };
    //............................................ cLayers getSelected
    self.getSelected = function () {
        return self.selectedIdx < 0 ? undefined : allLayers[self.selectedIdx];
    };
    //............................................ cLayers getSelectedIdx
    self.getSelectedIdx = function () {
        return self.selectedIdx;
    };

    //............................................ cLayers getSelectedProperty
    self.getSelectedProperty = function (propName) {
        return self.selectedIdx < 0 || allLayers[self.selectedIdx] == undefined ? undefined : allLayers[self.selectedIdx].get('propName');
    };
    //............................................ cLayers getSelectedId
    self.getSelectedId = function () {
        return self.selectedIdx < 0 || allLayers[self.selectedIdx] == undefined ? -1 : allLayers[self.selectedIdx].get('Id');
    };
    //............................................ cLayers selectByProperty
    //    This function sets the 'Selected' property of the layer whose property matches the passed value
    //        and clears the Selected property on all all other layers.
    //    Note that the layer object keeps its 'Selected' property up to date
    //        yet a property of the layers object keeps a handy access to its index

    self.selectByProperty = function (propName, propValue) {
        for (var lay = 0, len = allLayers.length; lay < len; lay++) {
            if (allLayers[lay] == undefined) continue;
            if (allLayers[lay].get(propName) == propValue) {
                allLayers[lay].set('Selected', true); // this is the layer that is selected
                self.selectedIdx = lay;
            } else {
                allLayers[lay].set('Selected', false); // no other layers can be selected
            }
        }
        return self.selectedIdx;
    };

    //............................................ cLayers findByProperty
    // This function returns an array of layer objects whose property matches the passed value
    self.findByProperty = function (propName, propValue) {
        var rtnArray = [];
        if (propValue != undefined) {
            for (var lay = 0, len = allLayers.length; lay < len; lay++) {
                if (allLayers[lay] && allLayers[lay].get(propName) == propValue) rtnArray.push(allLayers[lay]);
            }
        }
        return rtnArray;
    };

    //............................................ cLayers deleteRegions
    self.deleteRegions = function (fromLayerId) {
        thisRegions.delAllFromLayer(fromLayerId);

        var aLayer = self.getLayerById(fromLayerId); // reset the region count in the layer
        aLayer.set('nRegions', 0);
    };

    /**
     * returns the next id sequence that will be used when getNextLayerId() is called
     * @returns {number}
     */
    self.getProvisionalLayerId = function () {
        return -(lastLayerId + 1);
    };

    //............................................ cLayers get/set NextLayerId()
    var lastLayerId = 0; // last layer id; used to set id for new layer
    // Note that this isn't really the assigned layer id but a unique (to uscope) id prior to assignment
    self.getNextLayerId = function () {
        return -++lastLayerId; // new layer id's are negative values so they are flagged for dataserver
    };
    var setNextLayerId_ = function setNextLayerId_(id) {
        //
        if (id >= 0 && id > lastLayerId) lastLayerId = id;
    };
}
module.exports = exports['default'];

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NavigationService = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationService = exports.NavigationService = function NavigationService(uScope, viewport, annotationsService) {
    (0, _classCallCheck3.default)(this, NavigationService);

    viewport.events.on('viewport:change-navigation', function (navMode) {
        if (!uScope.canAnnotate()) {
            return;
        }

        var handled = false;

        switch (navMode) {
            case _defines2.default.eNavModes.nmAnnotPin:
            case _defines2.default.eNavModes.nmAnnotArrow:
            case _defines2.default.eNavModes.nmAnnotText:
            case _defines2.default.eNavModes.nmAnnotReport:
            case _defines2.default.eNavModes.nmAnnotRect:
            case _defines2.default.eNavModes.nmAnnotEllipse:
            case _defines2.default.eNavModes.nmAnnotPen:
            case _defines2.default.eNavModes.nmAnnotNegPen:
            case _defines2.default.eNavModes.nmAnnotCaliper:
            case _defines2.default.eNavModes.nmAnnotPolygon:
            case _defines2.default.eNavModes.nmRedrawStarting:
            case _defines2.default.eNavModes.nmRedraw:
                handled = true;
                viewport.setCursor('pointer');
                break;
        }

        return handled;
    });

    viewport.events.on('viewport:stop-navigation', function (navMode) {
        var handled = false;

        switch (navMode) {
            case _defines2.default.eNavModes.nmAnnotPin:
            case _defines2.default.eNavModes.nmAnnotArrow:
            case _defines2.default.eNavModes.nmAnnotReport:
            case _defines2.default.eNavModes.nmAnnotText:
            case _defines2.default.eNavModes.nmAnnotRect:
            case _defines2.default.eNavModes.nmAnnotEllipse:
            case _defines2.default.eNavModes.nmAnnotPen:
            case _defines2.default.eNavModes.nmAnnotNegPen:
            case _defines2.default.eNavModes.nmAnnotCaliper:
            case _defines2.default.eNavModes.nmAnnotPolygon:
            case _defines2.default.eNavModes.nmRedrawStarting:
            case _defines2.default.eNavModes.nmRedraw:
                handled = true;
                viewport.setCursor('auto');
                annotationsService.drawingCompleted();
                break;
            default:
        }

        return handled;
    });
};

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RegionInteraction = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This service allows regions to be copied and moved. Note that it operates in the context of a region, so it should
// probably be part of or extend the region class.

// Currently it's used by "Keyboard handler" and "region toolbar"

var RegionInteraction = exports.RegionInteraction = function RegionInteraction(uScope, serviceLocator) {
    (0, _classCallCheck3.default)(this, RegionInteraction);

    // HACK: Attach these items to uScope, since that's how the rest of the code works with it. It's really backwards
    //       and hard to follow because of this. TODO: integrate directly into the region object.
    var self = uScope;

    var isCopyingRegion = false;

    self.isRegionCopyActive = function () {
        return isCopyingRegion;
    };

    self.startCopyMoveRegion = function (regionToCopy, e, action) {
        // Validate we have a region to copy, and that we're not attempting to copy a report region
        if (!regionToCopy || regionToCopy.isReportRegion && action == 'copy') {
            return false;
        }

        isCopyingRegion = true;

        var activeViewport = serviceLocator.activeViewport,
            annotationsService = serviceLocator.annotationsService;

        // show special highlight for copy/move region

        annotationsService.regHighLight(annotationsService.getSelRegion(), true);

        if (action == 'copy') {
            var crsrPosBase = void 0;
            if (e.pageX) {
                // compute the position of the cursor in base image coords
                crsrPosBase = _defines2.default.coordBaseImage(e, activeViewport);
            } else {
                crsrPosBase = regionToCopy.getCenter();
                crsrPosBase.add(10, 10);
            }
            annotationsService.regCopyTo(crsrPosBase, regionToCopy);
        }
        return true;
    };

    self.stopCopyMoveRegion = function () {
        var annotationsService = serviceLocator.annotationsService;

        var selectedRegion = annotationsService.getSelRegion();

        if (!selectedRegion) {
            return false;
        }

        isCopyingRegion = false; // TODO: Placing this after a validation failure smells like a logic bug

        // return highlight to normal region select
        annotationsService.regHighLight(selectedRegion, true);

        // update the database with the region geometry change
        if (uScope.canSaveAnnotations()) {
            var regionXML = '<Region Id="' + selectedRegion.regionId + '">';
            var vertexXML = selectedRegion.buildVertexXML();
            regionXML += '<Vertices>' + vertexXML + '</Vertices>' + '</Region>';

            annotationsService.save({
                action: 'updateRegion',
                layerId: selectedRegion.layerId,
                regionXML: regionXML
            });
        }
    };
};

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RegionToolbar;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _toolbar = __webpack_require__(27);

var _objects = __webpack_require__(16);

var _helpers = __webpack_require__(4);

var _lbsPiDash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This class builds the context menu region toolbar.
// TODO: Why isn't this dang thing attached to the viewport???

function RegionToolbar(uScope, viewport, annotationsPanel, serviceLocator) {
    var getCurrentRegion = function getCurrentRegion() {
        return serviceLocator.annotationsService && serviceLocator.annotationsService.getSelRegion();
    };

    var items = [null, {
        id: 'us_regtbtrash',
        className: _defines2.default.clsRBBUTTON + ' ' + _defines2.default.APTRASH + ' ' + _defines2.default.APTRASH + '-e',
        tooltip: 'Delete region',
        action: function action(e) {
            var region = getCurrentRegion();
            if (region) {
                serviceLocator.annotationsService.regSelectDelete();
            }
        }
    }, {
        id: 'us_regtbcolor',
        className: _defines2.default.clsRBBUTTON + ' ' + _defines2.default.APANNOTCOLOR + ' ' + _defines2.default.APANNOTCOLOR + '-e',
        tooltip: 'Change region color',
        action: function action(e) {
            var region = getCurrentRegion();
            if (region) {
                var color = serviceLocator.annotationsService.getSelColor(); // get color of currently selected region
                annotationsPanel.publicColorPicker.show(true, color);
            }
        }
    }, {
        id: 'us_regtbnote',
        className: _defines2.default.clsRBBUTTON + ' ' + _defines2.default.APNOTE + ' ' + _defines2.default.APNOTE + '-e',
        tooltip: 'Add region note',
        action: function action(e) {
            var region = getCurrentRegion();
            if (region) {
                if (region.shape === 'text') {
                    (0, _toolbar.openTextEditPanel)('Update on image text', region.note, serviceLocator.annotationsService.onAddImageText);
                } else if (region.isReportRegion) {
                    (0, _toolbar.openTextEditPanel)('Modify report region text', region.note, serviceLocator.annotationsService.onAddImageText);
                } else {
                    (0, _toolbar.openTextEditPanel)('Add note for this region', region.note, function (cursorPosition, note) {
                        if (serviceLocator.annotationsService) {
                            serviceLocator.annotationsService.regAddNote(note);
                        }
                    });
                }
            }
        }
    }, {
        id: 'us_regtbcopy', className: _defines2.default.clsRBBUTTON + ' ' + _defines2.default.REGTBCOPY + ' ' + _defines2.default.REGTBCOPY + '-e',
        tooltip: 'Copy selected region:\r    Navigate to desired location \r    and right click to place the region',
        action: function action(e) {
            var region = getCurrentRegion();
            if (region) {
                uScope.startCopyMoveRegion(region, e, 'copy');
            }
        }
    }, {
        id: 'us_regtbmove', className: _defines2.default.clsRBBUTTON + ' ' + _defines2.default.REGTBMOVE + ' ' + _defines2.default.REGTBMOVE + '-e',
        tooltip: 'Move selected region:\r    Navigate to desired location \r    and right click to place the region',
        action: function action(e) {
            var region = getCurrentRegion();
            if (region) {
                uScope.startCopyMoveRegion(region, e, 'move');
            }
        }
    }, null, {
        id: 'us_regtbredraw', className: _defines2.default.clsRBBUTTON + ' ' + _defines2.default.REGTBREDRAW + ' ' + _defines2.default.REGTBREDRAW + '-e',
        tooltip: 'Redraw freeform:\n    o Hold left mouse button down\r      near the region to start redraw\r    o Drag mouse to redraw\n    o Release mouse button to stop.',
        action: function action(e) {
            var region = getCurrentRegion();
            if (region) {
                // switch to redraw mode
                viewport.navModeSwitch(_defines2.default.eNavModes.nmRedrawStarting);
            }
        }
    }];

    var removeAllToolbars = function removeAllToolbars() {
        $('.' + _defines2.default.clsREGIONRAR).remove();
    };

    return createAndBindContextMenuToolbar({
        // parent: us.idHashROOT,
        parent: viewport.vpDivGet(),
        title: 'Region',
        toolbarClass: _defines2.default.clsREGIONRAR,
        items: items
    });

    function createAndBindContextMenuToolbar(options) {
        (0, _lbsPiDash.defaults)(options, defaultSettings);

        var handlerDiv = $(options.parent);

        handlerDiv.on('mousedown', removeAllToolbars);

        handlerDiv.on('contextmenu', function (e) {
            // if this image isn't annotatable, return and do not propagate the event
            if (!uScope.canAnnotate()) {
                return false;
            }

            if (uScope.isRegionCopyActive()) {
                // complete the prior copy or move region action
                uScope.stopCopyMoveRegion();
            }

            // Make sure the correct viewport is selected (context menu handler in viewport should work but this one can fire first)
            viewport.setImageSelected();

            var menu = createMenu(e); // create the menu
            if (menu != false) {
                var region = getCurrentRegion();

                // if the selected region is not in the view, center it in the view
                if (!region.isInView(viewport.getVPViewRect2())) {
                    // todo: could really use a fn that centers selected region
                    serviceLocator.annotationsService.regSelect({ rfId: serviceLocator.annotationsService.rfSelected, bReposition: true });
                }

                menu.show(); // show the context toolbar - must do b4 positioning
                //todo: does not work multi-image
                var jVpDiv = viewport.vpDivGet();
                var offset = jVpDiv.offset(); // the current position of the target relative to the document

                var cpVPcoord = new _objects.Point(e.pageX - offset.left, e.pageY - offset.top); // translate viewport left top position
                var angleRad = viewport.getViewAngle();
                var vpDivDims = viewport.vpDivDimsGet();
                var cpRotOffset = (0, _helpers.computeRotationOffset)(vpDivDims.w, vpDivDims.h, angleRad); //
                cpVPcoord.addPoint(cpRotOffset);
                menu.css({ left: cpVPcoord.x + 10, top: cpVPcoord.y + 5 }).bind('contextmenu', function () {
                    return false;
                });
            }

            // cancel event, so real browser popup doesn't appear.
            return false;
        });

        //............................................ createMenu
        function createMenu(e) {
            var region = getCurrentRegion();

            // if no region selected or cannot annotate, then do not create the menu
            if (!region || !uScope.canAnnotate()) {
                return false;
            }

            // if a menu is already present, remove it
            var menu = $('.' + options.toolbarClass + ' ' + options.additionalClass);
            if (menu.length) {
                menu.remove();
            }

            // Build toolbar HTML
            menu = $('<div class="' + options.toolbarClass + ' ' + options.additionalClass + '"></div>').appendTo(options.parent);
            if (options.title) {
                $('<div class="' + options.titleClass + '"></div>').text(options.title).appendTo(menu);
            }

            options.items.forEach(function (item) {
                if (item) {
                    //toconsider: extend item info to do this test instead of hard coding this knowledge at this level
                    // do not show the redraw icon unless the region is a pen or negpen
                    if (item.id == _defines2.default.REGTBREDRAW && region.shape != 'pen' && region.shape != 'negpen') {
                        return; //stop processing this iteration
                    }
                    if (item.id == _defines2.default.REGTBCOPY && region.isReportRegion) {
                        return; //stop processing this iteration
                    }

                    if (item.icon || item.className || item.id) {
                        var row = $('<div/>').appendTo(menu);
                        var icon = $('<a/>');
                        if (item.icon) icon.attr('src', item.icon);
                        if (item.className) icon.attr('class', item.className);
                        if (item.id) icon.attr('id', item.id);
                        if (item.tooltip) icon.attr('title', item.tooltip);
                        $(row).append(icon);

                        if (item.action) {
                            // NOTE there's some kind of issue here. 'click' was originally applied but it seems to be being
                            // eaten but something else.
                            row.on('mousedown', function (e) {
                                item.action(e);
                                removeAllToolbars();
                                return false;
                            });
                        }
                    }
                } else {
                    $('<div class="' + options.spacerClass + '"></div>').appendTo(menu);
                }
            });
            menu.find('.' + options.titleClass).text(options.title);

            menu.on('mouseleave', function () {
                // when the mouse leaves the toolbar, remove it from the DOM
                menu.remove();
                return false;
            });
            return menu;
        }

        return this;
    }
}

var defaultSettings = {
    parent: document.body,
    toolbarClass: 'contextToolBar',
    additionalClass: '',
    titleClass: 'title',
    spacerClass: 'divider',
    title: 'Title',
    items: []
};
module.exports = exports['default'];

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cRegions;

var _helpers = __webpack_require__(4);

var _uScope = __webpack_require__(78);

var _uScope2 = _interopRequireDefault(_uScope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//________________________________________________________________________________________________
// regions.js
/**
 * @file   example_action.h
 * @Author Me (me@example.com)
 * @date   September, 2008
 * @brief  Brief description of file.
 *
 * Detailed description of file.
 */
//    This file contains the annotation region collection object 'cRegions'.
//
//    history
//
//    1302    cperz    created
//    _______________________________________end_AIHv1/PR __________________________________________
//    141118    cperz    ol3 integration
//    141222    cperz    cRegions created; move Region (singular) into its own file; add support for image analysis:
//    150318    cperz    build out for analysis and markup;
//
//________________________________________________________________________________________________
//    Object Name: cRegions
//    Overview:  The cRegions object is a container for Region objects

function cRegions(annotationsService, inImageId) {
    var self = this;
    var imageId = inImageId;

    // ..... to group fns in js parser, for ease of search (e.g. search for all 'us_region_pts')
    var CREGIONS = this; //
    var CREGIONS_GET = this; //
    var CREGIONS_SET = this; //
    var CREGIONS_LAYER = this; //
    var CREGIONS_MARKUP = this; //
    var CREGIONS_ANALYSIS = this; //
    var CREGIONS_DEBUG = this; //

    // The array containing all regions, rfId (live assigned) is the index into the array (not regionId)
    // Note that the length of this array is NOT the number of regions.  Deleted regions are undefined slots in the array.
    var rfRegions = [];
    CREGIONS_GET.getRegionsArray = function () {
        return rfRegions;
    };

    var isValidRegion_ = function isValidRegion_(rfId) {
        return rfRegions[rfId] ? true : false;
    };

    CREGIONS_GET.getRegionId = function (rfId) {
        return isValidRegion_(rfId) ? rfRegions[rfId].getRegionId() : undefined;
    };

    CREGIONS_GET.getType = function (rfId) {
        return isValidRegion_(rfId) ? rfRegions[rfId].getType() : undefined;
    };
    CREGIONS_GET.getShape = function (rfId) {
        return isValidRegion_(rfId) ? rfRegions[rfId].getShape() : undefined;
    };
    CREGIONS_GET.getLayerId = function (rfId) {
        return isValidRegion_(rfId) ? rfRegions[rfId].getLayerId() : -1;
    }; // return -1 if region does not exist
    CREGIONS_GET.getRGB = function (rfId) {
        return isValidRegion_(rfId) ? rfRegions[rfId].getRGB() : undefined;
    };

    CREGIONS_ANALYSIS.isAnalyzed = function (rfId) {
        return isValidRegion_(rfId) ? rfRegions[rfId].isAnalyzed : false;
    };
    CREGIONS_GET.isWholeSlide = function (rfId) {
        return isValidRegion_(rfId) ? rfRegions[rfId].isWholeSlide : false;
    };
    CREGIONS_MARKUP.getMarkupImageId = function (rfId) {
        return isValidRegion_(rfId) ? rfRegions[rfId].getMarkupImageId() : undefined;
    };
    CREGIONS_MARKUP.isWholeSlideMarkup = function (rfId) {
        return isValidRegion_(rfId) ? rfRegions[rfId].isWholeSlideMarkup : false;
    };

    CREGIONS_MARKUP.markupIsInView = function (rfId, cr2View) {
        return isValidRegion_(rfId) ? rfRegions[rfId].markupIsInView(cr2View) : false;
    };
    CREGIONS_MARKUP.getMarkupInfo = function (rfId) {
        return isValidRegion_(rfId) ? rfRegions[rfId].getMarkupInfo() : undefined;
    };
    CREGIONS_MARKUP.hasMarkup = function (rfId) {
        return isValidRegion_(rfId) ? rfRegions[rfId].get('hasMarkup') : false;
    };

    //............................................ cRegions getReportRegionId
    CREGIONS_GET.getReportRegionId = function () {
        // note: this is inefficient if there are a lot of regions...
        for (var r = 0, len = rfRegions.length; r < len; r++) {
            if (rfRegions[r] && rfRegions[r].get('isReportRegion')) return rfRegions[r].get('regionId');
        }
        return -1;
    };
    //............................................ cRegions createRegionResponse
    // { imageId: imageId, negId: oRegionId, assignedId: regionId, layerId: layerId }
    CREGIONS.createRegionResponse = function (json) {
        var aRegion = self.getByRegionId(json.negId);
        if (aRegion) {
            var posId = json.assignedId;
            aRegion.setRegionId(+posId);

            annotationsService.events.trigger('us:annotations:region-change', {
                imageId: json.imageId,
                regionId: posId,
                anShape: aRegion.isReportRegion ? 'report' : aRegion.getShape(),
                action: 'add'
            });
        } else {
            // ('createRegionResponse:  imageId: ' + json.imageId + '  assigned id: ' + json.assignedId + ' not reconciled with temp id: ' + json.negId); // eslint-disable-line no-undef
        }
    };

    //............................................ get/set NextRegionId()
    var lastRegionId = 0; // last region id in each layer; used to set id for new region
    // this regionId is not the true id assigned by DataServer. It is a unique neg id used to request a new region id... it is most likely neg of rfId
    CREGIONS_GET.getNextRegionId = function () {
        // new region id's are negative values so they are flagged for dataserver
        return -++lastRegionId;
    };
    CREGIONS_SET.setNextRegionId = function (id) {
        if (id > lastRegionId) // save the maximum region id
            lastRegionId = id;
    };

    //............................................ cRegions clear
    CREGIONS.clear = function () {
        rfRegions.length = 0;
    };

    //............................................ cRegions add
    CREGIONS.add = function (aRegion, opt_bDoSave) {
        //toconsider: could validate region and return true/false
        rfRegions[aRegion.rfId] = aRegion; // add region to array

        self.setNextRegionId(aRegion.regionId); // keep next regionId up to date

        if (opt_bDoSave == true && _uScope2.default.instance.canSaveAnnotations()) {
            var regionXML = aRegion.buildXML(true); // build the region xml for the new annotation
            annotationsService.save({
                action: 'addRegion',
                layerId: aRegion.layerId,
                regionXML: regionXML,
                tag: aRegion.regionId
            });
        }
        annotationsService.events.trigger('us:annotations:region-add', aRegion);
    };
    //............................................ cRegions addRegionResponse
    // addRegionResponse -
    //        input json = { imageId: , negId: , assignedId:   }
    CREGIONS.addRegionResponse = function (json) {
        var negId = json.negId;
        var posId = json.assignedId;
        self.setNextRegionId(posId); // track the highest value region id

        for (var i = 0, len = rfRegions.length; i < len; i++) {
            if ((0, _helpers.isDefined)(rfRegions[i]) && rfRegions[i].regionId == negId) {
                rfRegions[i].regionId = posId;

                annotationsService.events.trigger('us:annotations:region-change', {
                    imageId: json.imageId,
                    regionId: posId,
                    anShape: rfRegions[i].isReportRegion ? 'report' : rfRegions[i].shape,
                    action: 'add'
                });
                return;
            }
        }
        // ('addRegionResponse:  imageId: ' + json.imageId + '  assigned id: ' + json.assignedId + ' not reconciled with temp id: ' + json.negId); // eslint-disable-line no-undef
    };
    //............................................ cRegions del
    //    delete a single region
    CREGIONS.del = function (rfId) {
        if (rfId < 0 || rfRegions[rfId] == undefined) return;

        var aRegion = rfRegions[rfId]; // temp ref to region
        self.remove(rfId); // remove region from rfRegions

        // if incremental save is enabled, automatically send the new region to the server, get the assigned region id back
        if (_uScope2.default.instance.canSaveAnnotations()) {
            annotationsService.save({ action: 'delRegion', layerId: aRegion.layerId, regionId: aRegion.regionId });
        }

        // broadcast the region deletion last, it is important that it no longer can be referenced in rfRegions
        annotationsService.events.trigger('us:annotations:region-change', {
            action: 'del',
            imageId: aRegion.imageId,
            regionId: aRegion.regionId,
            anShape: aRegion.isReportRegion ? 'report' : aRegion.shape
        });
    };
    //............................................ cRegions delByRegionId
    CREGIONS.delByRegionId = function (regionId) {
        var aRegion = self.getByRegionId(regionId);
        if (aRegion) self.del(aRegion.get(aRegion.get('rfId')));
    };
    //............................................ cRegions remove
    //    This function removes a single region from rfRegions and its graphics dependencies.
    //        It does not update the database
    CREGIONS.remove = function (rfId) {
        if (rfId < 0 || rfRegions[rfId] == undefined) return false;
        if (rfRegions[rfId].get('isTuningRegion') == true) {
            return;
        }

        var aRegion = rfRegions[rfId];
        aRegion.removeGraphics(); // removes the graphics handles

        rfRegions[rfId] = undefined; // remove this item from the regions array
        return true;
    };
    //............................................ delAllFromLayer
    //    delete all regions in the passed layerId
    CREGIONS_LAYER.delAllFromLayer = function (layerId) {
        for (var r = 0, len = rfRegions.length; r < len; r++) {
            if (rfRegions[r] && rfRegions[r].layerId == layerId) self.del(rfRegions[r].rfId);
        }
    };

    self.deleteAllRegions = function () {
        rfRegions.forEach(function (region) {
            return region && self.del(region.rfId);
        });
    };

    //............................................ getRegionsByLayerId
    // return an array of regions refs associated with the passed layerId
    CREGIONS_LAYER.getRegionsByLayerId = function (layerId) {
        var rtnArray = [];
        for (var r = 0, rlen = rfRegions.length; r < rlen; r++) {
            if (rfRegions[r] && rfRegions[r].get('layerId') == layerId) rtnArray.push(rfRegions[r]);
        }
        return rtnArray;
    };
    //............................................ cRegions findByProperty
    // This function returns an array of region objects whose property matches the passed value
    CREGIONS.findByProperty = function (propName, propValue) {
        var rtnArray = [];
        for (var r = 0, rlen = rfRegions.length; r < rlen; r++) {
            if (rfRegions[r] && rfRegions[r].get(propName) == propValue) rtnArray.push(rfRegions[r]);
        }
        return rtnArray;
    };
    //............................................ cRegions toString
    // This function returns a string of all regions or if opt_LayerId all regions related to the specified layerId
    CREGIONS_DEBUG.toString = function (opt_LayerId, opt_bDoShort) {
        var rtnStr = opt_LayerId ? 'Regions for LayerId: ' + opt_LayerId : '';
        for (var r = 0, len = rfRegions.length; r < len; r++) {
            if (rfRegions[r]) {
                if (opt_LayerId == undefined || rfRegions[r].get('layerId') == opt_LayerId) rtnStr += opt_bDoShort == true ? '\n' + rfRegions[r].toStringShort() : '\n' + rfRegions[r].toString();
            }
        }
        return rtnStr;
    };
    //............................................ getByProperty
    CREGIONS_GET.getByProperty = function (propName, propValue) {
        var i, len;
        for (i = 0; len = rfRegions.length, i < len; i++) {
            if (rfRegions[i] && rfRegions[i].get(propName) == propValue) return rfRegions[i];
        }
        return undefined;
    };
    //............................................ getByRegionId
    // return a ref to the region with passed regionId or undefined if not found
    CREGIONS_GET.getByRegionId = function (regionId) {
        var i;
        var len;
        for (i = 0; len = rfRegions.length, i < len; i++) {
            if (rfRegions[i] && rfRegions[i].get('regionId') == regionId) return rfRegions[i];
        }
        return undefined;
    };
    //............................................ getByRfId
    // return a ref to the region with passed rfId or undefined if not found
    CREGIONS_GET.getByRfId = function (rfId) {
        return rfRegions[rfId];
    };
}
module.exports = exports['default'];

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createBaseLayer;

var _helpers = __webpack_require__(4);

function createBaseLayer(model) {
    var self = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    self.isSelected = function () {
        return model.Selected;
    };

    self.get = function (key) {
        return model[key];
    };
    self.set = function (key, value) {
        model[key] = value;
    };

    /**
     * Generates a layer ('Annotation') XML node;
     * @returns {string}
     */
    self.buildXML = function () {
        return '<Annotation ' + ('Id="' + model.Id + '" ') + ('Name="' + model.Name + '" ') + ('Type="' + model.Type + '" ') + ('Selected="' + (model.Selected ? 1 : 0) + '" ') + ('Incremental="' + (model.Incremental ? 1 : 0) + '" ') + ('LineColor="' + model.LineColor + '" ') + ( // note that layer color is saved BGR
        'Visible="' + (model.Visible ? 1 : 0) + '" ') + (

        // Funny story - without the extra parans this returns a bunch of undefined, and any save requests fail -- silently! TODO: Fix save logic.
        model.MacroName ? 'InputAnnotationId="' + model.InputAnnotationId + '" MacroName="' + model.MacroName + '"  MacroId="' + model.MacroId + '" ' : '') + 'ReadOnly="0" NameReadOnly="0" LineColorReadOnly="0"></Annotation>';
    };

    /* DEBUG CODE ONLY - TODO: REMOVE */
    self.toString = function (bReportResults) {
        var str = (0, _helpers.toStringAssoc)(model);
        if (bReportResults && (0, _helpers.assocArrayLength)(model.attributes)) {
            str += '\n              ..... Layer Results (' + (0, _helpers.assocArrayLength)(model.attributes) + '):  ' + (0, _helpers.toStringAssoc)(model.attributes);
        }
        return str;
    };

    self.toStringShort = function () {
        return 'Name: ' + model.Name + ' Id: ' + model.Id + ' typeName: ' + model.typeName + (model.InputAnnotationId ? ' InputAnnotationId: ' + model.InputAnnotationId + ' MacroName: ' + model.MacroName : '');
    };

    return self;
}
module.exports = exports['default'];

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(51), __esModule: true };

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106);
__webpack_require__(76);
__webpack_require__(77);
__webpack_require__(62);
module.exports = __webpack_require__(12).Promise;

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(19)
  , call        = __webpack_require__(56)
  , isArrayIter = __webpack_require__(55)
  , anObject    = __webpack_require__(13)
  , toLength    = __webpack_require__(104)
  , getIterFn   = __webpack_require__(105)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(47)
  , ITERATOR   = __webpack_require__(3)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(13);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(3)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(7)
  , macrotask = __webpack_require__(25).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(28)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(35);
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(7)
  , core        = __webpack_require__(12)
  , dP          = __webpack_require__(33)
  , DESCRIPTORS = __webpack_require__(32)
  , SPECIES     = __webpack_require__(3)('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(13)
  , aFunction = __webpack_require__(34)
  , SPECIES   = __webpack_require__(3)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(327);


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY            = __webpack_require__(74)
  , global             = __webpack_require__(7)
  , ctx                = __webpack_require__(19)
  , classof            = __webpack_require__(82)
  , $export            = __webpack_require__(45)
  , isObject           = __webpack_require__(46)
  , aFunction          = __webpack_require__(34)
  , anInstance         = __webpack_require__(52)
  , forOf              = __webpack_require__(53)
  , speciesConstructor = __webpack_require__(61)
  , task               = __webpack_require__(25).set
  , microtask          = __webpack_require__(58)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__(3)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(59)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__(75)($Promise, PROMISE);
__webpack_require__(60)(PROMISE);
Wrapper = __webpack_require__(12)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(57)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(72);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof process === "object" && process.domain) {
      invoke = process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(18)))

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(50);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ })

},[611]);